var _style, _defs, _g, _polygon, _g2, _polygon2, _g3, _polygon3, _g4, _polygon4, _g5, _polygon5, _g6, _polygon6, _g7, _polygon7, _g8, _polygon8, _g9, _polygon9, _g10, _polygon10, _g11, _polygon11, _g12, _polygon12, _g13, _polygon13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLines10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270.19 175.14",
    style: {
      enableBackground: "new 0 0 270.19 175.14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;opacity:0.19;}\n\t.st2{opacity:0.19;}\n\t.st3{clip-path:url(#SVGID_00000112621193099373066360000016760337649283814790_);}\n\t.st4{fill:url(#SVGID_00000051346162951682077880000016777770704141209996_);}\n\t.st5{fill:url(#SVGID_00000182502961243233668820000014882187333354370216_);}\n\t.st6{fill:url(#SVGID_00000053534050949386270620000014595172006490810296_);}\n\t.st7{fill:url(#SVGID_00000116944733375712281960000016225080010659467392_);}\n\t.st8{fill:url(#SVGID_00000183935251343831617640000005052472603672522645_);}\n\t.st9{fill:url(#SVGID_00000165235623350155380170000013150145800059044229_);}\n\t.st10{fill:url(#SVGID_00000089537074100232768600000001393179311897673646_);}\n\t.st11{fill:url(#SVGID_00000008144061925704567010000012680395815379966634_);}\n\t.st12{fill:url(#SVGID_00000165913388854426307850000004709177052141177999_);}\n\t.st13{fill:url(#SVGID_00000012431050350155672750000013618463657995909302_);}\n\t.st14{fill:url(#SVGID_00000123442402166427988100000004399366598856299454_);}\n\t.st15{fill:url(#SVGID_00000085214514599261208090000000495286684519746956_);}\n\t.st16{fill:url(#SVGID_00000026155825585823262730000009764847024547182772_);}\n\t.st17{fill:url(#SVGID_00000050649120250655198370000015756611984315517098_);}\n\t.st18{fill:url(#SVGID_00000003082031100039103470000012020197524646524339_);}\n\t.st19{fill:url(#SVGID_00000114788790227004662860000012642234162367142530_);}\n\t.st20{fill:url(#SVGID_00000003065704217074555180000006947423799490621112_);}\n\t.st21{fill:url(#SVGID_00000149382357324358152140000014505954660056424098_);}\n\t.st22{fill:url(#SVGID_00000130628985008520333350000012317939522209089188_);}\n\t.st23{fill:url(#SVGID_00000073001710140499938420000005690078290612326572_);}\n\t.st24{fill:url(#SVGID_00000072997302335671548630000014141605356084730266_);}\n\t.st25{fill:url(#SVGID_00000182507624407056047660000010820793580037042099_);}\n\t.st26{fill:url(#SVGID_00000122703061427756692690000003861594348068778661_);}\n\t.st27{fill:url(#SVGID_00000076566410017977420520000001661328501884320644_);}\n\t.st28{fill:url(#SVGID_00000142164129809585376100000013967083300012785034_);}\n\t.st29{fill:url(#SVGID_00000018238066867328269960000002576042973088667296_);}\n\t.st30{fill:url(#SVGID_00000107575964096434058060000000337657155186224827_);}\n\t.st31{fill:url(#SVGID_00000142882972902771320740000017143847859497280154_);}\n\t.st32{fill:url(#SVGID_00000118388182773859772610000017897664098893841833_);}\n\t.st33{opacity:0;fill:#FFFFFF;}\n\t.st34{opacity:9.900990e-03;fill:#FEFEFE;}\n\t.st35{opacity:0.0198;fill:#FDFDFD;}\n\t.st36{opacity:0.0297;fill:#FDFDFD;}\n\t.st37{opacity:0.0396;fill:#FCFCFC;}\n\t.st38{opacity:0.0495;fill:#FBFBFB;}\n\t.st39{opacity:0.0594;fill:#FAFAFA;}\n\t.st40{opacity:0.0693;fill:#FAFAFA;}\n\t.st41{opacity:0.0792;fill:#F9F9F9;}\n\t.st42{opacity:0.0891;fill:#F8F8F8;}\n\t.st43{opacity:0.099;fill:#F7F7F7;}\n\t.st44{opacity:0.1089;fill:#F7F7F7;}\n\t.st45{opacity:0.1188;fill:#F6F6F6;}\n\t.st46{opacity:0.1287;fill:#F5F5F5;}\n\t.st47{opacity:0.1386;fill:#F4F4F4;}\n\t.st48{opacity:0.1485;fill:#F4F4F4;}\n\t.st49{opacity:0.1584;fill:#F3F3F3;}\n\t.st50{opacity:0.1683;fill:#F2F2F2;}\n\t.st51{opacity:0.1782;fill:#F1F1F1;}\n\t.st52{opacity:0.1881;fill:#F1F1F1;}\n\t.st53{opacity:0.198;fill:#F0F0F0;}\n\t.st54{opacity:0.2079;fill:#EFEFEF;}\n\t.st55{opacity:0.2178;fill:#EEEEEE;}\n\t.st56{opacity:0.2277;fill:#EEEEEE;}\n\t.st57{opacity:0.2376;fill:#EDEDED;}\n\t.st58{opacity:0.2475;fill:#ECECEC;}\n\t.st59{opacity:0.2574;fill:#EBEBEB;}\n\t.st60{opacity:0.2673;fill:#EBEBEB;}\n\t.st61{opacity:0.2772;fill:#EAEAEA;}\n\t.st62{opacity:0.2871;fill:#E9E9E9;}\n\t.st63{opacity:0.297;fill:#E8E8E8;}\n\t.st64{opacity:0.3069;fill:#E8E8E8;}\n\t.st65{opacity:0.3168;fill:#E7E7E7;}\n\t.st66{opacity:0.3267;fill:#E6E6E6;}\n\t.st67{opacity:0.3366;fill:#E5E5E5;}\n\t.st68{opacity:0.3465;fill:#E5E5E5;}\n\t.st69{opacity:0.3564;fill:#E4E4E4;}\n\t.st70{opacity:0.3663;fill:#E3E3E3;}\n\t.st71{opacity:0.3762;fill:#E2E2E2;}\n\t.st72{opacity:0.3861;fill:#E2E2E2;}\n\t.st73{opacity:0.396;fill:#E1E1E1;}\n\t.st74{opacity:0.4059;fill:#E0E0E0;}\n\t.st75{opacity:0.4158;fill:#DFDFDF;}\n\t.st76{opacity:0.4257;fill:#DFDFDF;}\n\t.st77{opacity:0.4356;fill:#DEDEDE;}\n\t.st78{opacity:0.4455;fill:#DDDDDD;}\n\t.st79{opacity:0.4554;fill:#DCDCDC;}\n\t.st80{opacity:0.4653;fill:#DCDCDC;}\n\t.st81{opacity:0.4752;fill:#DBDBDB;}\n\t.st82{opacity:0.4851;fill:#DADADA;}\n\t.st83{opacity:0.495;fill:#D9D9D9;}\n\t.st84{opacity:0.505;fill:#D9D9D9;}\n\t.st85{opacity:0.5149;fill:#D8D8D8;}\n\t.st86{opacity:0.5248;fill:#D7D7D7;}\n\t.st87{opacity:0.5347;fill:#D6D6D6;}\n\t.st88{opacity:0.5446;fill:#D6D6D6;}\n\t.st89{opacity:0.5545;fill:#D5D5D5;}\n\t.st90{opacity:0.5644;fill:#D4D4D4;}\n\t.st91{opacity:0.5743;fill:#D3D3D3;}\n\t.st92{opacity:0.5842;fill:#D3D3D3;}\n\t.st93{opacity:0.5941;fill:#D2D2D2;}\n\t.st94{opacity:0.604;fill:#D1D1D1;}\n\t.st95{opacity:0.6139;fill:#D0D0D0;}\n\t.st96{opacity:0.6238;fill:#D0D0D0;}\n\t.st97{opacity:0.6337;fill:#CFCFCF;}\n\t.st98{opacity:0.6436;fill:#CECECE;}\n\t.st99{opacity:0.6535;fill:#CDCDCD;}\n\t.st100{opacity:0.6634;fill:#CDCDCD;}\n\t.st101{opacity:0.6733;fill:#CCCCCC;}\n\t.st102{opacity:0.6832;fill:#CBCBCB;}\n\t.st103{opacity:0.6931;fill:#CACACA;}\n\t.st104{opacity:0.703;fill:#CACACA;}\n\t.st105{opacity:0.7129;fill:#C9C9C9;}\n\t.st106{opacity:0.7228;fill:#C8C8C8;}\n\t.st107{opacity:0.7327;fill:#C7C7C7;}\n\t.st108{opacity:0.7426;fill:#C7C7C7;}\n\t.st109{opacity:0.7525;fill:#C6C6C6;}\n\t.st110{opacity:0.7624;fill:#C5C5C5;}\n\t.st111{opacity:0.7723;fill:#C4C4C4;}\n\t.st112{opacity:0.7822;fill:#C4C4C4;}\n\t.st113{opacity:0.7921;fill:#C3C3C3;}\n\t.st114{opacity:0.802;fill:#C2C2C2;}\n\t.st115{opacity:0.8119;fill:#C1C1C1;}\n\t.st116{opacity:0.8218;fill:#C1C1C1;}\n\t.st117{opacity:0.8317;fill:#C0C0C0;}\n\t.st118{opacity:0.8416;fill:#BFBFBF;}\n\t.st119{opacity:0.8515;fill:#BEBEBE;}\n\t.st120{opacity:0.8614;fill:#BEBEBE;}\n\t.st121{opacity:0.8713;fill:#BDBDBD;}\n\t.st122{opacity:0.8812;fill:#BCBCBC;}\n\t.st123{opacity:0.8911;fill:#BBBBBB;}\n\t.st124{opacity:0.901;fill:#BBBBBB;}\n\t.st125{opacity:0.9109;fill:#BABABA;}\n\t.st126{opacity:0.9208;fill:#B9B9B9;}\n\t.st127{opacity:0.9307;fill:#B8B8B8;}\n\t.st128{opacity:0.9406;fill:#B8B8B8;}\n\t.st129{opacity:0.9505;fill:#B7B7B7;}\n\t.st130{opacity:0.9604;fill:#B6B6B6;}\n\t.st131{opacity:0.9703;fill:#B5B5B5;}\n\t.st132{opacity:0.9802;fill:#B5B5B5;}\n\t.st133{opacity:0.9901;fill:#B4B4B4;}\n\t.st134{fill:#B3B3B3;}\n\t.st135{fill:url(#SVGID_00000057831333396888937980000000255637319390609555_);}\n\t.st136{opacity:0.7;fill:#FFFFFF;}\n\t.st137{fill:url(#SVGID_00000016781699853935363370000016345533091946244758_);}\n\t.st138{fill:url(#SVGID_00000084512083629125225880000009506757899499087502_);}\n\t.st139{fill:url(#SVGID_00000004544819159784360310000008207636298200446622_);}\n\t.st140{fill:url(#SVGID_00000172435413102102924080000006116925377800131226_);}\n\t.st141{fill:url(#SVGID_00000055686689757490162540000002204855094829929863_);}\n\t.st142{fill:url(#SVGID_00000139264556416879516530000007073243360768062866_);}\n\t.st143{fill:url(#SVGID_00000017474566114155244410000016594232170567577279_);}\n\t.st144{fill:url(#SVGID_00000182513598853620785790000012884363069051369393_);}\n\t.st145{fill:url(#SVGID_00000049187644021454841910000002717348252078937270_);}\n\t.st146{fill:url(#SVGID_00000047056499575440812230000007658972077007333265_);}\n\t.st147{fill:url(#SVGID_00000140702017714194758080000015229416867637163658_);}\n\t.st148{fill:url(#SVGID_00000003100056429707828070000008095310357900902322_);}\n\t.st149{fill:url(#SVGID_00000000922730853854619460000015504405804967844027_);}\n\t.st150{fill:url(#SVGID_00000025405452182330063530000009943675380371519641_);}\n\t.st151{fill:url(#SVGID_00000021823000542664170610000007044305745935597978_);}\n\t.st152{fill:url(#SVGID_00000009561462075297299740000017457651702939297409_);}\n\t.st153{fill:url(#SVGID_00000016075065573447183930000015254593442384392110_);}\n\t.st154{fill:url(#SVGID_00000121975336743120743760000005772819974529697983_);}\n\t.st155{fill:url(#SVGID_00000106858091734283536010000008323417725504867992_);}\n\t.st156{fill:url(#SVGID_00000159452072028684355270000015376978849190889136_);}\n\t.st157{fill:url(#SVGID_00000010286137509205761520000000688893483138413206_);}\n\t.st158{fill:url(#SVGID_00000095325500053299197760000008888561512002634632_);}\n\t.st159{fill:url(#SVGID_00000033365297331208151290000015805952104101379505_);}\n\t.st160{fill:url(#SVGID_00000031891067180656955880000006212849955939217590_);}\n\t.st161{fill:url(#SVGID_00000164510290614671733930000008540955938405915318_);}\n\t.st162{fill:url(#SVGID_00000020364784456976097120000008018850566849968528_);}\n\t.st163{fill:url(#SVGID_00000113336322294013449860000015420281552246581130_);}\n\t.st164{fill:url(#SVGID_00000117664149220144004080000017179403879535513528_);}\n\t.st165{fill:url(#SVGID_00000039845755507805924520000004549782887453764744_);}\n\t.st166{fill:url(#SVGID_00000131352346549698490400000015527636909493881528_);}\n\t.st167{fill:url(#SVGID_00000166641238697882012790000017760538035192795326_);}\n\t.st168{fill:url(#SVGID_00000044170461268307201910000008713094177441472143_);}\n\t.st169{fill:url(#SVGID_00000172417636894260279220000004405817391489545889_);}\n\t.st170{fill:url(#SVGID_00000059303940474372988360000009903949233744098444_);}\n\t.st171{fill:url(#SVGID_00000121982922154073948700000003455132740883278248_);}\n\t.st172{fill:url(#SVGID_00000145761674438982258870000016255028599156576386_);}\n\t.st173{fill:url(#SVGID_00000044162531084129477680000013280339529733666447_);}\n\t.st174{fill:url(#SVGID_00000087390835073950676210000015898306407326165923_);}\n\t.st175{fill:url(#SVGID_00000130621249655837617160000016630134110598604464_);}\n\t.st176{fill:url(#SVGID_00000109730401034756852140000013921164109922593153_);}\n\t.st177{fill:url(#SVGID_00000035506738403176810560000002190770551049157307_);}\n\t.st178{fill:url(#SVGID_00000049942403707711457760000002927228737858668479_);}\n\t.st179{fill:url(#SVGID_00000012459378901405101660000009725210098772852633_);}\n\t.st180{opacity:0.8;fill:url(#SVGID_00000066486878293856377450000004367339549749187519_);}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 47.52,
    y: -47.52,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 47.5243 222.6651)",
    className: "st2",
    width: 175.14,
    height: 270.19
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067927734551248395370000004608870699012716188_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000067927734551248395370000004608870699012716188_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130614639138639640040000005862142954715854523_",
    gradientUnits: "userSpaceOnUse",
    x1: 1613.7795,
    y1: 355.5111,
    x2: 1629.5399,
    y2: 371.2715,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000130614639138639640040000005862142954715854523_)"
    },
    points: "97.34,29.51 97.34,17.98  107.34,12.21 117.33,17.98 117.33,29.51 107.34,35.28  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049922628092913829590000003867656246192221598_",
    gradientUnits: "userSpaceOnUse",
    x1: 1613.7795,
    y1: 376.9548,
    x2: 1629.5399,
    y2: 392.7152,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000049922628092913829590000003867656246192221598_)"
    },
    points: "118.79,29.51 118.79,17.98  128.78,12.21 138.77,17.98 138.77,29.51 128.78,35.28  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098194823288179148660000012824374238828161691_",
    gradientUnits: "userSpaceOnUse",
    x1: 1631.6141,
    y1: 344.6592,
    x2: 1647.3745,
    y2: 360.4195,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000098194823288179148660000012824374238828161691_)"
    },
    points: "86.49,47.35 86.49,35.81  96.48,30.04 106.48,35.81 106.48,47.35 96.48,53.12  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056397959921663731970000006944687675785638530_",
    gradientUnits: "userSpaceOnUse",
    x1: 1613.7795,
    y1: 269.8862,
    x2: 1629.5399,
    y2: 285.6466,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000056397959921663731970000006944687675785638530_)"
    },
    points: "11.72,29.51 11.72,17.98  21.71,12.21 31.7,17.98 31.7,29.51 21.71,35.28  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147202156167705296500000008311086100527702912_",
    gradientUnits: "userSpaceOnUse",
    x1: 1613.7795,
    y1: 248.1756,
    x2: 1629.5399,
    y2: 263.936,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000147202156167705296500000008311086100527702912_)"
    },
    points: "-9.99,29.51 -9.99,17.98  0,12.21 9.99,17.98 9.99,29.51 0,35.28  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102507266046298104070000004908160725637793705_",
    gradientUnits: "userSpaceOnUse",
    x1: 1595.7133,
    y1: 302.2368,
    x2: 1611.4738,
    y2: 317.9972,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000102507266046298104070000004908160725637793705_)"
    },
    points: "44.07,11.45 44.07,-0.09  54.06,-5.86 64.05,-0.09 64.05,11.45 54.06,17.22  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087398423408795326670000014522811983516684431_",
    gradientUnits: "userSpaceOnUse",
    x1: 1595.7134,
    y1: 280.6698,
    x2: 1611.4736,
    y2: 296.4301,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000087398423408795326670000014522811983516684431_)"
    },
    points: "22.5,11.45 22.5,-0.09  32.49,-5.86 42.49,-0.09 42.49,11.45 32.49,17.22  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086670304357482337190000011537825517717202323_",
    gradientUnits: "userSpaceOnUse",
    x1: 1595.7134,
    y1: 344.6592,
    x2: 1611.4736,
    y2: 360.4195,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000086670304357482337190000011537825517717202323_)"
    },
    points: "86.49,11.45 86.49,-0.09  96.48,-5.86 106.48,-0.09 106.48,11.45 96.48,17.22  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011019584002760868030000007197350963892721540_",
    gradientUnits: "userSpaceOnUse",
    x1: 1595.7133,
    y1: 366.2462,
    x2: 1611.4738,
    y2: 382.0066,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000011019584002760868030000007197350963892721540_)"
    },
    points: "108.08,11.45 108.08,-0.09  118.07,-5.86 128.06,-0.09 128.06,11.45 118.07,17.22  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088111619163728329840000007936634482533724059_",
    gradientUnits: "userSpaceOnUse",
    x1: 1595.7133,
    y1: 387.7536,
    x2: 1611.4738,
    y2: 403.514,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000088111619163728329840000007936634482533724059_)"
    },
    points: "129.59,11.45 129.59,-0.09  139.58,-5.86 149.57,-0.09 149.57,11.45 139.58,17.22  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178169635698655415280000013458793054583586446_",
    gradientUnits: "userSpaceOnUse",
    x1: 1595.7133,
    y1: 323.0921,
    x2: 1611.4738,
    y2: 338.8525,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000178169635698655415280000013458793054583586446_)"
    },
    points: "64.92,11.45 64.92,-0.09  74.92,-5.86 84.91,-0.09 84.91,11.45 74.92,17.22  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086668929374835697420000006901194309259692956_",
    gradientUnits: "userSpaceOnUse",
    x1: 1703.9158,
    y1: 258.7319,
    x2: 1719.676,
    y2: 274.4922,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000086668929374835697420000006901194309259692956_)"
    },
    points: "0.56,119.65 0.56,108.11  10.56,102.34 20.55,108.11 20.55,119.65 10.56,125.42  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003088248633598857130000014212353856842400180_",
    gradientUnits: "userSpaceOnUse",
    x1: 1667.9874,
    y1: 258.7887,
    x2: 1683.7478,
    y2: 274.549,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000003088248633598857130000014212353856842400180_)"
    },
    points: "0.62,83.72 0.62,72.19  10.61,66.42 20.6,72.19 20.6,83.72 10.61,89.49  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156584287152898842200000016566929120727670967_",
    gradientUnits: "userSpaceOnUse",
    x1: 1631.6141,
    y1: 323.1489,
    x2: 1647.3745,
    y2: 338.9093,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000156584287152898842200000016566929120727670967_)"
    },
    points: "64.98,47.35 64.98,35.81  74.97,30.04 84.97,35.81 84.97,47.35 74.97,53.12  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100350375979269688060000016039969674778924949_",
    gradientUnits: "userSpaceOnUse",
    x1: 1649.947,
    y1: 312.4222,
    x2: 1665.7075,
    y2: 328.1826,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000100350375979269688060000016039969674778924949_)"
    },
    points: "54.25,65.68 54.25,54.14  64.25,48.38 74.24,54.14 74.24,65.68 64.25,71.45  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163768088597987428990000010325600582907334275_",
    gradientUnits: "userSpaceOnUse",
    x1: 1686.0795,
    y1: 290.9688,
    x2: 1701.8398,
    y2: 306.7292,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000163768088597987428990000010325600582907334275_)"
    },
    points: "32.8,101.81 32.8,90.28  42.79,84.51 52.78,90.28 52.78,101.81 42.79,107.58  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047055548775607400440000009880777096644612500_",
    gradientUnits: "userSpaceOnUse",
    x1: 1740.6217,
    y1: 258.7319,
    x2: 1756.3821,
    y2: 274.4922,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000047055548775607400440000009880777096644612500_)"
    },
    points: "0.56,156.36 0.56,144.82  10.56,139.05 20.55,144.82 20.55,156.36 10.56,162.13  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078734702807693266580000003907506481734857869_",
    gradientUnits: "userSpaceOnUse",
    x1: 1740.6217,
    y1: 390.4708,
    x2: 1756.3821,
    y2: 406.2311,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000078734702807693266580000003907506481734857869_)"
    },
    points: "132.3,156.36 132.3,144.82  142.3,139.05 152.29,144.82 152.29,156.36 142.3,162.13  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026843695654305481680000002766573943852098231_",
    gradientUnits: "userSpaceOnUse",
    x1: 1686.0795,
    y1: 269.5722,
    x2: 1701.8398,
    y2: 285.3326,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000026843695654305481680000002766573943852098231_)"
    },
    points: "11.4,101.81 11.4,90.28  21.4,84.51 31.39,90.28 31.39,101.81 21.4,107.58  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008146391273783981650000009840374890496542596_",
    gradientUnits: "userSpaceOnUse",
    x1: 1722.212,
    y1: 269.5722,
    x2: 1737.9724,
    y2: 285.3326,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000008146391273783981650000009840374890496542596_)"
    },
    points: "11.4,137.95 11.4,126.41  21.4,120.64 31.39,126.41 31.39,137.95 21.4,143.72  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179645216625196861430000009603399639479042446_",
    gradientUnits: "userSpaceOnUse",
    x1: 1759.4915,
    y1: 290.9688,
    x2: 1775.252,
    y2: 306.7292,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000179645216625196861430000009603399639479042446_)"
    },
    points: "32.8,175.23 32.8,163.69  42.79,157.92 52.78,163.69 52.78,175.23 42.79,181  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178164112926225522500000015295814417277956527_",
    gradientUnits: "userSpaceOnUse",
    x1: 1759.4916,
    y1: 357.1747,
    x2: 1775.2518,
    y2: 372.935,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000178164112926225522500000015295814417277956527_)"
    },
    points: "99.01,175.23 99.01,163.69  109,157.92 118.99,163.69 118.99,175.23 109,181  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060712231316771021990000009774719800026838692_",
    gradientUnits: "userSpaceOnUse",
    x1: 1759.4915,
    y1: 379.4515,
    x2: 1775.252,
    y2: 395.2119,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000060712231316771021990000009774719800026838692_)"
    },
    points: "121.28,175.23 121.28,163.69  131.28,157.92 141.27,163.69 141.27,175.23 131.28,181  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111182515196155554070000004441576959980614832_",
    gradientUnits: "userSpaceOnUse",
    x1: 1759.4915,
    y1: 401.416,
    x2: 1775.252,
    y2: 417.1764,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000111182515196155554070000004441576959980614832_)"
    },
    points: "143.25,175.23 143.25,163.69  153.24,157.92 163.23,163.69 163.23,175.23 153.24,181  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183933286200865698630000015885331956370507453_",
    gradientUnits: "userSpaceOnUse",
    x1: 1759.4915,
    y1: 269.5722,
    x2: 1775.252,
    y2: 285.3326,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000183933286200865698630000015885331956370507453_)"
    },
    points: "11.4,175.23 11.4,163.69  21.4,157.92 31.39,163.69 31.39,175.23 21.4,181  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134944355982458764960000015938193301475311003_",
    gradientUnits: "userSpaceOnUse",
    x1: 1686.0795,
    y1: 248.1756,
    x2: 1701.8398,
    y2: 263.936,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000134944355982458764960000015938193301475311003_)"
    },
    points: "-9.99,101.81 -9.99,90.28  0,84.51 9.99,90.28 9.99,101.81 0,107.58  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110440497793401457720000016848918384279500718_",
    gradientUnits: "userSpaceOnUse",
    x1: 1722.212,
    y1: 248.1756,
    x2: 1737.9724,
    y2: 263.936,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000110440497793401457720000016848918384279500718_)"
    },
    points: "-9.99,137.95 -9.99,126.41  0,120.64 9.99,126.41 9.99,137.95 0,143.72  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059994860759704527330000011655315755962515632_",
    gradientUnits: "userSpaceOnUse",
    x1: 1759.4915,
    y1: 248.1756,
    x2: 1775.252,
    y2: 263.936,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000059994860759704527330000011655315755962515632_)"
    },
    points: "-9.99,175.23 -9.99,163.69  0,157.92 9.99,163.69 9.99,175.23 0,181  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118393755416665306550000003021649267745665170_",
    gradientUnits: "userSpaceOnUse",
    x1: 1649.947,
    y1: 248.1756,
    x2: 1665.7075,
    y2: 263.936,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000118393755416665306550000003021649267745665170_)"
    },
    points: "-9.99,65.68 -9.99,54.14  0,48.38 9.99,54.14 9.99,65.68 0,71.45  "
  }), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "25.4,50.59 25.4,39.05 35.39,33.28 45.38,39.05 45.38,50.59 35.39,56.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "25.36,50.56 25.36,39.02 35.36,33.25 45.35,39.02 45.35,50.56 35.36,56.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "25.33,50.52 25.33,38.99 35.32,33.22 45.32,38.99 45.32,50.52 35.32,56.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "25.3,50.49 25.3,38.95 35.29,33.19 45.28,38.95 45.28,50.49 35.29,56.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "25.27,50.46 25.27,38.92 35.26,33.15 45.25,38.92 45.25,50.46 35.26,56.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "25.24,50.43 25.24,38.89 35.23,33.12 45.22,38.89 45.22,50.43 35.23,56.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "25.2,50.4 25.2,38.86 35.2,33.09 45.19,38.86 45.19,50.4 35.2,56.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "25.17,50.36 25.17,38.83 35.16,33.06 45.16,38.83 45.16,50.36 35.16,56.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "25.14,50.33 25.14,38.79 35.13,33.02 45.12,38.79 45.12,50.33 35.13,56.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "25.11,50.3 25.11,38.76 35.1,32.99 45.09,38.76 45.09,50.3 35.1,56.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "25.08,50.27 25.08,38.73 35.07,32.96 45.06,38.73 45.06,50.27 35.07,56.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "25.04,50.23 25.04,38.7 35.04,32.93 45.03,38.7 45.03,50.23 35.04,56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "25.01,50.2 25.01,38.67 35,32.9 45,38.67 45,50.2 35,55.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "24.98,50.17 24.98,38.63 34.97,32.86 44.96,38.63 44.96,50.17 34.97,55.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "24.95,50.14 24.95,38.6 34.94,32.83 44.93,38.6 44.93,50.14 34.94,55.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "24.92,50.11 24.92,38.57 34.91,32.8 44.9,38.57 44.9,50.11 34.91,55.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "24.88,50.07 24.88,38.54 34.88,32.77 44.87,38.54 44.87,50.07 34.88,55.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "24.85,50.04 24.85,38.51 34.84,32.74 44.84,38.51 44.84,50.04 34.84,55.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "24.82,50.01 24.82,38.47 34.81,32.7 44.8,38.47 44.8,50.01 34.81,55.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "24.79,49.98 24.79,38.44 34.78,32.67 44.77,38.44 44.77,49.98 34.78,55.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "24.76,49.95 24.76,38.41 34.75,32.64 44.74,38.41 44.74,49.95 34.75,55.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "24.72,49.91 24.72,38.38 34.72,32.61 44.71,38.38 44.71,49.91 34.72,55.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "24.69,49.88 24.69,38.34 34.68,32.58 44.67,38.34 44.67,49.88 34.68,55.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "24.66,49.85 24.66,38.31 34.65,32.54 44.64,38.31 44.64,49.85 34.65,55.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "24.63,49.82 24.63,38.28 34.62,32.51 44.61,38.28 44.61,49.82 34.62,55.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "24.6,49.79 24.6,38.25 34.59,32.48 44.58,38.25 44.58,49.79 34.59,55.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "24.56,49.75 24.56,38.22 34.55,32.45 44.55,38.22 44.55,49.75 34.55,55.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "24.53,49.72 24.53,38.18 34.52,32.42 44.51,38.18 44.51,49.72 34.52,55.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "24.5,49.69 24.5,38.15 34.49,32.38 44.48,38.15 44.48,49.69 34.49,55.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "24.47,49.66 24.47,38.12 34.46,32.35 44.45,38.12 44.45,49.66 34.46,55.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "24.43,49.63 24.43,38.09 34.43,32.32 44.42,38.09 44.42,49.63 34.43,55.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "24.4,49.59 24.4,38.06 34.39,32.29 44.39,38.06 44.39,49.59 34.39,55.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "24.37,49.56 24.37,38.02 34.36,32.26 44.35,38.02 44.35,49.56 34.36,55.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "24.34,49.53 24.34,37.99 34.33,32.22 44.32,37.99 44.32,49.53 34.33,55.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "24.31,49.5 24.31,37.96 34.3,32.19 44.29,37.96 44.29,49.5 34.3,55.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "24.27,49.47 24.27,37.93 34.27,32.16 44.26,37.93 44.26,49.47 34.27,55.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "24.24,49.43 24.24,37.9 34.23,32.13 44.23,37.9 44.23,49.43 34.23,55.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "24.21,49.4 24.21,37.86 34.2,32.1 44.19,37.86 44.19,49.4 34.2,55.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "24.18,49.37 24.18,37.83 34.17,32.06 44.16,37.83 44.16,49.37 34.17,55.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "24.15,49.34 24.15,37.8 34.14,32.03 44.13,37.8 44.13,49.34 34.14,55.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "24.11,49.31 24.11,37.77 34.11,32 44.1,37.77 44.1,49.31 34.11,55.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "24.08,49.27 24.08,37.74 34.07,31.97 44.07,37.74 44.07,49.27 34.07,55.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "24.05,49.24 24.05,37.7 34.04,31.93 44.03,37.7 44.03,49.24 34.04,55.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "24.02,49.21 24.02,37.67 34.01,31.9 44,37.67 44,49.21 34.01,54.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "23.99,49.18 23.99,37.64 33.98,31.87 43.97,37.64 43.97,49.18 33.98,54.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "23.95,49.14 23.95,37.61 33.95,31.84 43.94,37.61 43.94,49.14 33.95,54.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "23.92,49.11 23.92,37.58 33.91,31.81 43.91,37.58 43.91,49.11 33.91,54.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "23.89,49.08 23.89,37.54 33.88,31.77 43.87,37.54 43.87,49.08 33.88,54.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "23.86,49.05 23.86,37.51 33.85,31.74 43.84,37.51 43.84,49.05 33.85,54.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "23.83,49.02 23.83,37.48 33.82,31.71 43.81,37.48 43.81,49.02 33.82,54.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "23.79,48.98 23.79,37.45 33.79,31.68 43.78,37.45 43.78,48.98 33.79,54.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "23.76,48.95 23.76,37.41 33.75,31.65 43.75,37.41 43.75,48.95 33.75,54.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "23.73,48.92 23.73,37.38 33.72,31.61 43.71,37.38 43.71,48.92 33.72,54.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "23.7,48.89 23.7,37.35 33.69,31.58 43.68,37.35 43.68,48.89 33.69,54.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "23.67,48.86 23.67,37.32 33.66,31.55 43.65,37.32 43.65,48.86 33.66,54.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "23.63,48.82 23.63,37.29 33.63,31.52 43.62,37.29 43.62,48.82 33.63,54.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "23.6,48.79 23.6,37.25 33.59,31.49 43.58,37.25 43.58,48.79 33.59,54.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "23.57,48.76 23.57,37.22 33.56,31.45 43.55,37.22 43.55,48.76 33.56,54.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "23.54,48.73 23.54,37.19 33.53,31.42 43.52,37.19 43.52,48.73 33.53,54.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "23.51,48.7 23.51,37.16 33.5,31.39 43.49,37.16 43.49,48.7 33.5,54.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "23.47,48.66 23.47,37.13 33.46,31.36 43.46,37.13 43.46,48.66 33.46,54.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "23.44,48.63 23.44,37.09 33.43,31.33 43.42,37.09 43.42,48.63 33.43,54.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "23.41,48.6 23.41,37.06 33.4,31.29 43.39,37.06 43.39,48.6 33.4,54.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "23.38,48.57 23.38,37.03 33.37,31.26 43.36,37.03 43.36,48.57 33.37,54.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "23.34,48.54 23.34,37 33.34,31.23 43.33,37 43.33,48.54 33.34,54.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "23.31,48.5 23.31,36.97 33.3,31.2 43.3,36.97 43.3,48.5 33.3,54.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "23.28,48.47 23.28,36.93 33.27,31.17 43.26,36.93 43.26,48.47 33.27,54.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "23.25,48.44 23.25,36.9 33.24,31.13 43.23,36.9 43.23,48.44 33.24,54.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "23.22,48.41 23.22,36.87 33.21,31.1 43.2,36.87 43.2,48.41 33.21,54.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "23.18,48.38 23.18,36.84 33.18,31.07 43.17,36.84 43.17,48.38 33.18,54.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "23.15,48.34 23.15,36.81 33.14,31.04 43.14,36.81 43.14,48.34 33.14,54.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "23.12,48.31 23.12,36.77 33.11,31 43.1,36.77 43.1,48.31 33.11,54.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "23.09,48.28 23.09,36.74 33.08,30.97 43.07,36.74 43.07,48.28 33.08,54.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "23.06,48.25 23.06,36.71 33.05,30.94 43.04,36.71 43.04,48.25 33.05,54.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "23.02,48.21 23.02,36.68 33.02,30.91 43.01,36.68 43.01,48.21 33.02,53.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "22.99,48.18 22.99,36.65 32.98,30.88 42.98,36.65 42.98,48.18 32.98,53.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "22.96,48.15 22.96,36.61 32.95,30.84 42.94,36.61 42.94,48.15 32.95,53.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "22.93,48.12 22.93,36.58 32.92,30.81 42.91,36.58 42.91,48.12 32.92,53.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "22.9,48.09 22.9,36.55 32.89,30.78 42.88,36.55 42.88,48.09 32.89,53.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "22.86,48.05 22.86,36.52 32.86,30.75 42.85,36.52 42.85,48.05 32.86,53.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "22.83,48.02 22.83,36.49 32.82,30.72 42.82,36.49 42.82,48.02 32.82,53.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "22.8,47.99 22.8,36.45 32.79,30.68 42.78,36.45 42.78,47.99 32.79,53.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "22.77,47.96 22.77,36.42 32.76,30.65 42.75,36.42 42.75,47.96 32.76,53.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "22.74,47.93 22.74,36.39 32.73,30.62 42.72,36.39 42.72,47.93 32.73,53.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "22.7,47.89 22.7,36.36 32.7,30.59 42.69,36.36 42.69,47.89 32.7,53.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "22.67,47.86 22.67,36.32 32.66,30.56 42.65,36.32 42.65,47.86 32.66,53.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "22.64,47.83 22.64,36.29 32.63,30.52 42.62,36.29 42.62,47.83 32.63,53.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "22.61,47.8 22.61,36.26 32.6,30.49 42.59,36.26 42.59,47.8 32.6,53.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "22.58,47.77 22.58,36.23 32.57,30.46 42.56,36.23 42.56,47.77 32.57,53.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "22.54,47.73 22.54,36.2 32.53,30.43 42.53,36.2 42.53,47.73 32.53,53.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "22.51,47.7 22.51,36.16 32.5,30.4 42.49,36.16 42.49,47.7 32.5,53.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "22.48,47.67 22.48,36.13 32.47,30.36 42.46,36.13 42.46,47.67 32.47,53.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "22.45,47.64 22.45,36.1 32.44,30.33 42.43,36.1 42.43,47.64 32.44,53.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "22.42,47.61 22.42,36.07 32.41,30.3 42.4,36.07 42.4,47.61 32.41,53.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "22.38,47.57 22.38,36.04 32.37,30.27 42.37,36.04 42.37,47.57 32.37,53.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "22.35,47.54 22.35,36 32.34,30.24 42.33,36 42.33,47.54 32.34,53.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "22.32,47.51 22.32,35.97 32.31,30.2 42.3,35.97 42.3,47.51 32.31,53.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "22.29,47.48 22.29,35.94 32.28,30.17 42.27,35.94 42.27,47.48 32.28,53.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "22.25,47.45 22.25,35.91 32.25,30.14 42.24,35.91 42.24,47.45 32.25,53.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "22.22,47.41 22.22,35.88 32.21,30.11 42.21,35.88 42.21,47.41 32.21,53.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "22.19,47.38 22.19,35.84 32.18,30.08 42.17,35.84 42.17,47.38 32.18,53.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "22.16,47.35 22.16,35.81 32.15,30.04 42.14,35.81 42.14,47.35 32.15,53.12  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014630691657004233220000012209712344297362328_",
    gradientUnits: "userSpaceOnUse",
    x1: 1631.6141,
    y1: 280.3258,
    x2: 1647.3745,
    y2: 296.0862,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000014630691657004233220000012209712344297362328_)"
    },
    points: "22.16,47.35 22.16,35.81  32.15,30.04 42.14,35.81 42.14,47.35 32.15,53.12  "
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "22.36,36.09 22.36,47.47 22.16,47.35 22.16,35.81 32.15,30.04 32.49,30.24  "
  }))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "46.77,50.59 46.77,39.05 56.76,33.28 66.75,39.05 66.75,50.59 56.76,56.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "46.73,50.56 46.73,39.02 56.73,33.25 66.72,39.02 66.72,50.56 56.73,56.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "46.7,50.52 46.7,38.99 56.69,33.22 66.69,38.99 66.69,50.52 56.69,56.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "46.67,50.49 46.67,38.95 56.66,33.19 66.65,38.95 66.65,50.49 56.66,56.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "46.64,50.46 46.64,38.92 56.63,33.15 66.62,38.92 66.62,50.46 56.63,56.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "46.61,50.43 46.61,38.89 56.6,33.12 66.59,38.89 66.59,50.43 56.6,56.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "46.57,50.4 46.57,38.86 56.57,33.09 66.56,38.86 66.56,50.4 56.57,56.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "46.54,50.36 46.54,38.83 56.53,33.06 66.53,38.83 66.53,50.36 56.53,56.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "46.51,50.33 46.51,38.79 56.5,33.02 66.49,38.79 66.49,50.33 56.5,56.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "46.48,50.3 46.48,38.76 56.47,32.99 66.46,38.76 66.46,50.3 56.47,56.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "46.45,50.27 46.45,38.73 56.44,32.96 66.43,38.73 66.43,50.27 56.44,56.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "46.41,50.23 46.41,38.7 56.41,32.93 66.4,38.7 66.4,50.23 56.41,56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "46.38,50.2 46.38,38.67 56.37,32.9 66.37,38.67 66.37,50.2 56.37,55.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "46.35,50.17 46.35,38.63 56.34,32.86 66.33,38.63 66.33,50.17 56.34,55.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "46.32,50.14 46.32,38.6 56.31,32.83 66.3,38.6 66.3,50.14 56.31,55.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "46.29,50.11 46.29,38.57 56.28,32.8 66.27,38.57 66.27,50.11 56.28,55.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "46.25,50.07 46.25,38.54 56.25,32.77 66.24,38.54 66.24,50.07 56.25,55.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "46.22,50.04 46.22,38.51 56.21,32.74 66.2,38.51 66.2,50.04 56.21,55.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "46.19,50.01 46.19,38.47 56.18,32.7 66.17,38.47 66.17,50.01 56.18,55.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "46.16,49.98 46.16,38.44 56.15,32.67 66.14,38.44 66.14,49.98 56.15,55.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "46.13,49.95 46.13,38.41 56.12,32.64 66.11,38.41 66.11,49.95 56.12,55.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "46.09,49.91 46.09,38.38 56.08,32.61 66.08,38.38 66.08,49.91 56.08,55.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "46.06,49.88 46.06,38.34 56.05,32.58 66.04,38.34 66.04,49.88 56.05,55.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "46.03,49.85 46.03,38.31 56.02,32.54 66.01,38.31 66.01,49.85 56.02,55.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "46,49.82 46,38.28 55.99,32.51 65.98,38.28 65.98,49.82 55.99,55.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "45.96,49.79 45.96,38.25 55.96,32.48 65.95,38.25 65.95,49.79 55.96,55.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "45.93,49.75 45.93,38.22 55.92,32.45 65.92,38.22 65.92,49.75 55.92,55.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "45.9,49.72 45.9,38.18 55.89,32.42 65.88,38.18 65.88,49.72 55.89,55.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "45.87,49.69 45.87,38.15 55.86,32.38 65.85,38.15 65.85,49.69 55.86,55.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "45.84,49.66 45.84,38.12 55.83,32.35 65.82,38.12 65.82,49.66 55.83,55.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "45.8,49.63 45.8,38.09 55.8,32.32 65.79,38.09 65.79,49.63 55.8,55.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "45.77,49.59 45.77,38.06 55.76,32.29 65.76,38.06 65.76,49.59 55.76,55.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "45.74,49.56 45.74,38.02 55.73,32.26 65.72,38.02 65.72,49.56 55.73,55.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "45.71,49.53 45.71,37.99 55.7,32.22 65.69,37.99 65.69,49.53 55.7,55.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "45.68,49.5 45.68,37.96 55.67,32.19 65.66,37.96 65.66,49.5 55.67,55.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "45.64,49.47 45.64,37.93 55.64,32.16 65.63,37.93 65.63,49.47 55.64,55.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "45.61,49.43 45.61,37.9 55.6,32.13 65.6,37.9 65.6,49.43 55.6,55.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "45.58,49.4 45.58,37.86 55.57,32.1 65.56,37.86 65.56,49.4 55.57,55.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "45.55,49.37 45.55,37.83 55.54,32.06 65.53,37.83 65.53,49.37 55.54,55.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "45.52,49.34 45.52,37.8 55.51,32.03 65.5,37.8 65.5,49.34 55.51,55.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "45.48,49.31 45.48,37.77 55.48,32 65.47,37.77 65.47,49.31 55.48,55.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "45.45,49.27 45.45,37.74 55.44,31.97 65.44,37.74 65.44,49.27 55.44,55.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "45.42,49.24 45.42,37.7 55.41,31.93 65.4,37.7 65.4,49.24 55.41,55.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "45.39,49.21 45.39,37.67 55.38,31.9 65.37,37.67 65.37,49.21 55.38,54.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "45.36,49.18 45.36,37.64 55.35,31.87 65.34,37.64 65.34,49.18 55.35,54.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "45.32,49.14 45.32,37.61 55.32,31.84 65.31,37.61 65.31,49.14 55.32,54.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "45.29,49.11 45.29,37.58 55.28,31.81 65.28,37.58 65.28,49.11 55.28,54.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "45.26,49.08 45.26,37.54 55.25,31.77 65.24,37.54 65.24,49.08 55.25,54.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "45.23,49.05 45.23,37.51 55.22,31.74 65.21,37.51 65.21,49.05 55.22,54.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "45.2,49.02 45.2,37.48 55.19,31.71 65.18,37.48 65.18,49.02 55.19,54.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "45.16,48.98 45.16,37.45 55.16,31.68 65.15,37.45 65.15,48.98 55.16,54.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "45.13,48.95 45.13,37.41 55.12,31.65 65.11,37.41 65.11,48.95 55.12,54.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "45.1,48.92 45.1,37.38 55.09,31.61 65.08,37.38 65.08,48.92 55.09,54.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "45.07,48.89 45.07,37.35 55.06,31.58 65.05,37.35 65.05,48.89 55.06,54.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "45.04,48.86 45.04,37.32 55.03,31.55 65.02,37.32 65.02,48.86 55.03,54.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "45,48.82 45,37.29 54.99,31.52 64.99,37.29 64.99,48.82 54.99,54.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "44.97,48.79 44.97,37.25 54.96,31.49 64.95,37.25 64.95,48.79 54.96,54.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "44.94,48.76 44.94,37.22 54.93,31.45 64.92,37.22 64.92,48.76 54.93,54.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "44.91,48.73 44.91,37.19 54.9,31.42 64.89,37.19 64.89,48.73 54.9,54.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "44.87,48.7 44.87,37.16 54.87,31.39 64.86,37.16 64.86,48.7 54.87,54.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "44.84,48.66 44.84,37.13 54.83,31.36 64.83,37.13 64.83,48.66 54.83,54.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "44.81,48.63 44.81,37.09 54.8,31.33 64.79,37.09 64.79,48.63 54.8,54.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "44.78,48.6 44.78,37.06 54.77,31.29 64.76,37.06 64.76,48.6 54.77,54.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "44.75,48.57 44.75,37.03 54.74,31.26 64.73,37.03 64.73,48.57 54.74,54.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "44.71,48.54 44.71,37 54.71,31.23 64.7,37 64.7,48.54 54.71,54.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "44.68,48.5 44.68,36.97 54.67,31.2 64.67,36.97 64.67,48.5 54.67,54.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "44.65,48.47 44.65,36.93 54.64,31.17 64.63,36.93 64.63,48.47 54.64,54.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "44.62,48.44 44.62,36.9 54.61,31.13 64.6,36.9 64.6,48.44 54.61,54.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "44.59,48.41 44.59,36.87 54.58,31.1 64.57,36.87 64.57,48.41 54.58,54.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "44.55,48.38 44.55,36.84 54.55,31.07 64.54,36.84 64.54,48.38 54.55,54.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "44.52,48.34 44.52,36.81 54.51,31.04 64.51,36.81 64.51,48.34 54.51,54.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "44.49,48.31 44.49,36.77 54.48,31 64.47,36.77 64.47,48.31 54.48,54.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "44.46,48.28 44.46,36.74 54.45,30.97 64.44,36.74 64.44,48.28 54.45,54.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "44.43,48.25 44.43,36.71 54.42,30.94 64.41,36.71 64.41,48.25 54.42,54.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "44.39,48.21 44.39,36.68 54.39,30.91 64.38,36.68 64.38,48.21 54.39,53.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "44.36,48.18 44.36,36.65 54.35,30.88 64.35,36.65 64.35,48.18 54.35,53.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "44.33,48.15 44.33,36.61 54.32,30.84 64.31,36.61 64.31,48.15 54.32,53.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "44.3,48.12 44.3,36.58 54.29,30.81 64.28,36.58 64.28,48.12 54.29,53.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "44.27,48.09 44.27,36.55 54.26,30.78 64.25,36.55 64.25,48.09 54.26,53.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "44.23,48.05 44.23,36.52 54.23,30.75 64.22,36.52 64.22,48.05 54.23,53.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "44.2,48.02 44.2,36.49 54.19,30.72 64.18,36.49 64.18,48.02 54.19,53.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "44.17,47.99 44.17,36.45 54.16,30.68 64.15,36.45 64.15,47.99 54.16,53.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "44.14,47.96 44.14,36.42 54.13,30.65 64.12,36.42 64.12,47.96 54.13,53.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "44.11,47.93 44.11,36.39 54.1,30.62 64.09,36.39 64.09,47.93 54.1,53.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "44.07,47.89 44.07,36.36 54.06,30.59 64.06,36.36 64.06,47.89 54.06,53.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "44.04,47.86 44.04,36.32 54.03,30.56 64.02,36.32 64.02,47.86 54.03,53.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "44.01,47.83 44.01,36.29 54,30.52 63.99,36.29 63.99,47.83 54,53.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "43.98,47.8 43.98,36.26 53.97,30.49 63.96,36.26 63.96,47.8 53.97,53.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "43.95,47.77 43.95,36.23 53.94,30.46 63.93,36.23 63.93,47.77 53.94,53.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "43.91,47.73 43.91,36.2 53.9,30.43 63.9,36.2 63.9,47.73 53.9,53.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "43.88,47.7 43.88,36.16 53.87,30.4 63.86,36.16 63.86,47.7 53.87,53.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "43.85,47.67 43.85,36.13 53.84,30.36 63.83,36.13 63.83,47.67 53.84,53.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "43.82,47.64 43.82,36.1 53.81,30.33 63.8,36.1 63.8,47.64 53.81,53.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "43.78,47.61 43.78,36.07 53.78,30.3 63.77,36.07 63.77,47.61 53.78,53.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "43.75,47.57 43.75,36.04 53.74,30.27 63.74,36.04 63.74,47.57 53.74,53.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "43.72,47.54 43.72,36 53.71,30.24 63.7,36 63.7,47.54 53.71,53.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "43.69,47.51 43.69,35.97 53.68,30.2 63.67,35.97 63.67,47.51 53.68,53.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "43.66,47.48 43.66,35.94 53.65,30.17 63.64,35.94 63.64,47.48 53.65,53.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "43.62,47.45 43.62,35.91 53.62,30.14 63.61,35.91 63.61,47.45 53.62,53.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "43.59,47.41 43.59,35.88 53.58,30.11 63.58,35.88 63.58,47.41 53.58,53.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "43.56,47.38 43.56,35.84 53.55,30.08 63.54,35.84 63.54,47.38 53.55,53.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "43.53,47.35 43.53,35.81 53.52,30.04 63.51,35.81 63.51,47.35 53.52,53.12  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119827747902672137180000014416417073166594707_",
    gradientUnits: "userSpaceOnUse",
    x1: 1631.6141,
    y1: 301.6955,
    x2: 1647.3745,
    y2: 317.4559,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000119827747902672137180000014416417073166594707_)"
    },
    points: "43.53,47.35 43.53,35.81  53.52,30.04 63.51,35.81 63.51,47.35 53.52,53.12  "
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "43.73,36.09 43.73,47.47 43.53,47.35 43.53,35.81 53.52,30.04 53.86,30.24  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106118533501046007650000017718129661208938634_",
    gradientUnits: "userSpaceOnUse",
    x1: 1595.7133,
    y1: 259.3299,
    x2: 1611.4738,
    y2: 275.0903,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000106118533501046007650000017718129661208938634_)"
    },
    points: "1.16,11.45 1.16,-0.09  11.15,-5.86 21.15,-0.09 21.15,11.45 11.15,17.22  "
  }), /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "3.86,50.59 3.86,39.05 13.85,33.28 23.84,39.05 23.84,50.59 13.85,56.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "3.83,50.56 3.83,39.02 13.82,33.25 23.81,39.02 23.81,50.56 13.82,56.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "3.8,50.52 3.8,38.99 13.79,33.22 23.78,38.99 23.78,50.52 13.79,56.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "3.76,50.49 3.76,38.95 13.76,33.19 23.75,38.95 23.75,50.49 13.76,56.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "3.73,50.46 3.73,38.92 13.72,33.15 23.71,38.92 23.71,50.46 13.72,56.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "3.7,50.43 3.7,38.89 13.69,33.12 23.68,38.89 23.68,50.43 13.69,56.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "3.67,50.4 3.67,38.86 13.66,33.09 23.65,38.86 23.65,50.4 13.66,56.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "3.64,50.36 3.64,38.83 13.63,33.06 23.62,38.83 23.62,50.36 13.63,56.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "3.6,50.33 3.6,38.79 13.59,33.02 23.59,38.79 23.59,50.33 13.59,56.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "3.57,50.3 3.57,38.76 13.56,32.99 23.55,38.76 23.55,50.3 13.56,56.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "3.54,50.27 3.54,38.73 13.53,32.96 23.52,38.73 23.52,50.27 13.53,56.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "3.51,50.23 3.51,38.7 13.5,32.93 23.49,38.7 23.49,50.23 13.5,56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "3.47,50.2 3.47,38.67 13.47,32.9 23.46,38.67 23.46,50.2 13.47,55.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "3.44,50.17 3.44,38.63 13.43,32.86 23.43,38.63 23.43,50.17 13.43,55.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "3.41,50.14 3.41,38.6 13.4,32.83 23.39,38.6 23.39,50.14 13.4,55.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "3.38,50.11 3.38,38.57 13.37,32.8 23.36,38.57 23.36,50.11 13.37,55.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "3.35,50.07 3.35,38.54 13.34,32.77 23.33,38.54 23.33,50.07 13.34,55.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "3.31,50.04 3.31,38.51 13.31,32.74 23.3,38.51 23.3,50.04 13.31,55.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "3.28,50.01 3.28,38.47 13.27,32.7 23.27,38.47 23.27,50.01 13.27,55.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "3.25,49.98 3.25,38.44 13.24,32.67 23.23,38.44 23.23,49.98 13.24,55.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "3.22,49.95 3.22,38.41 13.21,32.64 23.2,38.41 23.2,49.95 13.21,55.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "3.19,49.91 3.19,38.38 13.18,32.61 23.17,38.38 23.17,49.91 13.18,55.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "3.15,49.88 3.15,38.34 13.15,32.58 23.14,38.34 23.14,49.88 13.15,55.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "3.12,49.85 3.12,38.31 13.11,32.54 23.11,38.31 23.11,49.85 13.11,55.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "3.09,49.82 3.09,38.28 13.08,32.51 23.07,38.28 23.07,49.82 13.08,55.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "3.06,49.79 3.06,38.25 13.05,32.48 23.04,38.25 23.04,49.79 13.05,55.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "3.03,49.75 3.03,38.22 13.02,32.45 23.01,38.22 23.01,49.75 13.02,55.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "2.99,49.72 2.99,38.18 12.99,32.42 22.98,38.18 22.98,49.72 12.99,55.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "2.96,49.69 2.96,38.15 12.95,32.38 22.95,38.15 22.95,49.69 12.95,55.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "2.93,49.66 2.93,38.12 12.92,32.35 22.91,38.12 22.91,49.66 12.92,55.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "2.9,49.63 2.9,38.09 12.89,32.32 22.88,38.09 22.88,49.63 12.89,55.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "2.87,49.59 2.87,38.06 12.86,32.29 22.85,38.06 22.85,49.59 12.86,55.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "2.83,49.56 2.83,38.02 12.83,32.26 22.82,38.02 22.82,49.56 12.83,55.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "2.8,49.53 2.8,37.99 12.79,32.22 22.78,37.99 22.78,49.53 12.79,55.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "2.77,49.5 2.77,37.96 12.76,32.19 22.75,37.96 22.75,49.5 12.76,55.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "2.74,49.47 2.74,37.93 12.73,32.16 22.72,37.93 22.72,49.47 12.73,55.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "2.71,49.43 2.71,37.9 12.7,32.13 22.69,37.9 22.69,49.43 12.7,55.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "2.67,49.4 2.67,37.86 12.67,32.1 22.66,37.86 22.66,49.4 12.67,55.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "2.64,49.37 2.64,37.83 12.63,32.06 22.62,37.83 22.62,49.37 12.63,55.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "2.61,49.34 2.61,37.8 12.6,32.03 22.59,37.8 22.59,49.34 12.6,55.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "2.58,49.31 2.58,37.77 12.57,32 22.56,37.77 22.56,49.31 12.57,55.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "2.55,49.27 2.55,37.74 12.54,31.97 22.53,37.74 22.53,49.27 12.54,55.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "2.51,49.24 2.51,37.7 12.5,31.93 22.5,37.7 22.5,49.24 12.5,55.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "2.48,49.21 2.48,37.67 12.47,31.9 22.46,37.67 22.46,49.21 12.47,54.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "2.45,49.18 2.45,37.64 12.44,31.87 22.43,37.64 22.43,49.18 12.44,54.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "2.42,49.14 2.42,37.61 12.41,31.84 22.4,37.61 22.4,49.14 12.41,54.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "2.38,49.11 2.38,37.58 12.38,31.81 22.37,37.58 22.37,49.11 12.38,54.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "2.35,49.08 2.35,37.54 12.34,31.77 22.34,37.54 22.34,49.08 12.34,54.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "2.32,49.05 2.32,37.51 12.31,31.74 22.3,37.51 22.3,49.05 12.31,54.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "2.29,49.02 2.29,37.48 12.28,31.71 22.27,37.48 22.27,49.02 12.28,54.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "2.26,48.98 2.26,37.45 12.25,31.68 22.24,37.45 22.24,48.98 12.25,54.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "2.22,48.95 2.22,37.41 12.22,31.65 22.21,37.41 22.21,48.95 12.22,54.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "2.19,48.92 2.19,37.38 12.18,31.61 22.18,37.38 22.18,48.92 12.18,54.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "2.16,48.89 2.16,37.35 12.15,31.58 22.14,37.35 22.14,48.89 12.15,54.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "2.13,48.86 2.13,37.32 12.12,31.55 22.11,37.32 22.11,48.86 12.12,54.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "2.1,48.82 2.1,37.29 12.09,31.52 22.08,37.29 22.08,48.82 12.09,54.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "2.06,48.79 2.06,37.25 12.06,31.49 22.05,37.25 22.05,48.79 12.06,54.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "2.03,48.76 2.03,37.22 12.02,31.45 22.02,37.22 22.02,48.76 12.02,54.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "2,48.73 2,37.19 11.99,31.42 21.98,37.19 21.98,48.73 11.99,54.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "1.97,48.7 1.97,37.16 11.96,31.39 21.95,37.16 21.95,48.7 11.96,54.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "1.94,48.66 1.94,37.13 11.93,31.36 21.92,37.13 21.92,48.66 11.93,54.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "1.9,48.63 1.9,37.09 11.9,31.33 21.89,37.09 21.89,48.63 11.9,54.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "1.87,48.6 1.87,37.06 11.86,31.29 21.86,37.06 21.86,48.6 11.86,54.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "1.84,48.57 1.84,37.03 11.83,31.26 21.82,37.03 21.82,48.57 11.83,54.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "1.81,48.54 1.81,37 11.8,31.23 21.79,37 21.79,48.54 11.8,54.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "1.78,48.5 1.78,36.97 11.77,31.2 21.76,36.97 21.76,48.5 11.77,54.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "1.74,48.47 1.74,36.93 11.74,31.17 21.73,36.93 21.73,48.47 11.74,54.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "1.71,48.44 1.71,36.9 11.7,31.13 21.69,36.9 21.69,48.44 11.7,54.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "1.68,48.41 1.68,36.87 11.67,31.1 21.66,36.87 21.66,48.41 11.67,54.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "1.65,48.38 1.65,36.84 11.64,31.07 21.63,36.84 21.63,48.38 11.64,54.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "1.62,48.34 1.62,36.81 11.61,31.04 21.6,36.81 21.6,48.34 11.61,54.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "1.58,48.31 1.58,36.77 11.57,31 21.57,36.77 21.57,48.31 11.57,54.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "1.55,48.28 1.55,36.74 11.54,30.97 21.53,36.74 21.53,48.28 11.54,54.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "1.52,48.25 1.52,36.71 11.51,30.94 21.5,36.71 21.5,48.25 11.51,54.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "1.49,48.21 1.49,36.68 11.48,30.91 21.47,36.68 21.47,48.21 11.48,53.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "1.46,48.18 1.46,36.65 11.45,30.88 21.44,36.65 21.44,48.18 11.45,53.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "1.42,48.15 1.42,36.61 11.41,30.84 21.41,36.61 21.41,48.15 11.41,53.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "1.39,48.12 1.39,36.58 11.38,30.81 21.37,36.58 21.37,48.12 11.38,53.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "1.36,48.09 1.36,36.55 11.35,30.78 21.34,36.55 21.34,48.09 11.35,53.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "1.33,48.05 1.33,36.52 11.32,30.75 21.31,36.52 21.31,48.05 11.32,53.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "1.29,48.02 1.29,36.49 11.29,30.72 21.28,36.49 21.28,48.02 11.29,53.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "1.26,47.99 1.26,36.45 11.25,30.68 21.25,36.45 21.25,47.99 11.25,53.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "1.23,47.96 1.23,36.42 11.22,30.65 21.21,36.42 21.21,47.96 11.22,53.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "1.2,47.93 1.2,36.39 11.19,30.62 21.18,36.39 21.18,47.93 11.19,53.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "1.17,47.89 1.17,36.36 11.16,30.59 21.15,36.36 21.15,47.89 11.16,53.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "1.13,47.86 1.13,36.32 11.13,30.56 21.12,36.32 21.12,47.86 11.13,53.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "1.1,47.83 1.1,36.29 11.09,30.52 21.09,36.29 21.09,47.83 11.09,53.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "1.07,47.8 1.07,36.26 11.06,30.49 21.05,36.26 21.05,47.8 11.06,53.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "1.04,47.77 1.04,36.23 11.03,30.46 21.02,36.23 21.02,47.77 11.03,53.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "1.01,47.73 1.01,36.2 11,30.43 20.99,36.2 20.99,47.73 11,53.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "0.97,47.7 0.97,36.16 10.97,30.4 20.96,36.16 20.96,47.7 10.97,53.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "0.94,47.67 0.94,36.13 10.93,30.36 20.93,36.13 20.93,47.67 10.93,53.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "0.91,47.64 0.91,36.1 10.9,30.33 20.89,36.1 20.89,47.64 10.9,53.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "0.88,47.61 0.88,36.07 10.87,30.3 20.86,36.07 20.86,47.61 10.87,53.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "0.85,47.57 0.85,36.04 10.84,30.27 20.83,36.04 20.83,47.57 10.84,53.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "0.81,47.54 0.81,36 10.81,30.24 20.8,36 20.8,47.54 10.81,53.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "0.78,47.51 0.78,35.97 10.77,30.2 20.77,35.97 20.77,47.51 10.77,53.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "0.75,47.48 0.75,35.94 10.74,30.17 20.73,35.94 20.73,47.48 10.74,53.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "0.72,47.45 0.72,35.91 10.71,30.14 20.7,35.91 20.7,47.45 10.71,53.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "0.69,47.41 0.69,35.88 10.68,30.11 20.67,35.88 20.67,47.41 10.68,53.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "0.65,47.38 0.65,35.84 10.65,30.08 20.64,35.84 20.64,47.38 10.65,53.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "0.62,47.35 0.62,35.81 10.61,30.04 20.6,35.81 20.6,47.35 10.61,53.12  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123404377097821926330000012552963225429926065_",
    gradientUnits: "userSpaceOnUse",
    x1: 1631.6141,
    y1: 258.7887,
    x2: 1647.3745,
    y2: 274.549,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000123404377097821926330000012552963225429926065_)"
    },
    points: "0.62,47.35 0.62,35.81  10.61,30.04 20.6,35.81 20.6,47.35 10.61,53.12  "
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "0.83,36.09 0.83,47.47 0.62,47.35 0.62,35.81 10.61,30.04 10.96,30.24  "
  }))), /*#__PURE__*/React.createElement("g", null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "57.49,32.72 57.49,21.18 67.48,15.42 77.48,21.18 77.48,32.72 67.48,38.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "57.46,32.69 57.46,21.15 67.45,15.38 77.44,21.15 77.44,32.69 67.45,38.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "57.43,32.66 57.43,21.12 67.42,15.35 77.41,21.12 77.41,32.66 67.42,38.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "57.4,32.63 57.4,21.09 67.39,15.32 77.38,21.09 77.38,32.63 67.39,38.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "57.36,32.59 57.36,21.06 67.36,15.29 77.35,21.06 77.35,32.59 67.36,38.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "57.33,32.56 57.33,21.02 67.32,15.26 77.32,21.02 77.32,32.56 67.32,38.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "57.3,32.53 57.3,20.99 67.29,15.22 77.28,20.99 77.28,32.53 67.29,38.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "57.27,32.5 57.27,20.96 67.26,15.19 77.25,20.96 77.25,32.5 67.26,38.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "57.24,32.47 57.24,20.93 67.23,15.16 77.22,20.93 77.22,32.47 67.23,38.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "57.2,32.43 57.2,20.9 67.2,15.13 77.19,20.9 77.19,32.43 67.2,38.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "57.17,32.4 57.17,20.86 67.16,15.1 77.16,20.86 77.16,32.4 67.16,38.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "57.14,32.37 57.14,20.83 67.13,15.06 77.12,20.83 77.12,32.37 67.13,38.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "57.11,32.34 57.11,20.8 67.1,15.03 77.09,20.8 77.09,32.34 67.1,38.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "57.08,32.31 57.08,20.77 67.07,15 77.06,20.77 77.06,32.31 67.07,38.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "57.04,32.27 57.04,20.74 67.04,14.97 77.03,20.74 77.03,32.27 67.04,38.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "57.01,32.24 57.01,20.7 67,14.93 77,20.7 77,32.24 67,38.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "56.98,32.21 56.98,20.67 66.97,14.9 76.96,20.67 76.96,32.21 66.97,37.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "56.95,32.18 56.95,20.64 66.94,14.87 76.93,20.64 76.93,32.18 66.94,37.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "56.92,32.14 56.92,20.61 66.91,14.84 76.9,20.61 76.9,32.14 66.91,37.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "56.88,32.11 56.88,20.58 66.88,14.81 76.87,20.58 76.87,32.11 66.88,37.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "56.85,32.08 56.85,20.54 66.84,14.77 76.84,20.54 76.84,32.08 66.84,37.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "56.82,32.05 56.82,20.51 66.81,14.74 76.8,20.51 76.8,32.05 66.81,37.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "56.79,32.02 56.79,20.48 66.78,14.71 76.77,20.48 76.77,32.02 66.78,37.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "56.76,31.98 56.76,20.45 66.75,14.68 76.74,20.45 76.74,31.98 66.75,37.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "56.72,31.95 56.72,20.41 66.72,14.65 76.71,20.41 76.71,31.95 66.72,37.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "56.69,31.92 56.69,20.38 66.68,14.61 76.68,20.38 76.68,31.92 66.68,37.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "56.66,31.89 56.66,20.35 66.65,14.58 76.64,20.35 76.64,31.89 66.65,37.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "56.63,31.86 56.63,20.32 66.62,14.55 76.61,20.32 76.61,31.86 66.62,37.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "56.6,31.82 56.6,20.29 66.59,14.52 76.58,20.29 76.58,31.82 66.59,37.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "56.56,31.79 56.56,20.25 66.56,14.49 76.55,20.25 76.55,31.79 66.56,37.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "56.53,31.76 56.53,20.22 66.52,14.45 76.51,20.22 76.51,31.76 66.52,37.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "56.5,31.73 56.5,20.19 66.49,14.42 76.48,20.19 76.48,31.73 66.49,37.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "56.47,31.7 56.47,20.16 66.46,14.39 76.45,20.16 76.45,31.7 66.46,37.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "56.44,31.66 56.44,20.13 66.43,14.36 76.42,20.13 76.42,31.66 66.43,37.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "56.4,31.63 56.4,20.09 66.39,14.33 76.39,20.09 76.39,31.63 66.39,37.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "56.37,31.6 56.37,20.06 66.36,14.29 76.35,20.06 76.35,31.6 66.36,37.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "56.34,31.57 56.34,20.03 66.33,14.26 76.32,20.03 76.32,31.57 66.33,37.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "56.31,31.54 56.31,20 66.3,14.23 76.29,20 76.29,31.54 66.3,37.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "56.27,31.5 56.27,19.97 66.27,14.2 76.26,19.97 76.26,31.5 66.27,37.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "56.24,31.47 56.24,19.93 66.23,14.17 76.23,19.93 76.23,31.47 66.23,37.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "56.21,31.44 56.21,19.9 66.2,14.13 76.19,19.9 76.19,31.44 66.2,37.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "56.18,31.41 56.18,19.87 66.17,14.1 76.16,19.87 76.16,31.41 66.17,37.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "56.15,31.38 56.15,19.84 66.14,14.07 76.13,19.84 76.13,31.38 66.14,37.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "56.11,31.34 56.11,19.81 66.11,14.04 76.1,19.81 76.1,31.34 66.11,37.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "56.08,31.31 56.08,19.77 66.07,14 76.07,19.77 76.07,31.31 66.07,37.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "56.05,31.28 56.05,19.74 66.04,13.97 76.03,19.74 76.03,31.28 66.04,37.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "56.02,31.25 56.02,19.71 66.01,13.94 76,19.71 76,31.25 66.01,37.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "55.99,31.21 55.99,19.68 65.98,13.91 75.97,19.68 75.97,31.21 65.98,36.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "55.95,31.18 55.95,19.65 65.95,13.88 75.94,19.65 75.94,31.18 65.95,36.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "55.92,31.15 55.92,19.61 65.91,13.84 75.91,19.61 75.91,31.15 65.91,36.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "55.89,31.12 55.89,19.58 65.88,13.81 75.87,19.58 75.87,31.12 65.88,36.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "55.86,31.09 55.86,19.55 65.85,13.78 75.84,19.55 75.84,31.09 65.85,36.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "55.83,31.05 55.83,19.52 65.82,13.75 75.81,19.52 75.81,31.05 65.82,36.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "55.79,31.02 55.79,19.49 65.79,13.72 75.78,19.49 75.78,31.02 65.79,36.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "55.76,30.99 55.76,19.45 65.75,13.68 75.75,19.45 75.75,30.99 65.75,36.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "55.73,30.96 55.73,19.42 65.72,13.65 75.71,19.42 75.71,30.96 65.72,36.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "55.7,30.93 55.7,19.39 65.69,13.62 75.68,19.39 75.68,30.93 65.69,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "55.67,30.89 55.67,19.36 65.66,13.59 75.65,19.36 75.65,30.89 65.66,36.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "55.63,30.86 55.63,19.32 65.63,13.56 75.62,19.32 75.62,30.86 65.63,36.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "55.6,30.83 55.6,19.29 65.59,13.52 75.58,19.29 75.58,30.83 65.59,36.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "55.57,30.8 55.57,19.26 65.56,13.49 75.55,19.26 75.55,30.8 65.56,36.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "55.54,30.77 55.54,19.23 65.53,13.46 75.52,19.23 75.52,30.77 65.53,36.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "55.51,30.73 55.51,19.2 65.5,13.43 75.49,19.2 75.49,30.73 65.5,36.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "55.47,30.7 55.47,19.16 65.46,13.4 75.46,19.16 75.46,30.7 65.46,36.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "55.44,30.67 55.44,19.13 65.43,13.36 75.42,19.13 75.42,30.67 65.43,36.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "55.41,30.64 55.41,19.1 65.4,13.33 75.39,19.1 75.39,30.64 65.4,36.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "55.38,30.61 55.38,19.07 65.37,13.3 75.36,19.07 75.36,30.61 65.37,36.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "55.35,30.57 55.35,19.04 65.34,13.27 75.33,19.04 75.33,30.57 65.34,36.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "55.31,30.54 55.31,19 65.3,13.24 75.3,19 75.3,30.54 65.3,36.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "55.28,30.51 55.28,18.97 65.27,13.2 75.26,18.97 75.26,30.51 65.27,36.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "55.25,30.48 55.25,18.94 65.24,13.17 75.23,18.94 75.23,30.48 65.24,36.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "55.22,30.45 55.22,18.91 65.21,13.14 75.2,18.91 75.2,30.45 65.21,36.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "55.18,30.41 55.18,18.88 65.18,13.11 75.17,18.88 75.17,30.41 65.18,36.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "55.15,30.38 55.15,18.84 65.14,13.08 75.14,18.84 75.14,30.38 65.14,36.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "55.12,30.35 55.12,18.81 65.11,13.04 75.1,18.81 75.1,30.35 65.11,36.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "55.09,30.32 55.09,18.78 65.08,13.01 75.07,18.78 75.07,30.32 65.08,36.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "55.06,30.29 55.06,18.75 65.05,12.98 75.04,18.75 75.04,30.29 65.05,36.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "55.02,30.25 55.02,18.72 65.02,12.95 75.01,18.72 75.01,30.25 65.02,36.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "54.99,30.22 54.99,18.68 64.98,12.91 74.98,18.68 74.98,30.22 64.98,35.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "54.96,30.19 54.96,18.65 64.95,12.88 74.94,18.65 74.94,30.19 64.95,35.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "54.93,30.16 54.93,18.62 64.92,12.85 74.91,18.62 74.91,30.16 64.92,35.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "54.9,30.12 54.9,18.59 64.89,12.82 74.88,18.59 74.88,30.12 64.89,35.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "54.86,30.09 54.86,18.56 64.86,12.79 74.85,18.56 74.85,30.09 64.86,35.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "54.83,30.06 54.83,18.52 64.82,12.75 74.82,18.52 74.82,30.06 64.82,35.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "54.8,30.03 54.8,18.49 64.79,12.72 74.78,18.49 74.78,30.03 64.79,35.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "54.77,30 54.77,18.46 64.76,12.69 74.75,18.46 74.75,30 64.76,35.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "54.74,29.96 54.74,18.43 64.73,12.66 74.72,18.43 74.72,29.96 64.73,35.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "54.7,29.93 54.7,18.39 64.7,12.63 74.69,18.39 74.69,29.93 64.7,35.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "54.67,29.9 54.67,18.36 64.66,12.59 74.66,18.36 74.66,29.9 64.66,35.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "54.64,29.87 54.64,18.33 64.63,12.56 74.62,18.33 74.62,29.87 64.63,35.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "54.61,29.84 54.61,18.3 64.6,12.53 74.59,18.3 74.59,29.84 64.6,35.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "54.58,29.8 54.58,18.27 64.57,12.5 74.56,18.27 74.56,29.8 64.57,35.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "54.54,29.77 54.54,18.23 64.54,12.47 74.53,18.23 74.53,29.77 64.54,35.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "54.51,29.74 54.51,18.2 64.5,12.43 74.49,18.2 74.49,29.74 64.5,35.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "54.48,29.71 54.48,18.17 64.47,12.4 74.46,18.17 74.46,29.71 64.47,35.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "54.45,29.68 54.45,18.14 64.44,12.37 74.43,18.14 74.43,29.68 64.44,35.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "54.42,29.64 54.42,18.11 64.41,12.34 74.4,18.11 74.4,29.64 64.41,35.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "54.38,29.61 54.38,18.07 64.37,12.31 74.37,18.07 74.37,29.61 64.37,35.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "54.35,29.58 54.35,18.04 64.34,12.27 74.33,18.04 74.33,29.58 64.34,35.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "54.32,29.55 54.32,18.01 64.31,12.24 74.3,18.01 74.3,29.55 64.31,35.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "54.29,29.52 54.29,17.98 64.28,12.21 74.27,17.98 74.27,29.52 64.28,35.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "54.25,29.48 54.25,17.95 64.25,12.18 74.24,17.95 74.24,29.48 64.25,35.25  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170972839355904771880000002872271939593663399_",
    gradientUnits: "userSpaceOnUse",
    x1: 1613.7484,
    y1: 312.4222,
    x2: 1629.5088,
    y2: 328.1826,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000170972839355904771880000002872271939593663399_)"
    },
    points: "54.25,29.48 54.25,17.95  64.25,12.18 74.24,17.95 74.24,29.48 64.25,35.25  "
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "54.46,18.22 54.46,29.6 54.25,29.48 54.25,17.95 64.25,12.18 64.59,12.38  "
  }))), /*#__PURE__*/React.createElement("g", null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "14.59,68.92 14.59,57.38 24.58,51.61 34.57,57.38 34.57,68.92 24.58,74.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "14.55,68.89 14.55,57.35 24.55,51.58 34.54,57.35 34.54,68.89 24.55,74.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "14.52,68.86 14.52,57.32 24.51,51.55 34.51,57.32 34.51,68.86 24.51,74.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "14.49,68.82 14.49,57.29 24.48,51.52 34.47,57.29 34.47,68.82 24.48,74.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "14.46,68.79 14.46,57.25 24.45,51.49 34.44,57.25 34.44,68.79 24.45,74.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "14.43,68.76 14.43,57.22 24.42,51.45 34.41,57.22 34.41,68.76 24.42,74.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "14.39,68.73 14.39,57.19 24.39,51.42 34.38,57.19 34.38,68.73 24.39,74.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "14.36,68.7 14.36,57.16 24.35,51.39 34.35,57.16 34.35,68.7 24.35,74.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "14.33,68.66 14.33,57.13 24.32,51.36 34.31,57.13 34.31,68.66 24.32,74.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "14.3,68.63 14.3,57.09 24.29,51.33 34.28,57.09 34.28,68.63 24.29,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "14.27,68.6 14.27,57.06 24.26,51.29 34.25,57.06 34.25,68.6 24.26,74.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "14.23,68.57 14.23,57.03 24.23,51.26 34.22,57.03 34.22,68.57 24.23,74.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "14.2,68.54 14.2,57 24.19,51.23 34.19,57 34.19,68.54 24.19,74.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "14.17,68.5 14.17,56.97 24.16,51.2 34.15,56.97 34.15,68.5 24.16,74.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "14.14,68.47 14.14,56.93 24.13,51.17 34.12,56.93 34.12,68.47 24.13,74.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "14.11,68.44 14.11,56.9 24.1,51.13 34.09,56.9 34.09,68.44 24.1,74.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "14.07,68.41 14.07,56.87 24.07,51.1 34.06,56.87 34.06,68.41 24.07,74.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "14.04,68.38 14.04,56.84 24.03,51.07 34.02,56.84 34.02,68.38 24.03,74.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "14.01,68.34 14.01,56.81 24,51.04 33.99,56.81 33.99,68.34 24,74.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "13.98,68.31 13.98,56.77 23.97,51.01 33.96,56.77 33.96,68.31 23.97,74.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "13.95,68.28 13.95,56.74 23.94,50.97 33.93,56.74 33.93,68.28 23.94,74.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "13.91,68.25 13.91,56.71 23.9,50.94 33.9,56.71 33.9,68.25 23.9,74.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "13.88,68.22 13.88,56.68 23.87,50.91 33.86,56.68 33.86,68.22 23.87,73.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "13.85,68.18 13.85,56.65 23.84,50.88 33.83,56.65 33.83,68.18 23.84,73.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "13.82,68.15 13.82,56.61 23.81,50.84 33.8,56.61 33.8,68.15 23.81,73.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "13.78,68.12 13.78,56.58 23.78,50.81 33.77,56.58 33.77,68.12 23.78,73.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "13.75,68.09 13.75,56.55 23.74,50.78 33.74,56.55 33.74,68.09 23.74,73.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "13.72,68.05 13.72,56.52 23.71,50.75 33.7,56.52 33.7,68.05 23.71,73.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "13.69,68.02 13.69,56.49 23.68,50.72 33.67,56.49 33.67,68.02 23.68,73.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "13.66,67.99 13.66,56.45 23.65,50.68 33.64,56.45 33.64,67.99 23.65,73.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "13.62,67.96 13.62,56.42 23.62,50.65 33.61,56.42 33.61,67.96 23.62,73.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "13.59,67.93 13.59,56.39 23.58,50.62 33.58,56.39 33.58,67.93 23.58,73.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "13.56,67.89 13.56,56.36 23.55,50.59 33.54,56.36 33.54,67.89 23.55,73.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "13.53,67.86 13.53,56.33 23.52,50.56 33.51,56.33 33.51,67.86 23.52,73.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "13.5,67.83 13.5,56.29 23.49,50.52 33.48,56.29 33.48,67.83 23.49,73.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "13.46,67.8 13.46,56.26 23.46,50.49 33.45,56.26 33.45,67.8 23.46,73.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "13.43,67.77 13.43,56.23 23.42,50.46 33.42,56.23 33.42,67.77 23.42,73.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "13.4,67.73 13.4,56.2 23.39,50.43 33.38,56.2 33.38,67.73 23.39,73.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "13.37,67.7 13.37,56.16 23.36,50.4 33.35,56.16 33.35,67.7 23.36,73.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "13.34,67.67 13.34,56.13 23.33,50.36 33.32,56.13 33.32,67.67 23.33,73.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "13.3,67.64 13.3,56.1 23.3,50.33 33.29,56.1 33.29,67.64 23.3,73.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "13.27,67.61 13.27,56.07 23.26,50.3 33.26,56.07 33.26,67.61 23.26,73.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "13.24,67.57 13.24,56.04 23.23,50.27 33.22,56.04 33.22,67.57 23.23,73.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "13.21,67.54 13.21,56 23.2,50.24 33.19,56 33.19,67.54 23.2,73.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "13.18,67.51 13.18,55.97 23.17,50.2 33.16,55.97 33.16,67.51 23.17,73.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "13.14,67.48 13.14,55.94 23.14,50.17 33.13,55.94 33.13,67.48 23.14,73.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "13.11,67.45 13.11,55.91 23.1,50.14 33.09,55.91 33.09,67.45 23.1,73.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "13.08,67.41 13.08,55.88 23.07,50.11 33.06,55.88 33.06,67.41 23.07,73.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "13.05,67.38 13.05,55.84 23.04,50.08 33.03,55.84 33.03,67.38 23.04,73.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "13.02,67.35 13.02,55.81 23.01,50.04 33,55.81 33,67.35 23.01,73.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "12.98,67.32 12.98,55.78 22.97,50.01 32.97,55.78 32.97,67.32 22.97,73.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "12.95,67.29 12.95,55.75 22.94,49.98 32.93,55.75 32.93,67.29 22.94,73.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "12.92,67.25 12.92,55.72 22.91,49.95 32.9,55.72 32.9,67.25 22.91,73.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "12.89,67.22 12.89,55.68 22.88,49.91 32.87,55.68 32.87,67.22 22.88,72.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "12.86,67.19 12.86,55.65 22.85,49.88 32.84,55.65 32.84,67.19 22.85,72.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "12.82,67.16 12.82,55.62 22.81,49.85 32.81,55.62 32.81,67.16 22.81,72.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "12.79,67.13 12.79,55.59 22.78,49.82 32.77,55.59 32.77,67.13 22.78,72.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "12.76,67.09 12.76,55.56 22.75,49.79 32.74,55.56 32.74,67.09 22.75,72.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "12.73,67.06 12.73,55.52 22.72,49.75 32.71,55.52 32.71,67.06 22.72,72.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "12.69,67.03 12.69,55.49 22.69,49.72 32.68,55.49 32.68,67.03 22.69,72.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "12.66,67 12.66,55.46 22.65,49.69 32.65,55.46 32.65,67 22.65,72.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "12.63,66.96 12.63,55.43 22.62,49.66 32.61,55.43 32.61,66.96 22.62,72.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "12.6,66.93 12.6,55.4 22.59,49.63 32.58,55.4 32.58,66.93 22.59,72.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "12.57,66.9 12.57,55.36 22.56,49.59 32.55,55.36 32.55,66.9 22.56,72.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "12.53,66.87 12.53,55.33 22.53,49.56 32.52,55.33 32.52,66.87 22.53,72.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "12.5,66.84 12.5,55.3 22.49,49.53 32.49,55.3 32.49,66.84 22.49,72.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "12.47,66.8 12.47,55.27 22.46,49.5 32.45,55.27 32.45,66.8 22.46,72.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "12.44,66.77 12.44,55.23 22.43,49.47 32.42,55.23 32.42,66.77 22.43,72.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "12.41,66.74 12.41,55.2 22.4,49.43 32.39,55.2 32.39,66.74 22.4,72.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "12.37,66.71 12.37,55.17 22.37,49.4 32.36,55.17 32.36,66.71 22.37,72.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "12.34,66.68 12.34,55.14 22.33,49.37 32.33,55.14 32.33,66.68 22.33,72.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "12.31,66.64 12.31,55.11 22.3,49.34 32.29,55.11 32.29,66.64 22.3,72.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "12.28,66.61 12.28,55.07 22.27,49.31 32.26,55.07 32.26,66.61 22.27,72.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "12.25,66.58 12.25,55.04 22.24,49.27 32.23,55.04 32.23,66.58 22.24,72.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "12.21,66.55 12.21,55.01 22.21,49.24 32.2,55.01 32.2,66.55 22.21,72.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "12.18,66.52 12.18,54.98 22.17,49.21 32.17,54.98 32.17,66.52 22.17,72.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "12.15,66.48 12.15,54.95 22.14,49.18 32.13,54.95 32.13,66.48 22.14,72.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "12.12,66.45 12.12,54.91 22.11,49.15 32.1,54.91 32.1,66.45 22.11,72.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "12.09,66.42 12.09,54.88 22.08,49.11 32.07,54.88 32.07,66.42 22.08,72.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "12.05,66.39 12.05,54.85 22.05,49.08 32.04,54.85 32.04,66.39 22.05,72.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "12.02,66.36 12.02,54.82 22.01,49.05 32,54.82 32,66.36 22.01,72.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "11.99,66.32 11.99,54.79 21.98,49.02 31.97,54.79 31.97,66.32 21.98,72.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "11.96,66.29 11.96,54.75 21.95,48.99 31.94,54.75 31.94,66.29 21.95,72.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "11.93,66.26 11.93,54.72 21.92,48.95 31.91,54.72 31.91,66.26 21.92,72.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "11.89,66.23 11.89,54.69 21.88,48.92 31.88,54.69 31.88,66.23 21.88,72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "11.86,66.2 11.86,54.66 21.85,48.89 31.84,54.66 31.84,66.2 21.85,71.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "11.83,66.16 11.83,54.63 21.82,48.86 31.81,54.63 31.81,66.16 21.82,71.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "11.8,66.13 11.8,54.59 21.79,48.82 31.78,54.59 31.78,66.13 21.79,71.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "11.76,66.1 11.76,54.56 21.76,48.79 31.75,54.56 31.75,66.1 21.76,71.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "11.73,66.07 11.73,54.53 21.72,48.76 31.72,54.53 31.72,66.07 21.72,71.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "11.7,66.03 11.7,54.5 21.69,48.73 31.68,54.5 31.68,66.03 21.69,71.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "11.67,66 11.67,54.47 21.66,48.7 31.65,54.47 31.65,66 21.66,71.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "11.64,65.97 11.64,54.43 21.63,48.66 31.62,54.43 31.62,65.97 21.63,71.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "11.6,65.94 11.6,54.4 21.6,48.63 31.59,54.4 31.59,65.94 21.6,71.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "11.57,65.91 11.57,54.37 21.56,48.6 31.56,54.37 31.56,65.91 21.56,71.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "11.54,65.87 11.54,54.34 21.53,48.57 31.52,54.34 31.52,65.87 21.53,71.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "11.51,65.84 11.51,54.31 21.5,48.54 31.49,54.31 31.49,65.84 21.5,71.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "11.48,65.81 11.48,54.27 21.47,48.5 31.46,54.27 31.46,65.81 21.47,71.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "11.44,65.78 11.44,54.24 21.44,48.47 31.43,54.24 31.43,65.78 21.44,71.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "11.41,65.75 11.41,54.21 21.4,48.44 31.4,54.21 31.4,65.75 21.4,71.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "11.38,65.71 11.38,54.18 21.37,48.41 31.36,54.18 31.36,65.71 21.37,71.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "11.35,65.68 11.35,54.14 21.34,48.38 31.33,54.14 31.33,65.68 21.34,71.45  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067203195540274301410000017367338083112801706_",
    gradientUnits: "userSpaceOnUse",
    x1: 1649.947,
    y1: 269.5154,
    x2: 1665.7075,
    y2: 285.2758,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000067203195540274301410000017367338083112801706_)"
    },
    points: "11.35,65.68 11.35,54.14  21.34,48.38 31.33,54.14 31.33,65.68 21.34,71.45  "
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "11.55,54.42 11.55,65.8 11.35,65.68 11.35,54.14 21.34,48.38 21.68,48.57  "
  }))), /*#__PURE__*/React.createElement("g", null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "36.04,68.92 36.04,57.38 46.03,51.61 56.02,57.38 56.02,68.92 46.03,74.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "36.01,68.89 36.01,57.35 46,51.58 55.99,57.35 55.99,68.89 46,74.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "35.98,68.86 35.98,57.32 45.97,51.55 55.96,57.32 55.96,68.86 45.97,74.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "35.94,68.82 35.94,57.29 45.94,51.52 55.93,57.29 55.93,68.82 45.94,74.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "35.91,68.79 35.91,57.25 45.9,51.49 55.89,57.25 55.89,68.79 45.9,74.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "35.88,68.76 35.88,57.22 45.87,51.45 55.86,57.22 55.86,68.76 45.87,74.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "35.85,68.73 35.85,57.19 45.84,51.42 55.83,57.19 55.83,68.73 45.84,74.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "35.82,68.7 35.82,57.16 45.81,51.39 55.8,57.16 55.8,68.7 45.81,74.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "35.78,68.66 35.78,57.13 45.78,51.36 55.77,57.13 55.77,68.66 45.78,74.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "35.75,68.63 35.75,57.09 45.74,51.33 55.73,57.09 55.73,68.63 45.74,74.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "35.72,68.6 35.72,57.06 45.71,51.29 55.7,57.06 55.7,68.6 45.71,74.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "35.69,68.57 35.69,57.03 45.68,51.26 55.67,57.03 55.67,68.57 45.68,74.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "35.66,68.54 35.66,57 45.65,51.23 55.64,57 55.64,68.54 45.65,74.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "35.62,68.5 35.62,56.97 45.61,51.2 55.61,56.97 55.61,68.5 45.61,74.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "35.59,68.47 35.59,56.93 45.58,51.17 55.57,56.93 55.57,68.47 45.58,74.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "35.56,68.44 35.56,56.9 45.55,51.13 55.54,56.9 55.54,68.44 45.55,74.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "35.53,68.41 35.53,56.87 45.52,51.1 55.51,56.87 55.51,68.41 45.52,74.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "35.49,68.38 35.49,56.84 45.49,51.07 55.48,56.84 55.48,68.38 45.49,74.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "35.46,68.34 35.46,56.81 45.45,51.04 55.45,56.81 55.45,68.34 45.45,74.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "35.43,68.31 35.43,56.77 45.42,51.01 55.41,56.77 55.41,68.31 45.42,74.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "35.4,68.28 35.4,56.74 45.39,50.97 55.38,56.74 55.38,68.28 45.39,74.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "35.37,68.25 35.37,56.71 45.36,50.94 55.35,56.71 55.35,68.25 45.36,74.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "35.33,68.22 35.33,56.68 45.33,50.91 55.32,56.68 55.32,68.22 45.33,73.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "35.3,68.18 35.3,56.65 45.29,50.88 55.29,56.65 55.29,68.18 45.29,73.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "35.27,68.15 35.27,56.61 45.26,50.84 55.25,56.61 55.25,68.15 45.26,73.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "35.24,68.12 35.24,56.58 45.23,50.81 55.22,56.58 55.22,68.12 45.23,73.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "35.21,68.09 35.21,56.55 45.2,50.78 55.19,56.55 55.19,68.09 45.2,73.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "35.17,68.05 35.17,56.52 45.17,50.75 55.16,56.52 55.16,68.05 45.17,73.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "35.14,68.02 35.14,56.49 45.13,50.72 55.13,56.49 55.13,68.02 45.13,73.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "35.11,67.99 35.11,56.45 45.1,50.68 55.09,56.45 55.09,67.99 45.1,73.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "35.08,67.96 35.08,56.42 45.07,50.65 55.06,56.42 55.06,67.96 45.07,73.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "35.05,67.93 35.05,56.39 45.04,50.62 55.03,56.39 55.03,67.93 45.04,73.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "35.01,67.89 35.01,56.36 45.01,50.59 55,56.36 55,67.89 45.01,73.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "34.98,67.86 34.98,56.33 44.97,50.56 54.97,56.33 54.97,67.86 44.97,73.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "34.95,67.83 34.95,56.29 44.94,50.52 54.93,56.29 54.93,67.83 44.94,73.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "34.92,67.8 34.92,56.26 44.91,50.49 54.9,56.26 54.9,67.8 44.91,73.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "34.89,67.77 34.89,56.23 44.88,50.46 54.87,56.23 54.87,67.77 44.88,73.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "34.85,67.73 34.85,56.2 44.85,50.43 54.84,56.2 54.84,67.73 44.85,73.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "34.82,67.7 34.82,56.16 44.81,50.4 54.8,56.16 54.8,67.7 44.81,73.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "34.79,67.67 34.79,56.13 44.78,50.36 54.77,56.13 54.77,67.67 44.78,73.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "34.76,67.64 34.76,56.1 44.75,50.33 54.74,56.1 54.74,67.64 44.75,73.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "34.73,67.61 34.73,56.07 44.72,50.3 54.71,56.07 54.71,67.61 44.72,73.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "34.69,67.57 34.69,56.04 44.68,50.27 54.68,56.04 54.68,67.57 44.68,73.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "34.66,67.54 34.66,56 44.65,50.24 54.64,56 54.64,67.54 44.65,73.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "34.63,67.51 34.63,55.97 44.62,50.2 54.61,55.97 54.61,67.51 44.62,73.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "34.6,67.48 34.6,55.94 44.59,50.17 54.58,55.94 54.58,67.48 44.59,73.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "34.56,67.45 34.56,55.91 44.56,50.14 54.55,55.91 54.55,67.45 44.56,73.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "34.53,67.41 34.53,55.88 44.52,50.11 54.52,55.88 54.52,67.41 44.52,73.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "34.5,67.38 34.5,55.84 44.49,50.08 54.48,55.84 54.48,67.38 44.49,73.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "34.47,67.35 34.47,55.81 44.46,50.04 54.45,55.81 54.45,67.35 44.46,73.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "34.44,67.32 34.44,55.78 44.43,50.01 54.42,55.78 54.42,67.32 44.43,73.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "34.4,67.29 34.4,55.75 44.4,49.98 54.39,55.75 54.39,67.29 44.4,73.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "34.37,67.25 34.37,55.72 44.36,49.95 54.36,55.72 54.36,67.25 44.36,73.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "34.34,67.22 34.34,55.68 44.33,49.91 54.32,55.68 54.32,67.22 44.33,72.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "34.31,67.19 34.31,55.65 44.3,49.88 54.29,55.65 54.29,67.19 44.3,72.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "34.28,67.16 34.28,55.62 44.27,49.85 54.26,55.62 54.26,67.16 44.27,72.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "34.24,67.13 34.24,55.59 44.24,49.82 54.23,55.59 54.23,67.13 44.24,72.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "34.21,67.09 34.21,55.56 44.2,49.79 54.2,55.56 54.2,67.09 44.2,72.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "34.18,67.06 34.18,55.52 44.17,49.75 54.16,55.52 54.16,67.06 44.17,72.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "34.15,67.03 34.15,55.49 44.14,49.72 54.13,55.49 54.13,67.03 44.14,72.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "34.12,67 34.12,55.46 44.11,49.69 54.1,55.46 54.1,67 44.11,72.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "34.08,66.96 34.08,55.43 44.08,49.66 54.07,55.43 54.07,66.96 44.08,72.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "34.05,66.93 34.05,55.4 44.04,49.63 54.04,55.4 54.04,66.93 44.04,72.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "34.02,66.9 34.02,55.36 44.01,49.59 54,55.36 54,66.9 44.01,72.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "33.99,66.87 33.99,55.33 43.98,49.56 53.97,55.33 53.97,66.87 43.98,72.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "33.96,66.84 33.96,55.3 43.95,49.53 53.94,55.3 53.94,66.84 43.95,72.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "33.92,66.8 33.92,55.27 43.92,49.5 53.91,55.27 53.91,66.8 43.92,72.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "33.89,66.77 33.89,55.23 43.88,49.47 53.88,55.23 53.88,66.77 43.88,72.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "33.86,66.74 33.86,55.2 43.85,49.43 53.84,55.2 53.84,66.74 43.85,72.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "33.83,66.71 33.83,55.17 43.82,49.4 53.81,55.17 53.81,66.71 43.82,72.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "33.8,66.68 33.8,55.14 43.79,49.37 53.78,55.14 53.78,66.68 43.79,72.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "33.76,66.64 33.76,55.11 43.76,49.34 53.75,55.11 53.75,66.64 43.76,72.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "33.73,66.61 33.73,55.07 43.72,49.31 53.71,55.07 53.71,66.61 43.72,72.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "33.7,66.58 33.7,55.04 43.69,49.27 53.68,55.04 53.68,66.58 43.69,72.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "33.67,66.55 33.67,55.01 43.66,49.24 53.65,55.01 53.65,66.55 43.66,72.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "33.64,66.52 33.64,54.98 43.63,49.21 53.62,54.98 53.62,66.52 43.63,72.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "33.6,66.48 33.6,54.95 43.59,49.18 53.59,54.95 53.59,66.48 43.59,72.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "33.57,66.45 33.57,54.91 43.56,49.15 53.55,54.91 53.55,66.45 43.56,72.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "33.54,66.42 33.54,54.88 43.53,49.11 53.52,54.88 53.52,66.42 43.53,72.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "33.51,66.39 33.51,54.85 43.5,49.08 53.49,54.85 53.49,66.39 43.5,72.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "33.47,66.36 33.47,54.82 43.47,49.05 53.46,54.82 53.46,66.36 43.47,72.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "33.44,66.32 33.44,54.79 43.43,49.02 53.43,54.79 53.43,66.32 43.43,72.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "33.41,66.29 33.41,54.75 43.4,48.99 53.39,54.75 53.39,66.29 43.4,72.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "33.38,66.26 33.38,54.72 43.37,48.95 53.36,54.72 53.36,66.26 43.37,72.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "33.35,66.23 33.35,54.69 43.34,48.92 53.33,54.69 53.33,66.23 43.34,72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "33.31,66.2 33.31,54.66 43.31,48.89 53.3,54.66 53.3,66.2 43.31,71.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "33.28,66.16 33.28,54.63 43.27,48.86 53.27,54.63 53.27,66.16 43.27,71.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "33.25,66.13 33.25,54.59 43.24,48.82 53.23,54.59 53.23,66.13 43.24,71.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "33.22,66.1 33.22,54.56 43.21,48.79 53.2,54.56 53.2,66.1 43.21,71.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "33.19,66.07 33.19,54.53 43.18,48.76 53.17,54.53 53.17,66.07 43.18,71.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "33.15,66.03 33.15,54.5 43.15,48.73 53.14,54.5 53.14,66.03 43.15,71.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "33.12,66 33.12,54.47 43.11,48.7 53.11,54.47 53.11,66 43.11,71.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "33.09,65.97 33.09,54.43 43.08,48.66 53.07,54.43 53.07,65.97 43.08,71.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "33.06,65.94 33.06,54.4 43.05,48.63 53.04,54.4 53.04,65.94 43.05,71.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "33.03,65.91 33.03,54.37 43.02,48.6 53.01,54.37 53.01,65.91 43.02,71.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "32.99,65.87 32.99,54.34 42.99,48.57 52.98,54.34 52.98,65.87 42.99,71.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "32.96,65.84 32.96,54.31 42.95,48.54 52.95,54.31 52.95,65.84 42.95,71.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "32.93,65.81 32.93,54.27 42.92,48.5 52.91,54.27 52.91,65.81 42.92,71.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "32.9,65.78 32.9,54.24 42.89,48.47 52.88,54.24 52.88,65.78 42.89,71.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "32.87,65.75 32.87,54.21 42.86,48.44 52.85,54.21 52.85,65.75 42.86,71.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "32.83,65.71 32.83,54.18 42.83,48.41 52.82,54.18 52.82,65.71 42.83,71.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "32.8,65.68 32.8,54.14 42.79,48.38 52.78,54.14 52.78,65.68 42.79,71.45  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029012507096650848400000007607947294381896841_",
    gradientUnits: "userSpaceOnUse",
    x1: 1649.947,
    y1: 290.9688,
    x2: 1665.7075,
    y2: 306.7292,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000029012507096650848400000007607947294381896841_)"
    },
    points: "32.8,65.68 32.8,54.14  42.79,48.38 52.78,54.14 52.78,65.68 42.79,71.45  "
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "33.01,54.42 33.01,65.8 32.8,65.68 32.8,54.14 42.79,48.38 43.14,48.57  "
  }))), /*#__PURE__*/React.createElement("g", null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "46.77,86.96 46.77,75.42 56.76,69.65 66.75,75.42 66.75,86.96 56.76,92.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "46.73,86.93 46.73,75.39 56.73,69.62 66.72,75.39 66.72,86.93 56.73,92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "46.7,86.9 46.7,75.36 56.69,69.59 66.69,75.36 66.69,86.9 56.69,92.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "46.67,86.86 46.67,75.33 56.66,69.56 66.65,75.33 66.65,86.86 56.66,92.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "46.64,86.83 46.64,75.3 56.63,69.53 66.62,75.3 66.62,86.83 56.63,92.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "46.61,86.8 46.61,75.26 56.6,69.49 66.59,75.26 66.59,86.8 56.6,92.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "46.57,86.77 46.57,75.23 56.57,69.46 66.56,75.23 66.56,86.77 56.57,92.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "46.54,86.74 46.54,75.2 56.53,69.43 66.53,75.2 66.53,86.74 56.53,92.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "46.51,86.7 46.51,75.17 56.5,69.4 66.49,75.17 66.49,86.7 56.5,92.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "46.48,86.67 46.48,75.13 56.47,69.37 66.46,75.13 66.46,86.67 56.47,92.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "46.45,86.64 46.45,75.1 56.44,69.33 66.43,75.1 66.43,86.64 56.44,92.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "46.41,86.61 46.41,75.07 56.41,69.3 66.4,75.07 66.4,86.61 56.41,92.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "46.38,86.58 46.38,75.04 56.37,69.27 66.37,75.04 66.37,86.58 56.37,92.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "46.35,86.54 46.35,75.01 56.34,69.24 66.33,75.01 66.33,86.54 56.34,92.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "46.32,86.51 46.32,74.97 56.31,69.21 66.3,74.97 66.3,86.51 56.31,92.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "46.29,86.48 46.29,74.94 56.28,69.17 66.27,74.94 66.27,86.48 56.28,92.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "46.25,86.45 46.25,74.91 56.25,69.14 66.24,74.91 66.24,86.45 56.25,92.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "46.22,86.42 46.22,74.88 56.21,69.11 66.2,74.88 66.2,86.42 56.21,92.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "46.19,86.38 46.19,74.85 56.18,69.08 66.17,74.85 66.17,86.38 56.18,92.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "46.16,86.35 46.16,74.81 56.15,69.05 66.14,74.81 66.14,86.35 56.15,92.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "46.13,86.32 46.13,74.78 56.12,69.01 66.11,74.78 66.11,86.32 56.12,92.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "46.09,86.29 46.09,74.75 56.08,68.98 66.08,74.75 66.08,86.29 56.08,92.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "46.06,86.26 46.06,74.72 56.05,68.95 66.04,74.72 66.04,86.26 56.05,92.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "46.03,86.22 46.03,74.69 56.02,68.92 66.01,74.69 66.01,86.22 56.02,91.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "46,86.19 46,74.65 55.99,68.89 65.98,74.65 65.98,86.19 55.99,91.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "45.96,86.16 45.96,74.62 55.96,68.85 65.95,74.62 65.95,86.16 55.96,91.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "45.93,86.13 45.93,74.59 55.92,68.82 65.92,74.59 65.92,86.13 55.92,91.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "45.9,86.1 45.9,74.56 55.89,68.79 65.88,74.56 65.88,86.1 55.89,91.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "45.87,86.06 45.87,74.53 55.86,68.76 65.85,74.53 65.85,86.06 55.86,91.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "45.84,86.03 45.84,74.49 55.83,68.72 65.82,74.49 65.82,86.03 55.83,91.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "45.8,86 45.8,74.46 55.8,68.69 65.79,74.46 65.79,86 55.8,91.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "45.77,85.97 45.77,74.43 55.76,68.66 65.76,74.43 65.76,85.97 55.76,91.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "45.74,85.93 45.74,74.4 55.73,68.63 65.72,74.4 65.72,85.93 55.73,91.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "45.71,85.9 45.71,74.37 55.7,68.6 65.69,74.37 65.69,85.9 55.7,91.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "45.68,85.87 45.68,74.33 55.67,68.56 65.66,74.33 65.66,85.87 55.67,91.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "45.64,85.84 45.64,74.3 55.64,68.53 65.63,74.3 65.63,85.84 55.64,91.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "45.61,85.81 45.61,74.27 55.6,68.5 65.6,74.27 65.6,85.81 55.6,91.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "45.58,85.77 45.58,74.24 55.57,68.47 65.56,74.24 65.56,85.77 55.57,91.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "45.55,85.74 45.55,74.21 55.54,68.44 65.53,74.21 65.53,85.74 55.54,91.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "45.52,85.71 45.52,74.17 55.51,68.4 65.5,74.17 65.5,85.71 55.51,91.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "45.48,85.68 45.48,74.14 55.48,68.37 65.47,74.14 65.47,85.68 55.48,91.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "45.45,85.65 45.45,74.11 55.44,68.34 65.44,74.11 65.44,85.65 55.44,91.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "45.42,85.61 45.42,74.08 55.41,68.31 65.4,74.08 65.4,85.61 55.41,91.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "45.39,85.58 45.39,74.04 55.38,68.28 65.37,74.04 65.37,85.58 55.38,91.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "45.36,85.55 45.36,74.01 55.35,68.24 65.34,74.01 65.34,85.55 55.35,91.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "45.32,85.52 45.32,73.98 55.32,68.21 65.31,73.98 65.31,85.52 55.32,91.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "45.29,85.49 45.29,73.95 55.28,68.18 65.28,73.95 65.28,85.49 55.28,91.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "45.26,85.45 45.26,73.92 55.25,68.15 65.24,73.92 65.24,85.45 55.25,91.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "45.23,85.42 45.23,73.88 55.22,68.12 65.21,73.88 65.21,85.42 55.22,91.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "45.2,85.39 45.2,73.85 55.19,68.08 65.18,73.85 65.18,85.39 55.19,91.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "45.16,85.36 45.16,73.82 55.16,68.05 65.15,73.82 65.15,85.36 55.16,91.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "45.13,85.33 45.13,73.79 55.12,68.02 65.11,73.79 65.11,85.33 55.12,91.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "45.1,85.29 45.1,73.76 55.09,67.99 65.08,73.76 65.08,85.29 55.09,91.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "45.07,85.26 45.07,73.72 55.06,67.96 65.05,73.72 65.05,85.26 55.06,91.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "45.04,85.23 45.04,73.69 55.03,67.92 65.02,73.69 65.02,85.23 55.03,91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "45,85.2 45,73.66 54.99,67.89 64.99,73.66 64.99,85.2 54.99,90.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "44.97,85.17 44.97,73.63 54.96,67.86 64.95,73.63 64.95,85.17 54.96,90.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "44.94,85.13 44.94,73.6 54.93,67.83 64.92,73.6 64.92,85.13 54.93,90.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "44.91,85.1 44.91,73.56 54.9,67.8 64.89,73.56 64.89,85.1 54.9,90.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "44.87,85.07 44.87,73.53 54.87,67.76 64.86,73.53 64.86,85.07 54.87,90.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "44.84,85.04 44.84,73.5 54.83,67.73 64.83,73.5 64.83,85.04 54.83,90.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "44.81,85 44.81,73.47 54.8,67.7 64.79,73.47 64.79,85 54.8,90.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "44.78,84.97 44.78,73.44 54.77,67.67 64.76,73.44 64.76,84.97 54.77,90.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "44.75,84.94 44.75,73.4 54.74,67.63 64.73,73.4 64.73,84.94 54.74,90.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "44.71,84.91 44.71,73.37 54.71,67.6 64.7,73.37 64.7,84.91 54.71,90.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "44.68,84.88 44.68,73.34 54.67,67.57 64.67,73.34 64.67,84.88 54.67,90.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "44.65,84.84 44.65,73.31 54.64,67.54 64.63,73.31 64.63,84.84 54.64,90.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "44.62,84.81 44.62,73.28 54.61,67.51 64.6,73.28 64.6,84.81 54.61,90.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "44.59,84.78 44.59,73.24 54.58,67.47 64.57,73.24 64.57,84.78 54.58,90.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "44.55,84.75 44.55,73.21 54.55,67.44 64.54,73.21 64.54,84.75 54.55,90.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "44.52,84.72 44.52,73.18 54.51,67.41 64.51,73.18 64.51,84.72 54.51,90.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "44.49,84.68 44.49,73.15 54.48,67.38 64.47,73.15 64.47,84.68 54.48,90.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "44.46,84.65 44.46,73.11 54.45,67.35 64.44,73.11 64.44,84.65 54.45,90.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "44.43,84.62 44.43,73.08 54.42,67.31 64.41,73.08 64.41,84.62 54.42,90.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "44.39,84.59 44.39,73.05 54.39,67.28 64.38,73.05 64.38,84.59 54.39,90.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "44.36,84.56 44.36,73.02 54.35,67.25 64.35,73.02 64.35,84.56 54.35,90.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "44.33,84.52 44.33,72.99 54.32,67.22 64.31,72.99 64.31,84.52 54.32,90.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "44.3,84.49 44.3,72.95 54.29,67.19 64.28,72.95 64.28,84.49 54.29,90.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "44.27,84.46 44.27,72.92 54.26,67.15 64.25,72.92 64.25,84.46 54.26,90.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "44.23,84.43 44.23,72.89 54.23,67.12 64.22,72.89 64.22,84.43 54.23,90.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "44.2,84.4 44.2,72.86 54.19,67.09 64.18,72.86 64.18,84.4 54.19,90.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "44.17,84.36 44.17,72.83 54.16,67.06 64.15,72.83 64.15,84.36 54.16,90.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "44.14,84.33 44.14,72.79 54.13,67.03 64.12,72.79 64.12,84.33 54.13,90.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "44.11,84.3 44.11,72.76 54.1,66.99 64.09,72.76 64.09,84.3 54.1,90.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "44.07,84.27 44.07,72.73 54.06,66.96 64.06,72.73 64.06,84.27 54.06,90.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "44.04,84.24 44.04,72.7 54.03,66.93 64.02,72.7 64.02,84.24 54.03,90  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "44.01,84.2 44.01,72.67 54,66.9 63.99,72.67 63.99,84.2 54,89.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "43.98,84.17 43.98,72.63 53.97,66.87 63.96,72.63 63.96,84.17 53.97,89.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "43.95,84.14 43.95,72.6 53.94,66.83 63.93,72.6 63.93,84.14 53.94,89.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "43.91,84.11 43.91,72.57 53.9,66.8 63.9,72.57 63.9,84.11 53.9,89.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "43.88,84.08 43.88,72.54 53.87,66.77 63.86,72.54 63.86,84.08 53.87,89.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "43.85,84.04 43.85,72.51 53.84,66.74 63.83,72.51 63.83,84.04 53.84,89.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "43.82,84.01 43.82,72.47 53.81,66.7 63.8,72.47 63.8,84.01 53.81,89.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "43.78,83.98 43.78,72.44 53.78,66.67 63.77,72.44 63.77,83.98 53.78,89.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "43.75,83.95 43.75,72.41 53.74,66.64 63.74,72.41 63.74,83.95 53.74,89.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "43.72,83.91 43.72,72.38 53.71,66.61 63.7,72.38 63.7,83.91 53.71,89.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "43.69,83.88 43.69,72.35 53.68,66.58 63.67,72.35 63.67,83.88 53.68,89.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "43.66,83.85 43.66,72.31 53.65,66.54 63.64,72.31 63.64,83.85 53.65,89.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "43.62,83.82 43.62,72.28 53.62,66.51 63.61,72.28 63.61,83.82 53.62,89.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "43.59,83.79 43.59,72.25 53.58,66.48 63.58,72.25 63.58,83.79 53.58,89.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "43.56,83.75 43.56,72.22 53.55,66.45 63.54,72.22 63.54,83.75 53.55,89.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "43.53,83.72 43.53,72.19 53.52,66.42 63.51,72.19 63.51,83.72 53.52,89.49  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121990148335374123040000015350715747487221889_",
    gradientUnits: "userSpaceOnUse",
    x1: 1667.9874,
    y1: 301.6955,
    x2: 1683.7478,
    y2: 317.4559,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000121990148335374123040000015350715747487221889_)"
    },
    points: "43.53,83.72 43.53,72.19  53.52,66.42 63.51,72.19 63.51,83.72 53.52,89.49  "
  }), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "43.73,72.46 43.73,83.84 43.53,83.72 43.53,72.19 53.52,66.42 53.86,66.61  "
  }))), /*#__PURE__*/React.createElement("g", null, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "25.4,123.28 25.4,111.74 35.39,105.97 45.38,111.74 45.38,123.28 35.39,129.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "25.36,123.25 25.36,111.71 35.36,105.94 45.35,111.71 45.35,123.25 35.36,129.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "25.33,123.21 25.33,111.68 35.32,105.91 45.32,111.68 45.32,123.21 35.32,128.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "25.3,123.18 25.3,111.64 35.29,105.88 45.28,111.64 45.28,123.18 35.29,128.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "25.27,123.15 25.27,111.61 35.26,105.84 45.25,111.61 45.25,123.15 35.26,128.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "25.24,123.12 25.24,111.58 35.23,105.81 45.22,111.58 45.22,123.12 35.23,128.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "25.2,123.09 25.2,111.55 35.2,105.78 45.19,111.55 45.19,123.09 35.2,128.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "25.17,123.05 25.17,111.52 35.16,105.75 45.16,111.52 45.16,123.05 35.16,128.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "25.14,123.02 25.14,111.48 35.13,105.72 45.12,111.48 45.12,123.02 35.13,128.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "25.11,122.99 25.11,111.45 35.1,105.68 45.09,111.45 45.09,122.99 35.1,128.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "25.08,122.96 25.08,111.42 35.07,105.65 45.06,111.42 45.06,122.96 35.07,128.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "25.04,122.93 25.04,111.39 35.04,105.62 45.03,111.39 45.03,122.93 35.04,128.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "25.01,122.89 25.01,111.36 35,105.59 45,111.36 45,122.89 35,128.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "24.98,122.86 24.98,111.32 34.97,105.56 44.96,111.32 44.96,122.86 34.97,128.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "24.95,122.83 24.95,111.29 34.94,105.52 44.93,111.29 44.93,122.83 34.94,128.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "24.92,122.8 24.92,111.26 34.91,105.49 44.9,111.26 44.9,122.8 34.91,128.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "24.88,122.76 24.88,111.23 34.88,105.46 44.87,111.23 44.87,122.76 34.88,128.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "24.85,122.73 24.85,111.2 34.84,105.43 44.84,111.2 44.84,122.73 34.84,128.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "24.82,122.7 24.82,111.16 34.81,105.39 44.8,111.16 44.8,122.7 34.81,128.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "24.79,122.67 24.79,111.13 34.78,105.36 44.77,111.13 44.77,122.67 34.78,128.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "24.76,122.64 24.76,111.1 34.75,105.33 44.74,111.1 44.74,122.64 34.75,128.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "24.72,122.6 24.72,111.07 34.72,105.3 44.71,111.07 44.71,122.6 34.72,128.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "24.69,122.57 24.69,111.04 34.68,105.27 44.67,111.04 44.67,122.57 34.68,128.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "24.66,122.54 24.66,111 34.65,105.23 44.64,111 44.64,122.54 34.65,128.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "24.63,122.51 24.63,110.97 34.62,105.2 44.61,110.97 44.61,122.51 34.62,128.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "24.6,122.48 24.6,110.94 34.59,105.17 44.58,110.94 44.58,122.48 34.59,128.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "24.56,122.44 24.56,110.91 34.55,105.14 44.55,110.91 44.55,122.44 34.55,128.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "24.53,122.41 24.53,110.87 34.52,105.11 44.51,110.87 44.51,122.41 34.52,128.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "24.5,122.38 24.5,110.84 34.49,105.07 44.48,110.84 44.48,122.38 34.49,128.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "24.47,122.35 24.47,110.81 34.46,105.04 44.45,110.81 44.45,122.35 34.46,128.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "24.43,122.32 24.43,110.78 34.43,105.01 44.42,110.78 44.42,122.32 34.43,128.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "24.4,122.28 24.4,110.75 34.39,104.98 44.39,110.75 44.39,122.28 34.39,128.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "24.37,122.25 24.37,110.71 34.36,104.95 44.35,110.71 44.35,122.25 34.36,128.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "24.34,122.22 24.34,110.68 34.33,104.91 44.32,110.68 44.32,122.22 34.33,127.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "24.31,122.19 24.31,110.65 34.3,104.88 44.29,110.65 44.29,122.19 34.3,127.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "24.27,122.16 24.27,110.62 34.27,104.85 44.26,110.62 44.26,122.16 34.27,127.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "24.24,122.12 24.24,110.59 34.23,104.82 44.23,110.59 44.23,122.12 34.23,127.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "24.21,122.09 24.21,110.55 34.2,104.79 44.19,110.55 44.19,122.09 34.2,127.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "24.18,122.06 24.18,110.52 34.17,104.75 44.16,110.52 44.16,122.06 34.17,127.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "24.15,122.03 24.15,110.49 34.14,104.72 44.13,110.49 44.13,122.03 34.14,127.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "24.11,122 24.11,110.46 34.11,104.69 44.1,110.46 44.1,122 34.11,127.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "24.08,121.96 24.08,110.43 34.07,104.66 44.07,110.43 44.07,121.96 34.07,127.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "24.05,121.93 24.05,110.39 34.04,104.63 44.03,110.39 44.03,121.93 34.04,127.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "24.02,121.9 24.02,110.36 34.01,104.59 44,110.36 44,121.9 34.01,127.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "23.99,121.87 23.99,110.33 33.98,104.56 43.97,110.33 43.97,121.87 33.98,127.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "23.95,121.84 23.95,110.3 33.95,104.53 43.94,110.3 43.94,121.84 33.95,127.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "23.92,121.8 23.92,110.27 33.91,104.5 43.91,110.27 43.91,121.8 33.91,127.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "23.89,121.77 23.89,110.23 33.88,104.46 43.87,110.23 43.87,121.77 33.88,127.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "23.86,121.74 23.86,110.2 33.85,104.43 43.84,110.2 43.84,121.74 33.85,127.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "23.83,121.71 23.83,110.17 33.82,104.4 43.81,110.17 43.81,121.71 33.82,127.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "23.79,121.67 23.79,110.14 33.79,104.37 43.78,110.14 43.78,121.67 33.79,127.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "23.76,121.64 23.76,110.11 33.75,104.34 43.75,110.11 43.75,121.64 33.75,127.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "23.73,121.61 23.73,110.07 33.72,104.3 43.71,110.07 43.71,121.61 33.72,127.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "23.7,121.58 23.7,110.04 33.69,104.27 43.68,110.04 43.68,121.58 33.69,127.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "23.67,121.55 23.67,110.01 33.66,104.24 43.65,110.01 43.65,121.55 33.66,127.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "23.63,121.51 23.63,109.98 33.63,104.21 43.62,109.98 43.62,121.51 33.63,127.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "23.6,121.48 23.6,109.95 33.59,104.18 43.58,109.95 43.58,121.48 33.59,127.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "23.57,121.45 23.57,109.91 33.56,104.14 43.55,109.91 43.55,121.45 33.56,127.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "23.54,121.42 23.54,109.88 33.53,104.11 43.52,109.88 43.52,121.42 33.53,127.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "23.51,121.39 23.51,109.85 33.5,104.08 43.49,109.85 43.49,121.39 33.5,127.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "23.47,121.35 23.47,109.82 33.46,104.05 43.46,109.82 43.46,121.35 33.46,127.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "23.44,121.32 23.44,109.78 33.43,104.02 43.42,109.78 43.42,121.32 33.43,127.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "23.41,121.29 23.41,109.75 33.4,103.98 43.39,109.75 43.39,121.29 33.4,127.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "23.38,121.26 23.38,109.72 33.37,103.95 43.36,109.72 43.36,121.26 33.37,127.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "23.34,121.23 23.34,109.69 33.34,103.92 43.33,109.69 43.33,121.23 33.34,126.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "23.31,121.19 23.31,109.66 33.3,103.89 43.3,109.66 43.3,121.19 33.3,126.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "23.28,121.16 23.28,109.62 33.27,103.86 43.26,109.62 43.26,121.16 33.27,126.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "23.25,121.13 23.25,109.59 33.24,103.82 43.23,109.59 43.23,121.13 33.24,126.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "23.22,121.1 23.22,109.56 33.21,103.79 43.2,109.56 43.2,121.1 33.21,126.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "23.18,121.07 23.18,109.53 33.18,103.76 43.17,109.53 43.17,121.07 33.18,126.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "23.15,121.03 23.15,109.5 33.14,103.73 43.14,109.5 43.14,121.03 33.14,126.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "23.12,121 23.12,109.46 33.11,103.7 43.1,109.46 43.1,121 33.11,126.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "23.09,120.97 23.09,109.43 33.08,103.66 43.07,109.43 43.07,120.97 33.08,126.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "23.06,120.94 23.06,109.4 33.05,103.63 43.04,109.4 43.04,120.94 33.05,126.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "23.02,120.91 23.02,109.37 33.02,103.6 43.01,109.37 43.01,120.91 33.02,126.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "22.99,120.87 22.99,109.34 32.98,103.57 42.98,109.34 42.98,120.87 32.98,126.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "22.96,120.84 22.96,109.3 32.95,103.54 42.94,109.3 42.94,120.84 32.95,126.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "22.93,120.81 22.93,109.27 32.92,103.5 42.91,109.27 42.91,120.81 32.92,126.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "22.9,120.78 22.9,109.24 32.89,103.47 42.88,109.24 42.88,120.78 32.89,126.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "22.86,120.75 22.86,109.21 32.86,103.44 42.85,109.21 42.85,120.75 32.86,126.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "22.83,120.71 22.83,109.18 32.82,103.41 42.82,109.18 42.82,120.71 32.82,126.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "22.8,120.68 22.8,109.14 32.79,103.37 42.78,109.14 42.78,120.68 32.79,126.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "22.77,120.65 22.77,109.11 32.76,103.34 42.75,109.11 42.75,120.65 32.76,126.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "22.74,120.62 22.74,109.08 32.73,103.31 42.72,109.08 42.72,120.62 32.73,126.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "22.7,120.58 22.7,109.05 32.7,103.28 42.69,109.05 42.69,120.58 32.7,126.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "22.67,120.55 22.67,109.02 32.66,103.25 42.65,109.02 42.65,120.55 32.66,126.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "22.64,120.52 22.64,108.98 32.63,103.21 42.62,108.98 42.62,120.52 32.63,126.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "22.61,120.49 22.61,108.95 32.6,103.18 42.59,108.95 42.59,120.49 32.6,126.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "22.58,120.46 22.58,108.92 32.57,103.15 42.56,108.92 42.56,120.46 32.57,126.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "22.54,120.42 22.54,108.89 32.53,103.12 42.53,108.89 42.53,120.42 32.53,126.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "22.51,120.39 22.51,108.85 32.5,103.09 42.49,108.85 42.49,120.39 32.5,126.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "22.48,120.36 22.48,108.82 32.47,103.05 42.46,108.82 42.46,120.36 32.47,126.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "22.45,120.33 22.45,108.79 32.44,103.02 42.43,108.79 42.43,120.33 32.44,126.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "22.42,120.3 22.42,108.76 32.41,102.99 42.4,108.76 42.4,120.3 32.41,126.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "22.38,120.26 22.38,108.73 32.37,102.96 42.37,108.73 42.37,120.26 32.37,126.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "22.35,120.23 22.35,108.69 32.34,102.93 42.33,108.69 42.33,120.23 32.34,126  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "22.32,120.2 22.32,108.66 32.31,102.89 42.3,108.66 42.3,120.2 32.31,125.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "22.29,120.17 22.29,108.63 32.28,102.86 42.27,108.63 42.27,120.17 32.28,125.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "22.25,120.14 22.25,108.6 32.25,102.83 42.24,108.6 42.24,120.14 32.25,125.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "22.22,120.1 22.22,108.57 32.21,102.8 42.21,108.57 42.21,120.1 32.21,125.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "22.19,120.07 22.19,108.53 32.18,102.77 42.17,108.53 42.17,120.07 32.18,125.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "22.16,120.04 22.16,108.5 32.15,102.73 42.14,108.5 42.14,120.04 32.15,125.81  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178170281688787494630000018244509004198355344_",
    gradientUnits: "userSpaceOnUse",
    x1: 1704.3046,
    y1: 280.3258,
    x2: 1720.0649,
    y2: 296.0862,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000178170281688787494630000018244509004198355344_)"
    },
    points: "22.16,120.04 22.16,108.5  32.15,102.73 42.14,108.5 42.14,120.04 32.15,125.81  "
  }), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "22.36,108.78 22.36,120.16 22.16,120.04 22.16,108.5 32.15,102.73 32.49,102.93  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160177605204130940570000006203582381421126320_",
    gradientUnits: "userSpaceOnUse",
    x1: 1741.3136,
    y1: 497.6737,
    x2: 1757.074,
    y2: 513.4341,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000160177605204130940570000006203582381421126320_)"
    },
    points: "239.51,157.05 239.51,145.51  249.5,139.74 259.49,145.51 259.49,157.05 249.5,162.82  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042005985876513853500000003957835708720632255_",
    gradientUnits: "userSpaceOnUse",
    x1: 1741.3136,
    y1: 476.3814,
    x2: 1757.074,
    y2: 492.1417,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000042005985876513853500000003957835708720632255_)"
    },
    points: "218.21,157.05 218.21,145.51  228.21,139.74 238.2,145.51 238.2,157.05 228.21,162.82  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096048664545394900940000012542917375565679530_",
    gradientUnits: "userSpaceOnUse",
    x1: 1759.4056,
    y1: 486.893,
    x2: 1775.1661,
    y2: 502.6534,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000096048664545394900940000012542917375565679530_)"
    },
    points: "228.73,175.14 228.73,163.6  238.72,157.83 248.71,163.6 248.71,175.14 238.72,180.91  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085217691179826062830000007700637638164935357_",
    gradientUnits: "userSpaceOnUse",
    x1: 1759.4056,
    y1: 465.7082,
    x2: 1775.1661,
    y2: 481.4686,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000085217691179826062830000007700637638164935357_)"
    },
    points: "207.54,175.14 207.54,163.6  217.53,157.83 227.52,163.6 227.52,175.14 217.53,180.91  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040546648864273116980000008823016375749798800_",
    gradientUnits: "userSpaceOnUse",
    x1: 1741.3136,
    y1: 454.8562,
    x2: 1757.074,
    y2: 470.6166,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000040546648864273116980000008823016375749798800_)"
    },
    points: "196.69,157.05 196.69,145.51  206.68,139.74 216.67,145.51 216.67,157.05 206.68,162.82  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154411442653118790430000008283034704636681626_",
    gradientUnits: "userSpaceOnUse",
    x1: 1759.4058,
    y1: 444.1831,
    x2: 1775.166,
    y2: 459.9434,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000154411442653118790430000008283034704636681626_)"
    },
    points: "186.02,175.14 186.02,163.6  196.01,157.83 206,163.6 206,175.14 196.01,180.91  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013905922953733322580000011136061884660965519_",
    gradientUnits: "userSpaceOnUse",
    x1: 1759.4058,
    y1: 422.4606,
    x2: 1775.1661,
    y2: 438.2209,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000013905922953733322580000011136061884660965519_)"
    },
    points: "164.29,175.14 164.29,163.6  174.29,157.83 184.28,163.6 184.28,175.14 174.29,180.91  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102530091006307800150000011915057419369356986_",
    gradientUnits: "userSpaceOnUse",
    x1: 1759.4056,
    y1: 508.3734,
    x2: 1775.1661,
    y2: 524.1338,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000102530091006307800150000011915057419369356986_)"
    },
    points: "250.21,175.14 250.21,163.6  260.2,157.83 270.19,163.6 270.19,175.14 260.2,180.91  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036945795477663067560000013976514832358796178_",
    gradientUnits: "userSpaceOnUse",
    x1: 1686.9594,
    y1: 508.3734,
    x2: 1702.7198,
    y2: 524.1338,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000036945795477663067560000013976514832358796178_)"
    },
    points: "250.21,102.69 250.21,91.16  260.2,85.39 270.19,91.16 270.19,102.69 260.2,108.46  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148633214111164274710000005145033415848293769_",
    gradientUnits: "userSpaceOnUse",
    x1: 1704.9403,
    y1: 476.3096,
    x2: 1720.7007,
    y2: 492.07,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000148633214111164274710000005145033415848293769_)"
    },
    points: "218.14,120.68 218.14,109.14  228.13,103.37 238.13,109.14 238.13,120.68 228.13,126.44  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181072056144889682930000017446294437466733230_",
    gradientUnits: "userSpaceOnUse",
    x1: 1723.2732,
    y1: 487.0364,
    x2: 1739.0336,
    y2: 502.7967,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000181072056144889682930000017446294437466733230_)"
    },
    points: "228.87,139.01 228.87,127.47  238.86,121.7 248.85,127.47 248.85,139.01 238.86,144.78  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053510681678472454490000014666003675662260867_",
    gradientUnits: "userSpaceOnUse",
    x1: 1723.2732,
    y1: 508.5797,
    x2: 1739.0336,
    y2: 524.34,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000053510681678472454490000014666003675662260867_)"
    },
    points: "250.41,139.01 250.41,127.47  260.4,121.7 270.4,127.47 270.4,139.01 260.4,144.78  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116914027655979214060000012586333661657027741_",
    gradientUnits: "userSpaceOnUse",
    x1: 1668.7728,
    y1: 454.8562,
    x2: 1684.5332,
    y2: 470.6166,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000116914027655979214060000012586333661657027741_)"
    },
    points: "196.69,84.51 196.69,72.97  206.68,67.2 216.67,72.97 216.67,84.51 206.68,90.28  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155121451924282585210000007325763613632059299_",
    gradientUnits: "userSpaceOnUse",
    x1: 1632.6052,
    y1: 476.3096,
    x2: 1648.3656,
    y2: 492.07,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000155121451924282585210000007325763613632059299_)"
    },
    points: "218.14,48.34 218.14,36.8  228.13,31.03 238.13,36.8 238.13,48.34 228.13,54.11  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036226667234912463780000006661805044791699382_",
    gradientUnits: "userSpaceOnUse",
    x1: 1704.9403,
    y1: 497.7631,
    x2: 1720.7007,
    y2: 513.5234,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000036226667234912463780000006661805044791699382_)"
    },
    points: "239.6,120.68 239.6,109.14  249.59,103.37 259.58,109.14 259.58,120.68 249.59,126.44  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073713430299215048120000010668937804995175821_",
    gradientUnits: "userSpaceOnUse",
    x1: 1668.7728,
    y1: 497.7631,
    x2: 1684.5332,
    y2: 513.5234,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000073713430299215048120000010668937804995175821_)"
    },
    points: "239.6,84.51 239.6,72.97  249.59,67.2 259.58,72.97 259.58,84.51 249.59,90.28  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170980958930560631530000011304589104963772331_",
    gradientUnits: "userSpaceOnUse",
    x1: 1632.6052,
    y1: 497.7631,
    x2: 1648.3656,
    y2: 513.5234,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000170980958930560631530000011304589104963772331_)"
    },
    points: "239.6,48.34 239.6,36.8  249.59,31.03 259.58,36.8 259.58,48.34 249.59,54.11  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103946355314979777740000005295556388530626963_",
    gradientUnits: "userSpaceOnUse",
    x1: 1687.1057,
    y1: 487.0364,
    x2: 1702.8661,
    y2: 502.7967,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000103946355314979777740000005295556388530626963_)"
    },
    points: "228.87,102.84 228.87,91.3  238.86,85.53 248.85,91.3 248.85,102.84 238.86,108.61  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037651977989956877350000007018707616479321271_",
    gradientUnits: "userSpaceOnUse",
    x1: 1651.0375,
    y1: 487.0364,
    x2: 1666.7977,
    y2: 502.7967,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000037651977989956877350000007018707616479321271_)"
    },
    points: "228.87,66.77 228.87,55.24  238.86,49.47 248.85,55.24 248.85,66.77 238.86,72.54  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116220139531775804250000005233159340372370354_",
    gradientUnits: "userSpaceOnUse",
    x1: 1651.0374,
    y1: 465.5829,
    x2: 1666.7979,
    y2: 481.3433,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000116220139531775804250000005233159340372370354_)"
    },
    points: "207.42,66.77 207.42,55.24  217.41,49.47 227.4,55.24 227.4,66.77 217.41,72.54  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131360353178993233290000006579787552762170526_",
    gradientUnits: "userSpaceOnUse",
    x1: 1595.7133,
    y1: 476.3096,
    x2: 1611.4738,
    y2: 492.07,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000131360353178993233290000006579787552762170526_)"
    },
    points: "218.14,11.45 218.14,-0.09  228.13,-5.86 238.13,-0.09 238.13,11.45 228.13,17.22  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093872072458463037040000008782613448198360454_",
    gradientUnits: "userSpaceOnUse",
    x1: 1595.7134,
    y1: 497.7631,
    x2: 1611.4736,
    y2: 513.5234,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000093872072458463037040000008782613448198360454_)"
    },
    points: "239.6,11.45 239.6,-0.09  249.59,-5.86 259.58,-0.09 259.58,11.45 249.59,17.22  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078739364910900033510000014197769593017307800_",
    gradientUnits: "userSpaceOnUse",
    x1: 1741.3136,
    y1: 519.2165,
    x2: 1757.074,
    y2: 534.9769,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000078739364910900033510000014197769593017307800_)"
    },
    points: "261.05,157.05 261.05,145.51  271.04,139.74 281.03,145.51 281.03,157.05 271.04,162.82  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043447067226458910620000010805856572807529140_",
    gradientUnits: "userSpaceOnUse",
    x1: 1704.9403,
    y1: 519.3058,
    x2: 1720.7007,
    y2: 535.0662,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000043447067226458910620000010805856572807529140_)"
    },
    points: "261.14,120.68 261.14,109.14  271.13,103.37 281.12,109.14 281.12,120.68 271.13,126.44  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152237782477668584520000009080456061706842025_",
    gradientUnits: "userSpaceOnUse",
    x1: 1668.7728,
    y1: 519.3058,
    x2: 1684.5332,
    y2: 535.0662,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000152237782477668584520000009080456061706842025_)"
    },
    points: "261.14,84.51 261.14,72.97  271.13,67.2 281.12,72.97 281.12,84.51 271.13,90.28  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113313866429544585750000015279417053809209488_",
    gradientUnits: "userSpaceOnUse",
    x1: 1632.6052,
    y1: 519.3058,
    x2: 1648.3656,
    y2: 535.0662,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000113313866429544585750000015279417053809209488_)"
    },
    points: "261.14,48.34 261.14,36.8  271.13,31.03 281.12,36.8 281.12,48.34 271.13,54.11  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071522549291221373490000005025033738042260399_",
    gradientUnits: "userSpaceOnUse",
    x1: 1595.7133,
    y1: 519.3058,
    x2: 1611.4738,
    y2: 535.0662,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000071522549291221373490000005025033738042260399_)"
    },
    points: "261.14,11.45 261.14,-0.09  271.13,-5.86 281.12,-0.09 281.12,11.45 271.13,17.22  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047746932889571736340000016272057182381582260_",
    gradientUnits: "userSpaceOnUse",
    x1: 1614.1455,
    y1: 487.0364,
    x2: 1629.9059,
    y2: 502.7967,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000047746932889571736340000016272057182381582260_)"
    },
    points: "228.87,29.88 228.87,18.34  238.86,12.57 248.85,18.34 248.85,29.88 238.86,35.65  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062871713682015203920000005203856336404964254_",
    gradientUnits: "userSpaceOnUse",
    x1: 1651.0375,
    y1: 508.4898,
    x2: 1666.7977,
    y2: 524.2501,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000062871713682015203920000005203856336404964254_)"
    },
    points: "250.32,66.77 250.32,55.24  260.31,49.47 270.31,55.24 270.31,66.77 260.31,72.54  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083779536568088117530000001279089492213120922_",
    gradientUnits: "userSpaceOnUse",
    x1: 1614.1455,
    y1: 508.4898,
    x2: 1629.9059,
    y2: 524.2501,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000083779536568088117530000001279089492213120922_)"
    },
    points: "250.32,29.88 250.32,18.34  260.31,12.57 270.31,18.34 270.31,29.88 260.31,35.65  "
  }), /*#__PURE__*/React.createElement("g", null, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "178.56,123.91 178.56,112.38 188.55,106.61 198.54,112.38 198.54,123.91 188.55,129.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "178.53,123.88 178.53,112.34 188.52,106.58 198.51,112.34 198.51,123.88 188.52,129.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "178.49,123.85 178.49,112.31 188.49,106.54 198.48,112.31 198.48,123.85 188.49,129.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "178.46,123.82 178.46,112.28 188.45,106.51 198.44,112.28 198.44,123.82 188.45,129.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "178.43,123.79 178.43,112.25 188.42,106.48 198.41,112.25 198.41,123.79 188.42,129.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "178.4,123.75 178.4,112.22 188.39,106.45 198.38,112.22 198.38,123.75 188.39,129.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "178.37,123.72 178.37,112.18 188.36,106.42 198.35,112.18 198.35,123.72 188.36,129.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "178.33,123.69 178.33,112.15 188.32,106.38 198.32,112.15 198.32,123.69 188.32,129.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "178.3,123.66 178.3,112.12 188.29,106.35 198.28,112.12 198.28,123.66 188.29,129.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "178.27,123.63 178.27,112.09 188.26,106.32 198.25,112.09 198.25,123.63 188.26,129.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "178.24,123.59 178.24,112.06 188.23,106.29 198.22,112.06 198.22,123.59 188.23,129.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "178.2,123.56 178.2,112.02 188.2,106.25 198.19,112.02 198.19,123.56 188.2,129.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "178.17,123.53 178.17,111.99 188.16,106.22 198.16,111.99 198.16,123.53 188.16,129.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "178.14,123.5 178.14,111.96 188.13,106.19 198.12,111.96 198.12,123.5 188.13,129.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "178.11,123.46 178.11,111.93 188.1,106.16 198.09,111.93 198.09,123.46 188.1,129.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "178.08,123.43 178.08,111.9 188.07,106.13 198.06,111.9 198.06,123.43 188.07,129.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "178.04,123.4 178.04,111.86 188.04,106.09 198.03,111.86 198.03,123.4 188.04,129.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "178.01,123.37 178.01,111.83 188,106.06 198,111.83 198,123.37 188,129.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "177.98,123.34 177.98,111.8 187.97,106.03 197.96,111.8 197.96,123.34 187.97,129.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "177.95,123.3 177.95,111.77 187.94,106 197.93,111.77 197.93,123.3 187.94,129.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "177.92,123.27 177.92,111.74 187.91,105.97 197.9,111.74 197.9,123.27 187.91,129.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "177.88,123.24 177.88,111.7 187.88,105.93 197.87,111.7 197.87,123.24 187.88,129.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "177.85,123.21 177.85,111.67 187.84,105.9 197.84,111.67 197.84,123.21 187.84,128.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "177.82,123.18 177.82,111.64 187.81,105.87 197.8,111.64 197.8,123.18 187.81,128.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "177.79,123.14 177.79,111.61 187.78,105.84 197.77,111.61 197.77,123.14 187.78,128.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "177.76,123.11 177.76,111.57 187.75,105.81 197.74,111.57 197.74,123.11 187.75,128.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "177.72,123.08 177.72,111.54 187.72,105.77 197.71,111.54 197.71,123.08 187.72,128.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "177.69,123.05 177.69,111.51 187.68,105.74 197.68,111.51 197.68,123.05 187.68,128.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "177.66,123.02 177.66,111.48 187.65,105.71 197.64,111.48 197.64,123.02 187.65,128.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "177.63,122.98 177.63,111.45 187.62,105.68 197.61,111.45 197.61,122.98 187.62,128.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "177.6,122.95 177.6,111.41 187.59,105.65 197.58,111.41 197.58,122.95 187.59,128.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "177.56,122.92 177.56,111.38 187.56,105.61 197.55,111.38 197.55,122.92 187.56,128.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "177.53,122.89 177.53,111.35 187.52,105.58 197.51,111.35 197.51,122.89 187.52,128.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "177.5,122.86 177.5,111.32 187.49,105.55 197.48,111.32 197.48,122.86 187.49,128.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "177.47,122.82 177.47,111.29 187.46,105.52 197.45,111.29 197.45,122.82 187.46,128.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "177.44,122.79 177.44,111.25 187.43,105.49 197.42,111.25 197.42,122.79 187.43,128.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "177.4,122.76 177.4,111.22 187.39,105.45 197.39,111.22 197.39,122.76 187.39,128.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "177.37,122.73 177.37,111.19 187.36,105.42 197.35,111.19 197.35,122.73 187.36,128.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "177.34,122.7 177.34,111.16 187.33,105.39 197.32,111.16 197.32,122.7 187.33,128.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "177.31,122.66 177.31,111.13 187.3,105.36 197.29,111.13 197.29,122.66 187.3,128.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "177.28,122.63 177.28,111.09 187.27,105.33 197.26,111.09 197.26,122.63 187.27,128.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "177.24,122.6 177.24,111.06 187.23,105.29 197.23,111.06 197.23,122.6 187.23,128.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "177.21,122.57 177.21,111.03 187.2,105.26 197.19,111.03 197.19,122.57 187.2,128.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "177.18,122.54 177.18,111 187.17,105.23 197.16,111 197.16,122.54 187.17,128.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "177.15,122.5 177.15,110.97 187.14,105.2 197.13,110.97 197.13,122.5 187.14,128.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "177.11,122.47 177.11,110.93 187.11,105.16 197.1,110.93 197.1,122.47 187.11,128.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "177.08,122.44 177.08,110.9 187.07,105.13 197.07,110.9 197.07,122.44 187.07,128.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "177.05,122.41 177.05,110.87 187.04,105.1 197.03,110.87 197.03,122.41 187.04,128.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "177.02,122.37 177.02,110.84 187.01,105.07 197,110.84 197,122.37 187.01,128.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "176.99,122.34 176.99,110.81 186.98,105.04 196.97,110.81 196.97,122.34 186.98,128.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "176.95,122.31 176.95,110.77 186.95,105 196.94,110.77 196.94,122.31 186.95,128.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "176.92,122.28 176.92,110.74 186.91,104.97 196.91,110.74 196.91,122.28 186.91,128.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "176.89,122.25 176.89,110.71 186.88,104.94 196.87,110.71 196.87,122.25 186.88,128.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "176.86,122.21 176.86,110.68 186.85,104.91 196.84,110.68 196.84,122.21 186.85,127.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "176.83,122.18 176.83,110.64 186.82,104.88 196.81,110.64 196.81,122.18 186.82,127.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "176.79,122.15 176.79,110.61 186.79,104.84 196.78,110.61 196.78,122.15 186.79,127.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "176.76,122.12 176.76,110.58 186.75,104.81 196.75,110.58 196.75,122.12 186.75,127.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "176.73,122.09 176.73,110.55 186.72,104.78 196.71,110.55 196.71,122.09 186.72,127.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "176.7,122.05 176.7,110.52 186.69,104.75 196.68,110.52 196.68,122.05 186.69,127.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "176.67,122.02 176.67,110.48 186.66,104.72 196.65,110.48 196.65,122.02 186.66,127.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "176.63,121.99 176.63,110.45 186.63,104.68 196.62,110.45 196.62,121.99 186.63,127.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "176.6,121.96 176.6,110.42 186.59,104.65 196.59,110.42 196.59,121.96 186.59,127.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "176.57,121.93 176.57,110.39 186.56,104.62 196.55,110.39 196.55,121.93 186.56,127.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "176.54,121.89 176.54,110.36 186.53,104.59 196.52,110.36 196.52,121.89 186.53,127.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "176.51,121.86 176.51,110.32 186.5,104.56 196.49,110.32 196.49,121.86 186.5,127.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "176.47,121.83 176.47,110.29 186.47,104.52 196.46,110.29 196.46,121.83 186.47,127.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "176.44,121.8 176.44,110.26 186.43,104.49 196.42,110.26 196.42,121.8 186.43,127.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "176.41,121.77 176.41,110.23 186.4,104.46 196.39,110.23 196.39,121.77 186.4,127.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "176.38,121.73 176.38,110.2 186.37,104.43 196.36,110.2 196.36,121.73 186.37,127.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "176.35,121.7 176.35,110.16 186.34,104.4 196.33,110.16 196.33,121.7 186.34,127.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "176.31,121.67 176.31,110.13 186.3,104.36 196.3,110.13 196.3,121.67 186.3,127.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "176.28,121.64 176.28,110.1 186.27,104.33 196.26,110.1 196.26,121.64 186.27,127.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "176.25,121.61 176.25,110.07 186.24,104.3 196.23,110.07 196.23,121.61 186.24,127.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "176.22,121.57 176.22,110.04 186.21,104.27 196.2,110.04 196.2,121.57 186.21,127.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "176.18,121.54 176.18,110 186.18,104.23 196.17,110 196.17,121.54 186.18,127.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "176.15,121.51 176.15,109.97 186.14,104.2 196.14,109.97 196.14,121.51 186.14,127.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "176.12,121.48 176.12,109.94 186.11,104.17 196.1,109.94 196.1,121.48 186.11,127.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "176.09,121.44 176.09,109.91 186.08,104.14 196.07,109.91 196.07,121.44 186.08,127.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "176.06,121.41 176.06,109.88 186.05,104.11 196.04,109.88 196.04,121.41 186.05,127.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "176.02,121.38 176.02,109.84 186.02,104.07 196.01,109.84 196.01,121.38 186.02,127.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "175.99,121.35 175.99,109.81 185.98,104.04 195.98,109.81 195.98,121.35 185.98,127.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "175.96,121.32 175.96,109.78 185.95,104.01 195.94,109.78 195.94,121.32 185.95,127.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "175.93,121.28 175.93,109.75 185.92,103.98 195.91,109.75 195.91,121.28 185.92,127.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "175.9,121.25 175.9,109.72 185.89,103.95 195.88,109.72 195.88,121.25 185.89,127.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "175.86,121.22 175.86,109.68 185.86,103.91 195.85,109.68 195.85,121.22 185.86,126.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "175.83,121.19 175.83,109.65 185.82,103.88 195.82,109.65 195.82,121.19 185.82,126.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "175.8,121.16 175.8,109.62 185.79,103.85 195.78,109.62 195.78,121.16 185.79,126.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "175.77,121.12 175.77,109.59 185.76,103.82 195.75,109.59 195.75,121.12 185.76,126.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "175.74,121.09 175.74,109.55 185.73,103.79 195.72,109.55 195.72,121.09 185.73,126.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "175.7,121.06 175.7,109.52 185.7,103.75 195.69,109.52 195.69,121.06 185.7,126.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "175.67,121.03 175.67,109.49 185.66,103.72 195.66,109.49 195.66,121.03 185.66,126.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "175.64,121 175.64,109.46 185.63,103.69 195.62,109.46 195.62,121 185.63,126.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "175.61,120.96 175.61,109.43 185.6,103.66 195.59,109.43 195.59,120.96 185.6,126.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "175.58,120.93 175.58,109.39 185.57,103.63 195.56,109.39 195.56,120.93 185.57,126.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "175.54,120.9 175.54,109.36 185.54,103.59 195.53,109.36 195.53,120.9 185.54,126.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "175.51,120.87 175.51,109.33 185.5,103.56 195.49,109.33 195.49,120.87 185.5,126.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "175.48,120.84 175.48,109.3 185.47,103.53 195.46,109.3 195.46,120.84 185.47,126.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "175.45,120.8 175.45,109.27 185.44,103.5 195.43,109.27 195.43,120.8 185.44,126.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "175.42,120.77 175.42,109.23 185.41,103.47 195.4,109.23 195.4,120.77 185.41,126.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "175.38,120.74 175.38,109.2 185.38,103.43 195.37,109.2 195.37,120.74 185.38,126.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "175.35,120.71 175.35,109.17 185.34,103.4 195.33,109.17 195.33,120.71 185.34,126.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "175.32,120.68 175.32,109.14 185.31,103.37 195.3,109.14 195.3,120.68 185.31,126.44  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155828091967683082630000005520807635363978936_",
    gradientUnits: "userSpaceOnUse",
    x1: 1704.9403,
    y1: 433.4865,
    x2: 1720.7007,
    y2: 449.2469,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000155828091967683082630000005520807635363978936_)"
    },
    points: "175.32,120.68 175.32,109.14  185.31,103.37 195.3,109.14 195.3,120.68 185.31,126.44  "
  }), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "175.52,109.42 175.52,120.79 175.32,120.68 175.32,109.14 185.31,103.37 185.65,103.57  "
  }))), /*#__PURE__*/React.createElement("g", null, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "199.93,123.91 199.93,112.38 209.92,106.61 219.91,112.38 219.91,123.91 209.92,129.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "199.9,123.88 199.9,112.34 209.89,106.58 219.88,112.34 219.88,123.88 209.89,129.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "199.86,123.85 199.86,112.31 209.85,106.54 219.85,112.31 219.85,123.85 209.85,129.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "199.83,123.82 199.83,112.28 209.82,106.51 219.81,112.28 219.81,123.82 209.82,129.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "199.8,123.79 199.8,112.25 209.79,106.48 219.78,112.25 219.78,123.79 209.79,129.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "199.77,123.75 199.77,112.22 209.76,106.45 219.75,112.22 219.75,123.75 209.76,129.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "199.73,123.72 199.73,112.18 209.73,106.42 219.72,112.18 219.72,123.72 209.73,129.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "199.7,123.69 199.7,112.15 209.69,106.38 219.69,112.15 219.69,123.69 209.69,129.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "199.67,123.66 199.67,112.12 209.66,106.35 219.65,112.12 219.65,123.66 209.66,129.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "199.64,123.63 199.64,112.09 209.63,106.32 219.62,112.09 219.62,123.63 209.63,129.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "199.61,123.59 199.61,112.06 209.6,106.29 219.59,112.06 219.59,123.59 209.6,129.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "199.57,123.56 199.57,112.02 209.57,106.25 219.56,112.02 219.56,123.56 209.57,129.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "199.54,123.53 199.54,111.99 209.53,106.22 219.53,111.99 219.53,123.53 209.53,129.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "199.51,123.5 199.51,111.96 209.5,106.19 219.49,111.96 219.49,123.5 209.5,129.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "199.48,123.46 199.48,111.93 209.47,106.16 219.46,111.93 219.46,123.46 209.47,129.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "199.45,123.43 199.45,111.9 209.44,106.13 219.43,111.9 219.43,123.43 209.44,129.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "199.41,123.4 199.41,111.86 209.41,106.09 219.4,111.86 219.4,123.4 209.41,129.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "199.38,123.37 199.38,111.83 209.37,106.06 219.37,111.83 219.37,123.37 209.37,129.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "199.35,123.34 199.35,111.8 209.34,106.03 219.33,111.8 219.33,123.34 209.34,129.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "199.32,123.3 199.32,111.77 209.31,106 219.3,111.77 219.3,123.3 209.31,129.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "199.29,123.27 199.29,111.74 209.28,105.97 219.27,111.74 219.27,123.27 209.28,129.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "199.25,123.24 199.25,111.7 209.25,105.93 219.24,111.7 219.24,123.24 209.25,129.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "199.22,123.21 199.22,111.67 209.21,105.9 219.21,111.67 219.21,123.21 209.21,128.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "199.19,123.18 199.19,111.64 209.18,105.87 219.17,111.64 219.17,123.18 209.18,128.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "199.16,123.14 199.16,111.61 209.15,105.84 219.14,111.61 219.14,123.14 209.15,128.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "199.13,123.11 199.13,111.57 209.12,105.81 219.11,111.57 219.11,123.11 209.12,128.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "199.09,123.08 199.09,111.54 209.09,105.77 219.08,111.54 219.08,123.08 209.09,128.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "199.06,123.05 199.06,111.51 209.05,105.74 219.04,111.51 219.04,123.05 209.05,128.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "199.03,123.02 199.03,111.48 209.02,105.71 219.01,111.48 219.01,123.02 209.02,128.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "199,122.98 199,111.45 208.99,105.68 218.98,111.45 218.98,122.98 208.99,128.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "198.97,122.95 198.97,111.41 208.96,105.65 218.95,111.41 218.95,122.95 208.96,128.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "198.93,122.92 198.93,111.38 208.92,105.61 218.92,111.38 218.92,122.92 208.92,128.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "198.9,122.89 198.9,111.35 208.89,105.58 218.88,111.35 218.88,122.89 208.89,128.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "198.87,122.86 198.87,111.32 208.86,105.55 218.85,111.32 218.85,122.86 208.86,128.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "198.84,122.82 198.84,111.29 208.83,105.52 218.82,111.29 218.82,122.82 208.83,128.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "198.81,122.79 198.81,111.25 208.8,105.49 218.79,111.25 218.79,122.79 208.8,128.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "198.77,122.76 198.77,111.22 208.76,105.45 218.76,111.22 218.76,122.76 208.76,128.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "198.74,122.73 198.74,111.19 208.73,105.42 218.72,111.19 218.72,122.73 208.73,128.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "198.71,122.7 198.71,111.16 208.7,105.39 218.69,111.16 218.69,122.7 208.7,128.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "198.68,122.66 198.68,111.13 208.67,105.36 218.66,111.13 218.66,122.66 208.67,128.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "198.64,122.63 198.64,111.09 208.64,105.33 218.63,111.09 218.63,122.63 208.64,128.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "198.61,122.6 198.61,111.06 208.6,105.29 218.6,111.06 218.6,122.6 208.6,128.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "198.58,122.57 198.58,111.03 208.57,105.26 218.56,111.03 218.56,122.57 208.57,128.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "198.55,122.54 198.55,111 208.54,105.23 218.53,111 218.53,122.54 208.54,128.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "198.52,122.5 198.52,110.97 208.51,105.2 218.5,110.97 218.5,122.5 208.51,128.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "198.48,122.47 198.48,110.93 208.48,105.16 218.47,110.93 218.47,122.47 208.48,128.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "198.45,122.44 198.45,110.9 208.44,105.13 218.44,110.9 218.44,122.44 208.44,128.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "198.42,122.41 198.42,110.87 208.41,105.1 218.4,110.87 218.4,122.41 208.41,128.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "198.39,122.37 198.39,110.84 208.38,105.07 218.37,110.84 218.37,122.37 208.38,128.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "198.36,122.34 198.36,110.81 208.35,105.04 218.34,110.81 218.34,122.34 208.35,128.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "198.32,122.31 198.32,110.77 208.32,105 218.31,110.77 218.31,122.31 208.32,128.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "198.29,122.28 198.29,110.74 208.28,104.97 218.28,110.74 218.28,122.28 208.28,128.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "198.26,122.25 198.26,110.71 208.25,104.94 218.24,110.71 218.24,122.25 208.25,128.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "198.23,122.21 198.23,110.68 208.22,104.91 218.21,110.68 218.21,122.21 208.22,127.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "198.2,122.18 198.2,110.64 208.19,104.88 218.18,110.64 218.18,122.18 208.19,127.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "198.16,122.15 198.16,110.61 208.16,104.84 218.15,110.61 218.15,122.15 208.16,127.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "198.13,122.12 198.13,110.58 208.12,104.81 218.12,110.58 218.12,122.12 208.12,127.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "198.1,122.09 198.1,110.55 208.09,104.78 218.08,110.55 218.08,122.09 208.09,127.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "198.07,122.05 198.07,110.52 208.06,104.75 218.05,110.52 218.05,122.05 208.06,127.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "198.04,122.02 198.04,110.48 208.03,104.72 218.02,110.48 218.02,122.02 208.03,127.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "198,121.99 198,110.45 208,104.68 217.99,110.45 217.99,121.99 208,127.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "197.97,121.96 197.97,110.42 207.96,104.65 217.95,110.42 217.95,121.96 207.96,127.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "197.94,121.93 197.94,110.39 207.93,104.62 217.92,110.39 217.92,121.93 207.93,127.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "197.91,121.89 197.91,110.36 207.9,104.59 217.89,110.36 217.89,121.89 207.9,127.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "197.88,121.86 197.88,110.32 207.87,104.56 217.86,110.32 217.86,121.86 207.87,127.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "197.84,121.83 197.84,110.29 207.83,104.52 217.83,110.29 217.83,121.83 207.83,127.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "197.81,121.8 197.81,110.26 207.8,104.49 217.79,110.26 217.79,121.8 207.8,127.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "197.78,121.77 197.78,110.23 207.77,104.46 217.76,110.23 217.76,121.77 207.77,127.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "197.75,121.73 197.75,110.2 207.74,104.43 217.73,110.2 217.73,121.73 207.74,127.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "197.71,121.7 197.71,110.16 207.71,104.4 217.7,110.16 217.7,121.7 207.71,127.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "197.68,121.67 197.68,110.13 207.67,104.36 217.67,110.13 217.67,121.67 207.67,127.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "197.65,121.64 197.65,110.1 207.64,104.33 217.63,110.1 217.63,121.64 207.64,127.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "197.62,121.61 197.62,110.07 207.61,104.3 217.6,110.07 217.6,121.61 207.61,127.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "197.59,121.57 197.59,110.04 207.58,104.27 217.57,110.04 217.57,121.57 207.58,127.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "197.55,121.54 197.55,110 207.55,104.23 217.54,110 217.54,121.54 207.55,127.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "197.52,121.51 197.52,109.97 207.51,104.2 217.51,109.97 217.51,121.51 207.51,127.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "197.49,121.48 197.49,109.94 207.48,104.17 217.47,109.94 217.47,121.48 207.48,127.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "197.46,121.44 197.46,109.91 207.45,104.14 217.44,109.91 217.44,121.44 207.45,127.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "197.43,121.41 197.43,109.88 207.42,104.11 217.41,109.88 217.41,121.41 207.42,127.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "197.39,121.38 197.39,109.84 207.39,104.07 217.38,109.84 217.38,121.38 207.39,127.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "197.36,121.35 197.36,109.81 207.35,104.04 217.35,109.81 217.35,121.35 207.35,127.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "197.33,121.32 197.33,109.78 207.32,104.01 217.31,109.78 217.31,121.32 207.32,127.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "197.3,121.28 197.3,109.75 207.29,103.98 217.28,109.75 217.28,121.28 207.29,127.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "197.27,121.25 197.27,109.72 207.26,103.95 217.25,109.72 217.25,121.25 207.26,127.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "197.23,121.22 197.23,109.68 207.23,103.91 217.22,109.68 217.22,121.22 207.23,126.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "197.2,121.19 197.2,109.65 207.19,103.88 217.19,109.65 217.19,121.19 207.19,126.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "197.17,121.16 197.17,109.62 207.16,103.85 217.15,109.62 217.15,121.16 207.16,126.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "197.14,121.12 197.14,109.59 207.13,103.82 217.12,109.59 217.12,121.12 207.13,126.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "197.11,121.09 197.11,109.55 207.1,103.79 217.09,109.55 217.09,121.09 207.1,126.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "197.07,121.06 197.07,109.52 207.07,103.75 217.06,109.52 217.06,121.06 207.07,126.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "197.04,121.03 197.04,109.49 207.03,103.72 217.02,109.49 217.02,121.03 207.03,126.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "197.01,121 197.01,109.46 207,103.69 216.99,109.46 216.99,121 207,126.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "196.98,120.96 196.98,109.43 206.97,103.66 216.96,109.43 216.96,120.96 206.97,126.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "196.95,120.93 196.95,109.39 206.94,103.63 216.93,109.39 216.93,120.93 206.94,126.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "196.91,120.9 196.91,109.36 206.91,103.59 216.9,109.36 216.9,120.9 206.91,126.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "196.88,120.87 196.88,109.33 206.87,103.56 216.86,109.33 216.86,120.87 206.87,126.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "196.85,120.84 196.85,109.3 206.84,103.53 216.83,109.3 216.83,120.84 206.84,126.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "196.82,120.8 196.82,109.27 206.81,103.5 216.8,109.27 216.8,120.8 206.81,126.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "196.79,120.77 196.79,109.23 206.78,103.47 216.77,109.23 216.77,120.77 206.78,126.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "196.75,120.74 196.75,109.2 206.74,103.43 216.74,109.2 216.74,120.74 206.74,126.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "196.72,120.71 196.72,109.17 206.71,103.4 216.7,109.17 216.7,120.71 206.71,126.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "196.69,120.68 196.69,109.14 206.68,103.37 216.67,109.14 216.67,120.68 206.68,126.44  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177467152667622348270000012097053292702208416_",
    gradientUnits: "userSpaceOnUse",
    x1: 1704.9403,
    y1: 454.8562,
    x2: 1720.7007,
    y2: 470.6166,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000177467152667622348270000012097053292702208416_)"
    },
    points: "196.69,120.68 196.69,109.14  206.68,103.37 216.67,109.14 216.67,120.68 206.68,126.44  "
  }), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "196.89,109.42 196.89,120.79 196.69,120.68 196.69,109.14 206.68,103.37 207.02,103.57  "
  }))), /*#__PURE__*/React.createElement("g", null, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "210.65,106.05 210.65,94.51 220.65,88.74 230.64,94.51 230.64,106.05 220.65,111.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "210.62,106.02 210.62,94.48 220.61,88.71 230.61,94.48 230.61,106.02 220.61,111.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "210.59,105.98 210.59,94.45 220.58,88.68 230.57,94.45 230.57,105.98 220.58,111.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "210.56,105.95 210.56,94.41 220.55,88.65 230.54,94.41 230.54,105.95 220.55,111.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "210.53,105.92 210.53,94.38 220.52,88.61 230.51,94.38 230.51,105.92 220.52,111.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "210.49,105.89 210.49,94.35 220.49,88.58 230.48,94.35 230.48,105.89 220.49,111.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "210.46,105.86 210.46,94.32 220.45,88.55 230.44,94.32 230.44,105.86 220.45,111.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "210.43,105.82 210.43,94.29 220.42,88.52 230.41,94.29 230.41,105.82 220.42,111.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "210.4,105.79 210.4,94.25 220.39,88.49 230.38,94.25 230.38,105.79 220.39,111.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "210.37,105.76 210.37,94.22 220.36,88.45 230.35,94.22 230.35,105.76 220.36,111.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "210.33,105.73 210.33,94.19 220.32,88.42 230.32,94.19 230.32,105.73 220.32,111.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "210.3,105.7 210.3,94.16 220.29,88.39 230.28,94.16 230.28,105.7 220.29,111.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "210.27,105.66 210.27,94.13 220.26,88.36 230.25,94.13 230.25,105.66 220.26,111.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "210.24,105.63 210.24,94.09 220.23,88.33 230.22,94.09 230.22,105.63 220.23,111.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "210.21,105.6 210.21,94.06 220.2,88.29 230.19,94.06 230.19,105.6 220.2,111.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "210.17,105.57 210.17,94.03 220.16,88.26 230.16,94.03 230.16,105.57 220.16,111.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "210.14,105.54 210.14,94 220.13,88.23 230.12,94 230.12,105.54 220.13,111.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "210.11,105.5 210.11,93.97 220.1,88.2 230.09,93.97 230.09,105.5 220.1,111.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "210.08,105.47 210.08,93.93 220.07,88.16 230.06,93.93 230.06,105.47 220.07,111.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "210.04,105.44 210.04,93.9 220.04,88.13 230.03,93.9 230.03,105.44 220.04,111.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "210.01,105.41 210.01,93.87 220,88.1 230,93.87 230,105.41 220,111.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "209.98,105.37 209.98,93.84 219.97,88.07 229.96,93.84 229.96,105.37 219.97,111.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "209.95,105.34 209.95,93.81 219.94,88.04 229.93,93.81 229.93,105.34 219.94,111.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "209.92,105.31 209.92,93.77 219.91,88 229.9,93.77 229.9,105.31 219.91,111.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "209.88,105.28 209.88,93.74 219.88,87.97 229.87,93.74 229.87,105.28 219.88,111.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "209.85,105.25 209.85,93.71 219.84,87.94 229.84,93.71 229.84,105.25 219.84,111.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "209.82,105.21 209.82,93.68 219.81,87.91 229.8,93.68 229.8,105.21 219.81,110.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "209.79,105.18 209.79,93.64 219.78,87.88 229.77,93.64 229.77,105.18 219.78,110.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "209.76,105.15 209.76,93.61 219.75,87.84 229.74,93.61 229.74,105.15 219.75,110.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "209.72,105.12 209.72,93.58 219.72,87.81 229.71,93.58 229.71,105.12 219.72,110.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "209.69,105.09 209.69,93.55 219.68,87.78 229.68,93.55 229.68,105.09 219.68,110.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "209.66,105.05 209.66,93.52 219.65,87.75 229.64,93.52 229.64,105.05 219.65,110.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "209.63,105.02 209.63,93.48 219.62,87.72 229.61,93.48 229.61,105.02 219.62,110.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "209.6,104.99 209.6,93.45 219.59,87.68 229.58,93.45 229.58,104.99 219.59,110.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "209.56,104.96 209.56,93.42 219.56,87.65 229.55,93.42 229.55,104.96 219.56,110.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "209.53,104.93 209.53,93.39 219.52,87.62 229.52,93.39 229.52,104.93 219.52,110.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "209.5,104.89 209.5,93.36 219.49,87.59 229.48,93.36 229.48,104.89 219.49,110.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "209.47,104.86 209.47,93.32 219.46,87.56 229.45,93.32 229.45,104.86 219.46,110.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "209.44,104.83 209.44,93.29 219.43,87.52 229.42,93.29 229.42,104.83 219.43,110.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "209.4,104.8 209.4,93.26 219.4,87.49 229.39,93.26 229.39,104.8 219.4,110.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "209.37,104.77 209.37,93.23 219.36,87.46 229.35,93.23 229.35,104.77 219.36,110.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "209.34,104.73 209.34,93.2 219.33,87.43 229.32,93.2 229.32,104.73 219.33,110.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "209.31,104.7 209.31,93.16 219.3,87.4 229.29,93.16 229.29,104.7 219.3,110.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "209.28,104.67 209.28,93.13 219.27,87.36 229.26,93.13 229.26,104.67 219.27,110.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "209.24,104.64 209.24,93.1 219.23,87.33 229.23,93.1 229.23,104.64 219.23,110.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "209.21,104.61 209.21,93.07 219.2,87.3 229.19,93.07 229.19,104.61 219.2,110.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "209.18,104.57 209.18,93.04 219.17,87.27 229.16,93.04 229.16,104.57 219.17,110.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "209.15,104.54 209.15,93 219.14,87.23 229.13,93 229.13,104.54 219.14,110.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "209.11,104.51 209.11,92.97 219.11,87.2 229.1,92.97 229.1,104.51 219.11,110.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "209.08,104.48 209.08,92.94 219.07,87.17 229.07,92.94 229.07,104.48 219.07,110.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "209.05,104.44 209.05,92.91 219.04,87.14 229.03,92.91 229.03,104.44 219.04,110.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "209.02,104.41 209.02,92.88 219.01,87.11 229,92.88 229,104.41 219.01,110.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "208.99,104.38 208.99,92.84 218.98,87.07 228.97,92.84 228.97,104.38 218.98,110.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "208.95,104.35 208.95,92.81 218.95,87.04 228.94,92.81 228.94,104.35 218.95,110.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "208.92,104.32 208.92,92.78 218.91,87.01 228.91,92.78 228.91,104.32 218.91,110.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "208.89,104.28 208.89,92.75 218.88,86.98 228.87,92.75 228.87,104.28 218.88,110.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "208.86,104.25 208.86,92.72 218.85,86.95 228.84,92.72 228.84,104.25 218.85,110.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "208.83,104.22 208.83,92.68 218.82,86.91 228.81,92.68 228.81,104.22 218.82,109.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "208.79,104.19 208.79,92.65 218.79,86.88 228.78,92.65 228.78,104.19 218.79,109.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "208.76,104.16 208.76,92.62 218.75,86.85 228.75,92.62 228.75,104.16 218.75,109.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "208.73,104.12 208.73,92.59 218.72,86.82 228.71,92.59 228.71,104.12 218.72,109.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "208.7,104.09 208.7,92.55 218.69,86.79 228.68,92.55 228.68,104.09 218.69,109.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "208.67,104.06 208.67,92.52 218.66,86.75 228.65,92.52 228.65,104.06 218.66,109.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "208.63,104.03 208.63,92.49 218.63,86.72 228.62,92.49 228.62,104.03 218.63,109.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "208.6,104 208.6,92.46 218.59,86.69 228.59,92.46 228.59,104 218.59,109.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "208.57,103.96 208.57,92.43 218.56,86.66 228.55,92.43 228.55,103.96 218.56,109.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "208.54,103.93 208.54,92.39 218.53,86.63 228.52,92.39 228.52,103.93 218.53,109.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "208.51,103.9 208.51,92.36 218.5,86.59 228.49,92.36 228.49,103.9 218.5,109.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "208.47,103.87 208.47,92.33 218.47,86.56 228.46,92.33 228.46,103.87 218.47,109.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "208.44,103.84 208.44,92.3 218.43,86.53 228.42,92.3 228.42,103.84 218.43,109.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "208.41,103.8 208.41,92.27 218.4,86.5 228.39,92.27 228.39,103.8 218.4,109.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "208.38,103.77 208.38,92.23 218.37,86.47 228.36,92.23 228.36,103.77 218.37,109.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "208.35,103.74 208.35,92.2 218.34,86.43 228.33,92.2 228.33,103.74 218.34,109.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "208.31,103.71 208.31,92.17 218.31,86.4 228.3,92.17 228.3,103.71 218.31,109.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "208.28,103.68 208.28,92.14 218.27,86.37 228.26,92.14 228.26,103.68 218.27,109.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "208.25,103.64 208.25,92.11 218.24,86.34 228.23,92.11 228.23,103.64 218.24,109.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "208.22,103.61 208.22,92.07 218.21,86.31 228.2,92.07 228.2,103.61 218.21,109.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "208.19,103.58 208.19,92.04 218.18,86.27 228.17,92.04 228.17,103.58 218.18,109.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "208.15,103.55 208.15,92.01 218.14,86.24 228.14,92.01 228.14,103.55 218.14,109.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "208.12,103.52 208.12,91.98 218.11,86.21 228.1,91.98 228.1,103.52 218.11,109.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "208.09,103.48 208.09,91.95 218.08,86.18 228.07,91.95 228.07,103.48 218.08,109.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "208.06,103.45 208.06,91.91 218.05,86.14 228.04,91.91 228.04,103.45 218.05,109.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "208.02,103.42 208.02,91.88 218.02,86.11 228.01,91.88 228.01,103.42 218.02,109.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "207.99,103.39 207.99,91.85 217.98,86.08 227.98,91.85 227.98,103.39 217.98,109.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "207.96,103.35 207.96,91.82 217.95,86.05 227.94,91.82 227.94,103.35 217.95,109.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "207.93,103.32 207.93,91.79 217.92,86.02 227.91,91.79 227.91,103.32 217.92,109.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "207.9,103.29 207.9,91.75 217.89,85.98 227.88,91.75 227.88,103.29 217.89,109.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "207.86,103.26 207.86,91.72 217.86,85.95 227.85,91.72 227.85,103.26 217.86,109.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "207.83,103.23 207.83,91.69 217.82,85.92 227.82,91.69 227.82,103.23 217.82,109  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "207.8,103.19 207.8,91.66 217.79,85.89 227.78,91.66 227.78,103.19 217.79,108.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "207.77,103.16 207.77,91.62 217.76,85.86 227.75,91.62 227.75,103.16 217.76,108.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "207.74,103.13 207.74,91.59 217.73,85.82 227.72,91.59 227.72,103.13 217.73,108.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "207.7,103.1 207.7,91.56 217.7,85.79 227.69,91.56 227.69,103.1 217.7,108.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "207.67,103.07 207.67,91.53 217.66,85.76 227.66,91.53 227.66,103.07 217.66,108.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "207.64,103.03 207.64,91.5 217.63,85.73 227.62,91.5 227.62,103.03 217.63,108.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "207.61,103 207.61,91.46 217.6,85.7 227.59,91.46 227.59,103 217.6,108.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "207.58,102.97 207.58,91.43 217.57,85.66 227.56,91.43 227.56,102.97 217.57,108.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "207.54,102.94 207.54,91.4 217.54,85.63 227.53,91.4 227.53,102.94 217.54,108.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "207.51,102.91 207.51,91.37 217.5,85.6 227.5,91.37 227.5,102.91 217.5,108.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "207.48,102.87 207.48,91.34 217.47,85.57 227.46,91.34 227.46,102.87 217.47,108.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "207.45,102.84 207.45,91.3 217.44,85.54 227.43,91.3 227.43,102.84 217.44,108.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "207.42,102.81 207.42,91.27 217.41,85.5 227.4,91.27 227.4,102.81 217.41,108.58  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026152014896057767740000005088326355476481457_",
    gradientUnits: "userSpaceOnUse",
    x1: 1687.0746,
    y1: 465.5829,
    x2: 1702.835,
    y2: 481.3433,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000026152014896057767740000005088326355476481457_)"
    },
    points: "207.42,102.81 207.42,91.27  217.41,85.5 227.4,91.27 227.4,102.81 217.41,108.58  "
  }), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "207.62,91.55 207.62,102.93 207.42,102.81 207.42,91.27 217.41,85.5 217.75,85.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "167.75,142.25 167.75,130.71 177.74,124.94 187.73,130.71 187.73,142.25 177.74,148.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "167.72,142.21 167.72,130.68 177.71,124.91 187.7,130.68 187.7,142.21 177.71,147.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "167.68,142.18 167.68,130.65 177.67,124.88 187.67,130.65 187.67,142.18 177.67,147.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "167.65,142.15 167.65,130.61 177.64,124.84 187.63,130.61 187.63,142.15 177.64,147.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "167.62,142.12 167.62,130.58 177.61,124.81 187.6,130.58 187.6,142.12 177.61,147.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "167.59,142.09 167.59,130.55 177.58,124.78 187.57,130.55 187.57,142.09 177.58,147.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "167.55,142.05 167.55,130.52 177.55,124.75 187.54,130.52 187.54,142.05 177.55,147.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "167.52,142.02 167.52,130.48 177.51,124.72 187.51,130.48 187.51,142.02 177.51,147.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "167.49,141.99 167.49,130.45 177.48,124.68 187.47,130.45 187.47,141.99 177.48,147.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "167.46,141.96 167.46,130.42 177.45,124.65 187.44,130.42 187.44,141.96 177.45,147.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "167.43,141.93 167.43,130.39 177.42,124.62 187.41,130.39 187.41,141.93 177.42,147.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "167.39,141.89 167.39,130.36 177.39,124.59 187.38,130.36 187.38,141.89 177.39,147.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "167.36,141.86 167.36,130.32 177.35,124.56 187.35,130.32 187.35,141.86 177.35,147.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "167.33,141.83 167.33,130.29 177.32,124.52 187.31,130.29 187.31,141.83 177.32,147.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "167.3,141.8 167.3,130.26 177.29,124.49 187.28,130.26 187.28,141.8 177.29,147.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "167.27,141.77 167.27,130.23 177.26,124.46 187.25,130.23 187.25,141.77 177.26,147.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "167.23,141.73 167.23,130.2 177.23,124.43 187.22,130.2 187.22,141.73 177.23,147.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "167.2,141.7 167.2,130.16 177.19,124.4 187.19,130.16 187.19,141.7 177.19,147.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "167.17,141.67 167.17,130.13 177.16,124.36 187.15,130.13 187.15,141.67 177.16,147.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "167.14,141.64 167.14,130.1 177.13,124.33 187.12,130.1 187.12,141.64 177.13,147.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "167.11,141.61 167.11,130.07 177.1,124.3 187.09,130.07 187.09,141.61 177.1,147.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "167.07,141.57 167.07,130.04 177.07,124.27 187.06,130.04 187.06,141.57 177.07,147.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "167.04,141.54 167.04,130 177.03,124.24 187.03,130 187.03,141.54 177.03,147.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "167.01,141.51 167.01,129.97 177,124.2 186.99,129.97 186.99,141.51 177,147.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "166.98,141.48 166.98,129.94 176.97,124.17 186.96,129.94 186.96,141.48 176.97,147.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "166.95,141.45 166.95,129.91 176.94,124.14 186.93,129.91 186.93,141.45 176.94,147.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "166.91,141.41 166.91,129.88 176.91,124.11 186.9,129.88 186.9,141.41 176.91,147.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "166.88,141.38 166.88,129.84 176.87,124.07 186.86,129.84 186.86,141.38 176.87,147.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "166.85,141.35 166.85,129.81 176.84,124.04 186.83,129.81 186.83,141.35 176.84,147.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "166.82,141.32 166.82,129.78 176.81,124.01 186.8,129.78 186.8,141.32 176.81,147.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "166.79,141.28 166.79,129.75 176.78,123.98 186.77,129.75 186.77,141.28 176.78,147.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "166.75,141.25 166.75,129.72 176.74,123.95 186.74,129.72 186.74,141.25 176.74,147.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "166.72,141.22 166.72,129.68 176.71,123.91 186.7,129.68 186.7,141.22 176.71,146.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "166.69,141.19 166.69,129.65 176.68,123.88 186.67,129.65 186.67,141.19 176.68,146.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "166.66,141.16 166.66,129.62 176.65,123.85 186.64,129.62 186.64,141.16 176.65,146.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "166.62,141.12 166.62,129.59 176.62,123.82 186.61,129.59 186.61,141.12 176.62,146.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "166.59,141.09 166.59,129.55 176.58,123.79 186.58,129.55 186.58,141.09 176.58,146.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "166.56,141.06 166.56,129.52 176.55,123.75 186.54,129.52 186.54,141.06 176.55,146.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "166.53,141.03 166.53,129.49 176.52,123.72 186.51,129.49 186.51,141.03 176.52,146.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "166.5,141 166.5,129.46 176.49,123.69 186.48,129.46 186.48,141 176.49,146.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "166.46,140.96 166.46,129.43 176.46,123.66 186.45,129.43 186.45,140.96 176.46,146.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "166.43,140.93 166.43,129.39 176.42,123.63 186.42,129.39 186.42,140.93 176.42,146.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "166.4,140.9 166.4,129.36 176.39,123.59 186.38,129.36 186.38,140.9 176.39,146.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "166.37,140.87 166.37,129.33 176.36,123.56 186.35,129.33 186.35,140.87 176.36,146.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "166.34,140.84 166.34,129.3 176.33,123.53 186.32,129.3 186.32,140.84 176.33,146.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "166.3,140.8 166.3,129.27 176.3,123.5 186.29,129.27 186.29,140.8 176.3,146.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "166.27,140.77 166.27,129.23 176.26,123.47 186.26,129.23 186.26,140.77 176.26,146.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "166.24,140.74 166.24,129.2 176.23,123.43 186.22,129.2 186.22,140.74 176.23,146.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "166.21,140.71 166.21,129.17 176.2,123.4 186.19,129.17 186.19,140.71 176.2,146.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "166.18,140.68 166.18,129.14 176.17,123.37 186.16,129.14 186.16,140.68 176.17,146.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "166.14,140.64 166.14,129.11 176.14,123.34 186.13,129.11 186.13,140.64 176.14,146.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "166.11,140.61 166.11,129.07 176.1,123.31 186.1,129.07 186.1,140.61 176.1,146.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "166.08,140.58 166.08,129.04 176.07,123.27 186.06,129.04 186.06,140.58 176.07,146.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "166.05,140.55 166.05,129.01 176.04,123.24 186.03,129.01 186.03,140.55 176.04,146.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "166.02,140.52 166.02,128.98 176.01,123.21 186,128.98 186,140.52 176.01,146.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "165.98,140.48 165.98,128.95 175.98,123.18 185.97,128.95 185.97,140.48 175.98,146.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "165.95,140.45 165.95,128.91 175.94,123.15 185.94,128.91 185.94,140.45 175.94,146.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "165.92,140.42 165.92,128.88 175.91,123.11 185.9,128.88 185.9,140.42 175.91,146.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "165.89,140.39 165.89,128.85 175.88,123.08 185.87,128.85 185.87,140.39 175.88,146.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "165.86,140.35 165.86,128.82 175.85,123.05 185.84,128.82 185.84,140.35 175.85,146.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "165.82,140.32 165.82,128.79 175.82,123.02 185.81,128.79 185.81,140.32 175.82,146.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "165.79,140.29 165.79,128.75 175.78,122.98 185.77,128.75 185.77,140.29 175.78,146.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "165.76,140.26 165.76,128.72 175.75,122.95 185.74,128.72 185.74,140.26 175.75,146.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "165.73,140.23 165.73,128.69 175.72,122.92 185.71,128.69 185.71,140.23 175.72,146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "165.7,140.19 165.7,128.66 175.69,122.89 185.68,128.66 185.68,140.19 175.69,145.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "165.66,140.16 165.66,128.63 175.65,122.86 185.65,128.63 185.65,140.16 175.65,145.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "165.63,140.13 165.63,128.59 175.62,122.82 185.61,128.59 185.61,140.13 175.62,145.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "165.6,140.1 165.6,128.56 175.59,122.79 185.58,128.56 185.58,140.1 175.59,145.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "165.57,140.07 165.57,128.53 175.56,122.76 185.55,128.53 185.55,140.07 175.56,145.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "165.53,140.03 165.53,128.5 175.53,122.73 185.52,128.5 185.52,140.03 175.53,145.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "165.5,140 165.5,128.46 175.49,122.7 185.49,128.46 185.49,140 175.49,145.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "165.47,139.97 165.47,128.43 175.46,122.66 185.45,128.43 185.45,139.97 175.46,145.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "165.44,139.94 165.44,128.4 175.43,122.63 185.42,128.4 185.42,139.94 175.43,145.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "165.41,139.91 165.41,128.37 175.4,122.6 185.39,128.37 185.39,139.91 175.4,145.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "165.37,139.87 165.37,128.34 175.37,122.57 185.36,128.34 185.36,139.87 175.37,145.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "165.34,139.84 165.34,128.3 175.33,122.54 185.33,128.3 185.33,139.84 175.33,145.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "165.31,139.81 165.31,128.27 175.3,122.5 185.29,128.27 185.29,139.81 175.3,145.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "165.28,139.78 165.28,128.24 175.27,122.47 185.26,128.24 185.26,139.78 175.27,145.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "165.25,139.75 165.25,128.21 175.24,122.44 185.23,128.21 185.23,139.75 175.24,145.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "165.21,139.71 165.21,128.18 175.21,122.41 185.2,128.18 185.2,139.71 175.21,145.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "165.18,139.68 165.18,128.14 175.17,122.38 185.17,128.14 185.17,139.68 175.17,145.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "165.15,139.65 165.15,128.11 175.14,122.34 185.13,128.11 185.13,139.65 175.14,145.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "165.12,139.62 165.12,128.08 175.11,122.31 185.1,128.08 185.1,139.62 175.11,145.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "165.09,139.59 165.09,128.05 175.08,122.28 185.07,128.05 185.07,139.59 175.08,145.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "165.05,139.55 165.05,128.02 175.05,122.25 185.04,128.02 185.04,139.55 175.05,145.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "165.02,139.52 165.02,127.98 175.01,122.22 185.01,127.98 185.01,139.52 175.01,145.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "164.99,139.49 164.99,127.95 174.98,122.18 184.97,127.95 184.97,139.49 174.98,145.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "164.96,139.46 164.96,127.92 174.95,122.15 184.94,127.92 184.94,139.46 174.95,145.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "164.93,139.43 164.93,127.89 174.92,122.12 184.91,127.89 184.91,139.43 174.92,145.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "164.89,139.39 164.89,127.86 174.89,122.09 184.88,127.86 184.88,139.39 174.89,145.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "164.86,139.36 164.86,127.82 174.85,122.05 184.84,127.82 184.84,139.36 174.85,145.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "164.83,139.33 164.83,127.79 174.82,122.02 184.81,127.79 184.81,139.33 174.82,145.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "164.8,139.3 164.8,127.76 174.79,121.99 184.78,127.76 184.78,139.3 174.79,145.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "164.77,139.26 164.77,127.73 174.76,121.96 184.75,127.73 184.75,139.26 174.76,145.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "164.73,139.23 164.73,127.7 174.72,121.93 184.72,127.7 184.72,139.23 174.72,145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "164.7,139.2 164.7,127.66 174.69,121.89 184.68,127.66 184.68,139.2 174.69,144.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "164.67,139.17 164.67,127.63 174.66,121.86 184.65,127.63 184.65,139.17 174.66,144.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "164.64,139.14 164.64,127.6 174.63,121.83 184.62,127.6 184.62,139.14 174.63,144.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "164.6,139.1 164.6,127.57 174.6,121.8 184.59,127.57 184.59,139.1 174.6,144.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "164.57,139.07 164.57,127.54 174.56,121.77 184.56,127.54 184.56,139.07 174.56,144.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "164.54,139.04 164.54,127.5 174.53,121.73 184.52,127.5 184.52,139.04 174.53,144.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "164.51,139.01 164.51,127.47 174.5,121.7 184.49,127.47 184.49,139.01 174.5,144.78  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090981972267197478350000013866417257028549043_",
    gradientUnits: "userSpaceOnUse",
    x1: 1723.2732,
    y1: 422.6761,
    x2: 1739.0336,
    y2: 438.4365,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000090981972267197478350000013866417257028549043_)"
    },
    points: "164.51,139.01 164.51,127.47  174.5,121.7 184.49,127.47 184.49,139.01 174.5,144.78  "
  }), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "164.71,127.75 164.71,139.13 164.51,139.01 164.51,127.47 174.5,121.7 174.84,121.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "189.2,142.25 189.2,130.71 199.19,124.94 209.18,130.71 209.18,142.25 199.19,148.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "189.17,142.21 189.17,130.68 199.16,124.91 209.15,130.68 209.15,142.21 199.16,147.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "189.14,142.18 189.14,130.65 199.13,124.88 209.12,130.65 209.12,142.18 199.13,147.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "189.1,142.15 189.1,130.61 199.1,124.84 209.09,130.61 209.09,142.15 199.1,147.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "189.07,142.12 189.07,130.58 199.06,124.81 209.06,130.58 209.06,142.12 199.06,147.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "189.04,142.09 189.04,130.55 199.03,124.78 209.02,130.55 209.02,142.09 199.03,147.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "189.01,142.05 189.01,130.52 199,124.75 208.99,130.52 208.99,142.05 199,147.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "188.98,142.02 188.98,130.48 198.97,124.72 208.96,130.48 208.96,142.02 198.97,147.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "188.94,141.99 188.94,130.45 198.94,124.68 208.93,130.45 208.93,141.99 198.94,147.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "188.91,141.96 188.91,130.42 198.9,124.65 208.9,130.42 208.9,141.96 198.9,147.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "188.88,141.93 188.88,130.39 198.87,124.62 208.86,130.39 208.86,141.93 198.87,147.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "188.85,141.89 188.85,130.36 198.84,124.59 208.83,130.36 208.83,141.89 198.84,147.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "188.82,141.86 188.82,130.32 198.81,124.56 208.8,130.32 208.8,141.86 198.81,147.63  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "188.78,141.83 188.78,130.29 198.78,124.52 208.77,130.29 208.77,141.83 198.78,147.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "188.75,141.8 188.75,130.26 198.74,124.49 208.74,130.26 208.74,141.8 198.74,147.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "188.72,141.77 188.72,130.23 198.71,124.46 208.7,130.23 208.7,141.77 198.71,147.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "188.69,141.73 188.69,130.2 198.68,124.43 208.67,130.2 208.67,141.73 198.68,147.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "188.66,141.7 188.66,130.16 198.65,124.4 208.64,130.16 208.64,141.7 198.65,147.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "188.62,141.67 188.62,130.13 198.62,124.36 208.61,130.13 208.61,141.67 198.62,147.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "188.59,141.64 188.59,130.1 198.58,124.33 208.57,130.1 208.57,141.64 198.58,147.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "188.56,141.61 188.56,130.07 198.55,124.3 208.54,130.07 208.54,141.61 198.55,147.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "188.53,141.57 188.53,130.04 198.52,124.27 208.51,130.04 208.51,141.57 198.52,147.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "188.5,141.54 188.5,130 198.49,124.24 208.48,130 208.48,141.54 198.49,147.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "188.46,141.51 188.46,129.97 198.45,124.2 208.45,129.97 208.45,141.51 198.45,147.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "188.43,141.48 188.43,129.94 198.42,124.17 208.41,129.94 208.41,141.48 198.42,147.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "188.4,141.45 188.4,129.91 198.39,124.14 208.38,129.91 208.38,141.45 198.39,147.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "188.37,141.41 188.37,129.88 198.36,124.11 208.35,129.88 208.35,141.41 198.36,147.18  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "188.33,141.38 188.33,129.84 198.33,124.07 208.32,129.84 208.32,141.38 198.33,147.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "188.3,141.35 188.3,129.81 198.29,124.04 208.29,129.81 208.29,141.35 198.29,147.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "188.27,141.32 188.27,129.78 198.26,124.01 208.25,129.78 208.25,141.32 198.26,147.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "188.24,141.28 188.24,129.75 198.23,123.98 208.22,129.75 208.22,141.28 198.23,147.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "188.21,141.25 188.21,129.72 198.2,123.95 208.19,129.72 208.19,141.25 198.2,147.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "188.17,141.22 188.17,129.68 198.17,123.91 208.16,129.68 208.16,141.22 198.17,146.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "188.14,141.19 188.14,129.65 198.13,123.88 208.13,129.65 208.13,141.19 198.13,146.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "188.11,141.16 188.11,129.62 198.1,123.85 208.09,129.62 208.09,141.16 198.1,146.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "188.08,141.12 188.08,129.59 198.07,123.82 208.06,129.59 208.06,141.12 198.07,146.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "188.05,141.09 188.05,129.55 198.04,123.79 208.03,129.55 208.03,141.09 198.04,146.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "188.01,141.06 188.01,129.52 198.01,123.75 208,129.52 208,141.06 198.01,146.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "187.98,141.03 187.98,129.49 197.97,123.72 207.97,129.49 207.97,141.03 197.97,146.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "187.95,141 187.95,129.46 197.94,123.69 207.93,129.46 207.93,141 197.94,146.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "187.92,140.96 187.92,129.43 197.91,123.66 207.9,129.43 207.9,140.96 197.91,146.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "187.89,140.93 187.89,129.39 197.88,123.63 207.87,129.39 207.87,140.93 197.88,146.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "187.85,140.9 187.85,129.36 197.85,123.59 207.84,129.36 207.84,140.9 197.85,146.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st76",
    points: "187.82,140.87 187.82,129.33 197.81,123.56 207.81,129.33 207.81,140.87 197.81,146.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "187.79,140.84 187.79,129.3 197.78,123.53 207.77,129.3 207.77,140.84 197.78,146.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "187.76,140.8 187.76,129.27 197.75,123.5 207.74,129.27 207.74,140.8 197.75,146.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "187.73,140.77 187.73,129.23 197.72,123.47 207.71,129.23 207.71,140.77 197.72,146.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "187.69,140.74 187.69,129.2 197.69,123.43 207.68,129.2 207.68,140.74 197.69,146.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "187.66,140.71 187.66,129.17 197.65,123.4 207.64,129.17 207.64,140.71 197.65,146.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "187.63,140.68 187.63,129.14 197.62,123.37 207.61,129.14 207.61,140.68 197.62,146.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "187.6,140.64 187.6,129.11 197.59,123.34 207.58,129.11 207.58,140.64 197.59,146.41  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "187.57,140.61 187.57,129.07 197.56,123.31 207.55,129.07 207.55,140.61 197.56,146.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "187.53,140.58 187.53,129.04 197.52,123.27 207.52,129.04 207.52,140.58 197.52,146.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "187.5,140.55 187.5,129.01 197.49,123.24 207.48,129.01 207.48,140.55 197.49,146.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "187.47,140.52 187.47,128.98 197.46,123.21 207.45,128.98 207.45,140.52 197.46,146.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "187.44,140.48 187.44,128.95 197.43,123.18 207.42,128.95 207.42,140.48 197.43,146.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "187.4,140.45 187.4,128.91 197.4,123.15 207.39,128.91 207.39,140.45 197.4,146.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "187.37,140.42 187.37,128.88 197.36,123.11 207.36,128.88 207.36,140.42 197.36,146.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "187.34,140.39 187.34,128.85 197.33,123.08 207.32,128.85 207.32,140.39 197.33,146.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "187.31,140.35 187.31,128.82 197.3,123.05 207.29,128.82 207.29,140.35 197.3,146.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "187.28,140.32 187.28,128.79 197.27,123.02 207.26,128.79 207.26,140.32 197.27,146.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "187.24,140.29 187.24,128.75 197.24,122.98 207.23,128.75 207.23,140.29 197.24,146.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "187.21,140.26 187.21,128.72 197.2,122.95 207.2,128.72 207.2,140.26 197.2,146.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "187.18,140.23 187.18,128.69 197.17,122.92 207.16,128.69 207.16,140.23 197.17,146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "187.15,140.19 187.15,128.66 197.14,122.89 207.13,128.66 207.13,140.19 197.14,145.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "187.12,140.16 187.12,128.63 197.11,122.86 207.1,128.63 207.1,140.16 197.11,145.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "187.08,140.13 187.08,128.59 197.08,122.82 207.07,128.59 207.07,140.13 197.08,145.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "187.05,140.1 187.05,128.56 197.04,122.79 207.04,128.56 207.04,140.1 197.04,145.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st101",
    points: "187.02,140.07 187.02,128.53 197.01,122.76 207,128.53 207,140.07 197.01,145.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st102",
    points: "186.99,140.03 186.99,128.5 196.98,122.73 206.97,128.5 206.97,140.03 196.98,145.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "186.96,140 186.96,128.46 196.95,122.7 206.94,128.46 206.94,140 196.95,145.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "186.92,139.97 186.92,128.43 196.92,122.66 206.91,128.43 206.91,139.97 196.92,145.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "186.89,139.94 186.89,128.4 196.88,122.63 206.88,128.4 206.88,139.94 196.88,145.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "186.86,139.91 186.86,128.37 196.85,122.6 206.84,128.37 206.84,139.91 196.85,145.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "186.83,139.87 186.83,128.34 196.82,122.57 206.81,128.34 206.81,139.87 196.82,145.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "186.8,139.84 186.8,128.3 196.79,122.54 206.78,128.3 206.78,139.84 196.79,145.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st109",
    points: "186.76,139.81 186.76,128.27 196.76,122.5 206.75,128.27 206.75,139.81 196.76,145.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st110",
    points: "186.73,139.78 186.73,128.24 196.72,122.47 206.72,128.24 206.72,139.78 196.72,145.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st111",
    points: "186.7,139.75 186.7,128.21 196.69,122.44 206.68,128.21 206.68,139.75 196.69,145.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "186.67,139.71 186.67,128.18 196.66,122.41 206.65,128.18 206.65,139.71 196.66,145.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st113",
    points: "186.64,139.68 186.64,128.14 196.63,122.38 206.62,128.14 206.62,139.68 196.63,145.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st114",
    points: "186.6,139.65 186.6,128.11 196.6,122.34 206.59,128.11 206.59,139.65 196.6,145.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st115",
    points: "186.57,139.62 186.57,128.08 196.56,122.31 206.55,128.08 206.55,139.62 196.56,145.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st116",
    points: "186.54,139.59 186.54,128.05 196.53,122.28 206.52,128.05 206.52,139.59 196.53,145.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st117",
    points: "186.51,139.55 186.51,128.02 196.5,122.25 206.49,128.02 206.49,139.55 196.5,145.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st118",
    points: "186.48,139.52 186.48,127.98 196.47,122.22 206.46,127.98 206.46,139.52 196.47,145.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st119",
    points: "186.44,139.49 186.44,127.95 196.43,122.18 206.43,127.95 206.43,139.49 196.43,145.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st120",
    points: "186.41,139.46 186.41,127.92 196.4,122.15 206.39,127.92 206.39,139.46 196.4,145.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st121",
    points: "186.38,139.43 186.38,127.89 196.37,122.12 206.36,127.89 206.36,139.43 196.37,145.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st122",
    points: "186.35,139.39 186.35,127.86 196.34,122.09 206.33,127.86 206.33,139.39 196.34,145.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "186.31,139.36 186.31,127.82 196.31,122.05 206.3,127.82 206.3,139.36 196.31,145.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st124",
    points: "186.28,139.33 186.28,127.79 196.27,122.02 206.27,127.79 206.27,139.33 196.27,145.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st125",
    points: "186.25,139.3 186.25,127.76 196.24,121.99 206.23,127.76 206.23,139.3 196.24,145.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st126",
    points: "186.22,139.26 186.22,127.73 196.21,121.96 206.2,127.73 206.2,139.26 196.21,145.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st127",
    points: "186.19,139.23 186.19,127.7 196.18,121.93 206.17,127.7 206.17,139.23 196.18,145  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st128",
    points: "186.15,139.2 186.15,127.66 196.15,121.89 206.14,127.66 206.14,139.2 196.15,144.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st129",
    points: "186.12,139.17 186.12,127.63 196.11,121.86 206.11,127.63 206.11,139.17 196.11,144.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st130",
    points: "186.09,139.14 186.09,127.6 196.08,121.83 206.07,127.6 206.07,139.14 196.08,144.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st131",
    points: "186.06,139.1 186.06,127.57 196.05,121.8 206.04,127.57 206.04,139.1 196.05,144.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st132",
    points: "186.03,139.07 186.03,127.54 196.02,121.77 206.01,127.54 206.01,139.07 196.02,144.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st133",
    points: "185.99,139.04 185.99,127.5 195.99,121.73 205.98,127.5 205.98,139.04 195.99,144.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st134",
    points: "185.96,139.01 185.96,127.47 195.95,121.7 205.95,127.47 205.95,139.01 195.95,144.78  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040570069680163099420000012617469002070215828_",
    gradientUnits: "userSpaceOnUse",
    x1: 1723.2732,
    y1: 444.1295,
    x2: 1739.0336,
    y2: 459.8899,
    gradientTransform: "matrix(0 1 1 0 -256.0558 -1597.9138)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3742,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7407,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000040570069680163099420000012617469002070215828_)"
    },
    points: "185.96,139.01 185.96,127.47  195.95,121.7 205.95,127.47 205.95,139.01 195.95,144.78  "
  }), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st136",
    points: "186.17,127.75 186.17,139.13 185.96,139.01 185.96,127.47 195.95,121.7 196.3,121.9  "
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072992008684834517590000006140038899721672873_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.751,
    y1: 7.3843,
    x2: 268.0845,
    y2: 169.3843
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5849,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8,
      fill: "url(#SVGID_00000072992008684834517590000006140038899721672873_)"
    },
    points: "270.19,0  270.19,175.14 0,175.14 0,0  "
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 270,
    height: 175,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQ4AAACvCAYAAAAMhjBaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ bWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdp bj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6 eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDkuMS1jMDAyIDc5LmYz NTRlZmM3MCwgMjAyMy8xMS8wOS0xMjowNTo1MyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRm PSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNj cmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8x LjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6 c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHht cDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDI1LjQgKFdpbmRvd3MpIiB4bXBNTTpJbnN0 YW5jZUlEPSJ4bXAuaWlkOkQyQTIyQUUwRDA3NzExRUU4MDBBQTlCRDZGNTE2NTMwIiB4bXBNTTpE b2N1bWVudElEPSJ4bXAuZGlkOkQyQTIyQUUxRDA3NzExRUU4MDBBQTlCRDZGNTE2NTMwIj4gPHht cE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDJBMjJBREVEMDc3MTFF RTgwMEFBOUJENkY1MTY1MzAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDJBMjJBREZEMDc3 MTFFRTgwMEFBOUJENkY1MTY1MzAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94 OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4KCqwQAAA0gUlEQVR42uydeZccxfG1u5rxzwub EEggFvkPzvH3/yZgsA5IYBYhswmzGGNbeOm3nqJuvdHZmVm51WhmlHFOqRdNR+UScTMyK+PmcDgc dsjbb7+92+/30/XUU08t78dr8Hw/jHL0/3wxv07XN998M3z33XfL31id4/vB6D+6R0D3dI1lHR48 eLB79OiRLc+RLqfsy2V0Hn1G7t275/19SFdIr9U51n9n6p+l11fWuf47T/13tfX/xz/+MenVb1P0 8nu+89VfZe3y/8X2m689fW0e6rPafgvdx2djobKeqWIyToHA/Hl5nR36ly92+q9h77zq/48+29/O 74/+3/6p0e3eawA4fDpNGZd6xC7VN1D3k/e5F41vP+foteVxP1u9Pj2l9UdcA1rTK+ONtUGX3YmN +drT176xtq3ptxrbtZ/3tgCh0cp+v4ZYrpPUjrRWX6ycMd2hUdG+5kYaMb3q9MtS/xK9sbIKVLoc O3hppNGq31L0ppZ1iTgagMYyZZHjZDrNkGKIa2UscZqWoMHr//73v5L67x5X/d2y1oKGOyp28bdx LWjk9Fut3hOdqQaZcGPNIw52xM1wmsNaBOPqbRFpxBC2VK+NuFqAxlb1D+msBY0OHOGIo4Vz5/Zb rt4kW0ipWMaND7GpSgtDbAkaOeUsdcaLWn9fyNsKNDpwxIGj1rlz+i1Hb47Os7WK1VSoldP4HKcV aMSmaaWRxkWvf2g9phVo9DWO9DWOGh9b67dc0EiJwBedsYqVVMg85WjmNCvzr0MpaKSUMxc0YmHk RvUvBo1UoCsta5f4GkeFj632WwlorNmY1XkWeqpSW6GY45QYom0oHhn59oCUgEZofacUNFIAqXH9 q0EjBkYdNNpFHG6/tfCx1qCRWlbvU5WKCk2Lo4o6tjBET6UOzqaxZNDIjYxS9cWAswY0YsBRAhpr 4FkTFXWJA0cNaMT6rTbSSC3ryVSlskIH+zi2pSHGHLIGNGIRR2mk0bL+bqeW1H/N+Lbqqy7HU5XW oBHbWdrKx0I6z3w70CordJh3ezY1ROvkIaArAY2U0TYXNFI6NRc0Suu/Zny+NmjVV12O23cNpGv6 rQVouDYWHVBChl5RoYENUGdnZ00N8b///e/0XUhvKWig91e/+lUz0CDE46qtv9sGJfVPMT702vWt Fn31n//8pyOFI/RbS9DAx9RvrUBD/ZZS1kE5BX/729+WH5o1A/vqyxHZ2xyTf//738OoZ//tt98O 482H5557juQ2gGSYFzGlY+/RtXxv81P47aNHj4bRwKfvZ2BaPnvKmgQaP//8824s7+6nn36a6v27 3/1u2fFZChroIzlIQtvimOrkEtDgt//85z9333///e7HH3/cjW26e/rpp6fvfbkKqcZH/dGHXuSF F15Y5rYpIOwzPspE/QVyXY6FtjU+VtRv2Bh9h7+i75lnnpnavUW/YWd///vfJ52Ah/rRq1PAcf/+ /d2zzz47IRjJZO42cp+jCzjGG+xHBxwePnw4jJXaz9mv0zU65PDb3/72JMnNAxpHSW68jromMBJg uBfl1LTIJrnFnJyOo+FppB9++OFoxKXBfv3rXx9FYCmggU4aPpbYZUEpdSGUcpJhi5HYEcZX1lTj o6xkVf71r3/d/etf/zpaFP/Nb34zgdJJQlPCgpqAuEsagGjxMbXfsFNsjL4bB+bJHmQLDCb0XaqN uf2GXnwB0JA9YAeyBW9ZZeyffvrp9OX//d//7XB0m+IeAA1+ux+Nb/jmm2/24+g1oYEFDV18N1Zs GHUP8/97s2d3c1YtYMElYFi5bPmCDU89aSAuHJEO8D3KYtoy1v9kSuC7hNQa/XM2AsVAAwekjEQD dGxoQw5lJFJSWWPGR/0BS4AII4nt26D+2IENhUPGJyDu2bDlC6Zr/Ub7AvIABq++vmMQATw0zUjt N2yBy7cRks/YAnrd8p3sHFVojOFQCKGaL2QaI4wl1J1vdPDwa0y/4e9pBOm18yjp5N5UJscRheBC 4FBYToMTmoOqsd2i6OJvARDKGnqGDmCUzOVVN7f+GlVoe7g8mEKtbf1FKCu6MJxQX1F/jI4rZVcr fUVZ0Onybti+WouyuqzbLe0c8zH6V84dswXZDjYru431GwMndmYjWd+ahvzR2tcRH4evIDas0gIi 31MJQAPHcSozxPZEIPxGjo5Ofsd7GWvt/FF6uZ9QFcCgzLFG8gEIZdJCL52hzlQdSkUAqforGqJN iTRS8gXcdkUf5bR9RTmpN4CB/hjhi++iP7TQq0FEI2Bfx2gnamfrY1rHYEq5tg3cXrIt+ku2a/sN IMLOYkQ9PvuSLwgPlqnKF1984UtxXxYeNTX4/PPPhxGtlinHPBXZO9MT9/PJ4qidrZgpyT5hanIy VXHeL+EYCIzTxML9lM1figbo2NYjLLpB/6+++moZfXJAw/d0RdeXX345gabVU1J/l4Wsy7bTF+zB HZhr+w7bYprKVUIjccJdE3se7IbSOKK7NuC58ZCzoWorQ6SsI8g1AQ1e//KXvyyhfutwlbK2Ag0b MbUEjS37qsuxPUDd1wI0LNi3Ao1lH1FoA1iISCbhxodctqytOqBFw9vGYhQAiLYYZVqBRigBqhY0 +qau85MSW2jNxrc6OPk2gMWYgRJuPOTswmzhd7EV6xag4S40bjFdaQUaPmazFqDRU+XPT1qChm8X aBN7CE1VYinoKzc+5Bp4bXARc8ZWoGHLuiVwtACNHE6Qc+6rLhnA0QI0Mn032R68UxVfmBMKo1oY +FYRRyvQ2Hq0zenUHDKhC9hXXRKBoxVo2IijpT3sfZtRUhiHItOUIdfAt4w4WoDG1o7TEjTWiI1r wajL+a9x1IBGhu/m2Vko4kjhvAxMUw6WfDiFSCcWObSaK15U0Ejt1NyEttz6Z/ZVl3Na46gFjVzg SCbi9kUcsa3baxFHbpLYWuRwHs64BhpbO04LMqE10tkW1AFdLg5wpIJGDkVmjj2cRBxrTpNw45Mj IVPS27d8qnKRQWOtrKWgkdhXRVQEXR4vcOSCRqvBKRhxlDBFec5GOZhzVpKJb85zjaMENB5HxFHD IRozwFqSoi6PDzhKQKPF4BQFjlymKM+NB5uKf06GOJQ440UBjVBZa0AjlUe0g8blAo7SSKN2cPJd Z76pSmjvglK5beWcGx9yQGPLLcxKP24BGlwiTmktbC2OnSheAhqWLSzSV9nMZl0eH3CUgkYtV+0q cKwxDpFPIQYqZbQGbpwEGpYbg+8gpkFv4VTlaEgkn4a0dF4hJ+IqBQ0Sxd55552p/hCbwJQFR0Gt 0H5QElBGUpZp1xC7dCpooBPAVOo+XB3KGK4BDfp/i632XU4Ff8PORIpUAxrKg8LPsDF7rnENaGAL S3YsBmaPOWDUgqSHCnz33XcTsY72aUDKA7OXSXHdu7SAIZlZvSbiH67dTP8H1eCoc49uMYDtMjNk aSDAjYppFMeRqMOtW7cmQpJU0ADQ7ty5M2Wt0uh0Jo7IBcgBRkq1zxV02/R5lZXyoT/GwBVaCF3j B3ENJsVINGj0aGN7wU4ZSPA77ItLzh/qt9iahrg88AcubPX555+fXlNoJ9dYyBbg4EvDlDUBxg8/ /DDMhDJHbF56PzrUfryO0ugND+mRwBMKEI0IOIxAtLc8pDZFHwABPHhNBQ34RykrFfJtpqKhqAeh +yuvvBIk6JGzABiffPLJ9P90IM4sJiQREYktjO9SIyU60pKnhDZ+WQauNdCgvCJJyl1Pacls1qV8 qgpnimzXZXcT+1YK6Eufyydr7UyDoGw2BTQse57KegQcGmGIBOYRcbA7Qj20gJOzjw6099AC7sQh CmAARmNFpvcWaBydy/cAx6g3Gn3A4zFzJSpyWWW24u+vXbu2u3nz5kkDffzxxxNo8Hd0Gg1sAUPE Oz66QTF6hYzj66+/PkrxT9ktSifbe7rcoSJXKVmMdekG7bSks5RvL/SbeD7ddQ1rF/STKAFdNno3 GqDvxEnqIdk6sS1NX0I6NTBZTtIFbAQcIBTzIRiH5mjAZrr6QMOylS/Rwuzw+3kutAcwRhCaLhcg QqBhpj3L37iAAZkQU6h59Nbfrj4D18hPfW/cuDGtWVDnt956a2ocgEKAoZGfK0W3qNqscdCJ6C1N mxdVmyKdFmxpEvQBTIq0Otnw+YiiARt5rtmF+mqi7ZtZvSwnKc4N34YlHE6xM9m2pfO0A5O4b92y LsDxwQcfTMDhUABqFA+xee2t0+uL8aaTwwMWHJUgELAgEYpeLGjY9+gElIhY0Mlaic2NmfUlb3Kh 3qxf0NifffbZVG8xO4PwoLEaNefUeQGHiISQllwbracP/anJ+QnOzVTV0jim2oWbCCknRxeO7SMc TrVby3kKOGl9JFbW5amKAY2kykQO7jncvXt3uH379nTjDJ3RM2ChNmRBkuighSPyG6YjRAREHZbR mcYLTUtSmbJoz4sOGh0wzk+wWwapkA2kgIZNYNTUBGY691CtHNDQey3CojOlrN5DpytAY4pSQKsx 2jj4SH1SG8i3EESI15opS2zeOoRGV01CkDphC1avLpf3qUktaLgRM9OJWtDw2W5SWUObTgpBw4a+ Q2zRp5RExqPvUEtOoxBNi5wtmLK2YvXqcjmlJWjEyHlqQMOeS7xW1rOIQ5aAxrDi5GWkIQYNPfqG mj349pFUKg9CcupxB40ugYG5FjR8M4Va0IilKpzoditWCRokth3cEbcFaFidrZmychiXUsFoq7J2 uZySE4GugUYJj2jqYeLJZV0LpTJuejBnsCQ5Tu5p84G1mENNglgIYc8LjHJZvbpc/oijFjRy7SwV NHz+EHw8HFsczb2p7yTslqARcPKhBVNW7ip0Lf9BaVm7XG7gaAkaKdPrXP9NLetZbA5WChprwJEL GqmsVqWOaM/YbJl6vAWrV5fLO1VpBRol/pA76K+VNQgcNTdNBaNc0AjoPKRSFtY2fg5T1lasXl0u b8ThHhJWCxqpNpbqv9Yf1srqBY7K6cnhl7dDNs9ESor3FkxZrUlOanXGytrlagFHCWjk+EMuaKSW NXp2bMmahvl8iDVKCddlgIxkqHXELZiytmL16nI1nqq0AI01nbmgkUX6Y52nBWh89tlnw7yHfhBq 1YKGTp1npxx751s5IrkqvNoU9hZMWVzulvXasvaM1au1j6MWNFrNFFIoJ31lXaYq7E+H6IN8jRLQ 4Pd3796dtm7/4Q9/mNJ7ydTD0V988cUi0CDZBl4MksXefPPNhc0KELl+/frknCWOSFn/9Kc/LYQ/ 6KTeytsoBQ3qapmbyIVhS7Bl4Motq8hTOjfG5RYlj7UADexUW83RqxSHWtAQy1tSWeUsZIji7MiN GzeGmexmMJu7lkxVcWTwEWKe9957b0+26u9//3v07X/66adh5umYXkmBf/rpp4dr164dsYR5yMKW L4hc7t+/P1AWfgdHiMh/RiefMm/Rf/PmTS85ss8RiVzefffdKZOQepOjIpIeQJMkOvF05oAGDb5G pmNBKQU0RJ7SIn2+y+MT+pABFBsTlWMoEk8h1FHmKjqxDSgnkZTBKQQaopzEP0ijxw9I9oyWVQbN yM7oy2ecFEcaIwUR8pyABmnu42/2Dx48GMZoYKL8g4XrF984JukhHR6A4TcAwdiIIYbB/RgNDB99 9BHsYsOtW7cGSHosbaFNx6ccpBS/9NJLAiVvY9HYH3744QSO1E8p9HSm0ufFcaCUeneaEaJSAzRy ooEUVi8BUZfLK5bZy1JDYne+wWkNNDRNJ9FTKfRKrxetZWxwCi2EohPQIBvWLgNQVssDfKJPNxtH 96NNVRgvkQNMWSMCHYEGYDGCxvDyyy/v52hg4uCIkPQsvydSGP9vP/6WqGZBDH5P5ALfxuuvvw7n 6aDIJcJANl0gJQDzxhtvHHF2itVrBKLJyamrSwMYSp8HPAQmluDETktKowF1uA/gcmgAu1xMYTDD wRGfbWF7opxci2oZlGZfnPRqCuEj+sG2NX1fAw1FLkQYMaIpDa4nUyAZ6QgGJ7sxNaIzRbh9+/bk 9EQDTBFee+01HHvvUgEGSHqOSHkgK4a96/r16wPRwgcffDB89dVX3GPiMIVicDeTGK+BhvZw8Pes fdAhgB0Ncu/evakDaXxNSxRRrGXC6nGywEMdImakFiJWJ01LOmBcbsG5sUGxZcU2UYnVTQOXS99n pyVEA+he2yUqe7WsXi6IiJMU/6CsPnBLGkhlrCxAerZxD/NIOHz55ZfTVAQAAUiYzrgMYLOD783v vaxe+19QaZqGfPrpp8MLL7zA1GgPMJnIJRU03LJO5CYQ/9BIlvRVJD1qgNTNMz1XpMvaOgYL7jbU T02atA4uENG0hEFbbPgpoGHtVjYugBLFIABEWRW5pICGzTtbImUBB+eHuMBhF0fh18CpR6ecgMMy k3umJ17+UJdykMiCRVVABCAyoJMDGoO7nwPgELkqSLk2LUl5pGUXOLt00YLkw4cPTwimUkHD9wQE wW4tG34uaPhsF6AgwkB3qJwx0EjaOepbmaUSenSZSEhyshXcp1ePgVuSnNCRNBSUgCLpyeUODZAT dW/psghTiJagoSmKHcRrQUO2SzlbgUaQASzGh5Hg4EdThwzikKEQNA6+xSA96SghHA4xI3Xp4i5y twINH81DC9BI4e7IBY2TnaO5ufotKAZNpQ6Fkcbg467Ioe3LITnp0sWx22agkUPzkAoaa8RSRaDh RhwpRDIrN8WJD1sQh+TsuIs1VC3JSZcuLnC0AA1ruy1Bw16tQOMo4khhykpA2INdpEwlvbkszEhd urjA0RI0UmgeckEjhzw7FTSCSW5rKbet2cJagobvjM3WJEVduvicsRY01oCjBDRSB/0c0AhGHLHo IAE0DiXEIRWgcQilHLcGuC5dSoEj57T5lqCRMnXPBY0TBrBSxiHn+yHXEXNIb1L29meUNRngOnh0 KQWOHNAIPYAoBY3Q+Ss1oHEScZRQ99VyeIQQ9iIyI3XpkgsctfSYLUAjVNZS0DiKOFIq5FaqBWhI JztTC0FjCDFwhfSUMiN16ZIDHLX0mC1AIwQcNaDhXRwN3VTMVimHTut1jS1MBzOzN99dGymNNNDF FWLfqmFG6tIlFThKQcM+LGgFGm5Za0HjJOLw3ZQdmGxVZXstuzBJklHSWOjQaRsJ+EADjgL4Mdhu fu3ateVk7Bs3bpSAxkHpsfBtkNz2yiuvLIdJ5x7Z6ANMAK4T6nRxpSVopBzXURppWIawFqBxxMfB KG3D/9lhBpybLFYlnHHBJ4qMjr6fWb72ltnLgMbesIVNSXIff/zxMDr3lD7/zDPPDCMITZdIfJ57 7rnpsolsAbaw5T7ffPPNMALRxB0CqLEvf0LFs7OJISmF1cu3pkG+i+jUunSRMJCQuUoOFCQ6a2CR Emlga2TEIkqp90X4OaDBoI//atCHmCe0XSEH3Bj4F+BgRDWVGMjOmxm9dr4sVTJk4eOAxm8c4V1G r71DMTjxbdy7d2/SM1ZgD5UgrGEACODD99AOkjELgQ9EP+iOgQbABmAADLCViU7NRWoaDUKSEKuX Cxri+exJbV2sMIjghOKqlS3ZCNznmDFHFD+Gj0UO+wtRAsZ08zuyw236vC6AjrLaiCkVNPAJcAE/ W4CDAorujJF/XncY5vlWKK19D8gAIDjuTN93BBpwbNy9e3eA8AcmMQAD6kABBrSCogGkLryi8+HD hxND2Mx/egQYilzgMr1169YUGaF/bRcfACKaQF+DlVABdrn6gj2I1Sv0WNPSTqY4o5i9UqfAqU9P iIa+/vprL/GPPquslt0/BhgiCAeIFg5SAQeAwQ1njsQlw3W+WYgTYz87/Z7pDNwar7766p6pB87/ /vvvM9VZAIPviTJGwNgLMAQwFjh0AQZjmSD5IaqZ/hbaQqIXPguYDLglPVcX85ZYvURy0tcxuriC XwAadtFyzbY0QIWcG1srOe7C3t9HmI3/hoh/QmAnNrxQWQFL9BJtHEXsAo633nrL3sB1xihwKMoY HW/PegOPVj///PNpqsE6Bq9cRA4ABoQ9DmCcgIYudAFKTF+YOgFC6OS9WM9tmXMOelZ9xUfapYtd x8BhRKaTm8wmuknrlKKdrLE1rd2JB5fyMX2yZc1NZrM0hnZaAisgkYtPx5kPzXIayS3Aa6+9tjxm FdmpCqXK5jYUdO3MI5mfgaiETCWd6S4G0eB05ksvvdQ9pcsyLcFh4Pqs4drQWplY9VsNTlo4RR8X bHcxysKU3aJ6OCKSLvwCZrNYlHVmHwHVgIbJG2E6shunLEuFtKZQI5QJAGFxpgVo6JWGZ7VZC0Zd nmzRcQEtWb22OIVPZ6HUgoavrJruROtuI45K0BDv50GRgl2ASQHT1HleK9Cwj5f6gmiXmkE0hbBq C2kFGjb6SKp7aKpS4oiKOLZuqBag4XZqX+PoYp9etCTo2bqsrUAjJbP8BDgagMayk/O8RoMGZe2e 0iXJGWtZvbYqa0vQSKG5iJIV1zjieYVmDpv6hSxrl8s/VWnF6nUe/lALGpsAR6ojmoY6bDUaXAaA 63L5pyotWb0ex7QqFzSaA0cOaJg1jmFrhG1Q1u4pXbJtrJSg5zzX/EpAY40EKws4ch1xy4gjUM6h QVm7dCmKah/n4BRaxCwFjWYRR4kjmoY6r4jj0EGjy+OIai+CnbUEjZyI4yylABmgMcyRRklrDYWd OpQCXAePLrkRRw1Bz9ZlrQUNG3HYlH5vG/gcsiLSKAWNpKnNnLHbLCpi626XLqkRRy1Bz5ZlbQEa KRHHyaHTLtlNqSOSq8+WVZv3XytiIRN7GGXhoOrSslLOjz/+eGILIwemSxfriPKFFqCxZcZ1a9BQ Wckrc3k8XL1ndjQnxVYFymkgbkhiG8lno2MfyKrlxgAHeSDqiJKpCoBBarPtVHSTDXj9+vUpiS6n rNALAhosKnGaPcDB+y5dZGPYhJK+aqYn5JIoG5ackpb5UPIJ8rcoZ6isKaBB+SgryW34Max5+JWA xFt3bbX+5JNPJqek0WY6QOWe7EKcfTB2QSM4Asb+xx9/nNLgSZl30+/h4BCb1y6cQn/CxQEbGLwe vpR+/gYCH8r86quvDqas3oso6O7du1MDKduWxgEsdaJ9P5W+y9HceSbozmX1ghtDgEGEjJPzPbaG 7SUOpF5BH/wgymRV8ieg5JY1dZaAb6BTSwHi6WDQ5/1C3mPrLuC4f//+cjOAY06FH2bi1GOSz5ml a7zhxL8xVmJv6AX3Pkfn/2D9go8jABzT97B7jcg38W+EmMf0vdjAIBsZo4fhxRdf9FKzvffee1M0 RAMzhRLVm1L9+2ltXXIWImORt0h6eAUwfFSW2J4i5VRBJ5nh6PXt3cCWsWvZcwplISCEXzCYhjaS UVaXmPwIOB48eHCyNwInn9myJmeVo0LZBzPXGG0IJPbGyfcR4p9Jz6jzhMgH8CHCgNFrjlyioCHg 0FMVykRDwHAOQPDdBx98MHEr0EmgpwBD/CAdMLrkTmN8DFyWQU4j+MykFyX6kR2ure8xhRBt4Voe jdjH+Bvx37g0gEyboAIE2Na2rOsSU5iinAU4cDDPI86FAQwQATTgAoV9y0YXzvQkChyiC7O0gTB8 eSKXJNCwZRQ3InWCZ4OGE2BoWmLZk7p0KRFRT2qhXcQ6AAZrckhqvot1cFeYPljawpzkO3SKhUxT I8op7tCU0+tjer37OHxhGaENNwSlEvkKDi6dn08vTv7ll1+u6oscsHQQ0NFIRBwgKiCCbgGGnZZ0 6VIj+IIWDrEzogH8IkTdt8YUZhc2ERYov/rqqyPawly9YkgHLOy0xOUOTdVr/RW9Z7FHO25qcCK9 4MGJBIJ6tQBVARreFV+AAvZznYnS1zG6bLVwSqSudYdarhj4PcVKV+LcIb1ILWi4AHJyWn3IGXXu SksGLt/csQA0Bp9erWJ36bKltAIN+Vhr0OA1h8Q4eYNlaNU45IwJNxxyGbhCLOW5kUbfSt7lcT1p aUVlqcXL1gN0zLdKElz3oalK6Hl1wg0PuQxcldOTg3tQTZcuj+NJSysqywxfSz4DtiVoeE+rDx01 5yLsWsSRQ6bTKtLo6xhdzlu2oLLMIRJaAw3Xd1uAxslp9WvOuBUDl11ULQCNofOIdnncU5WW/Let Io3Yg42acp6k1aecT7kBxWBtpLE8ju1rHF0ex1SltU/UOnlpFJMKGt7F0RBopCBsKW1fi+lJB40u FxE4Snwi5AMloJE66OeAhvdxbGxKkZKnr7NVcrII7VOVAtDo0UaXCzlVqRlIW4KGdIbIeXJB4yTi iEUasYaqpBisjTQOHTS6XLSIo8YnWoNGre/6MOEsNFVxHw2FKuTceLBUfqnMSOax6lA6PbHl7aey dXmcwFE7kOY6eQw0rO+65S0FjeBUxXVCEm3YskpmKQljbFLx5f3nMCOx445L+SQ6mLcGNHQQbz8H tst5SGsqS9cHWoCGfFhkVS1A4+RxrIt8JMaQbKPTu0m+wdnJOGU7t4fgw/uEw+UsUBIa+sgo5HtY h9ApUMoBDTEsbXEqeJfLL9gcNgwXSyvB5khuIxsWf7BMdCWgce/evYkGgmRMeGWUfVsDGhr0Scsn 1Z5BX9F4KWjwe/z2BDgQwAHSEG7qe+LBD8m6oyCeGx98C5aiJ6MTcXAqI15D/p8O4DMdMJMHJTWQ IpcuXVxR5irJY9gPgwtcLWscGGvCgIpebBpdpKrjmGRm54IGmeHvvPPOpBN/AtzwBbGFxdjHYmsa 1BkfFi+ISIY06LvLEykPR/i9Uv0XPg4aGeVMScaGGObEmME88fBde0h+xoLs4etYSDYctrDxhhOX x6h/IuoZG2Yf4NyYVMAUNnbEMOscPGonfbCQzdMSEQJ16TIJjs1lR1cNgDiOWK1yhIEPnTiQu8+C QQ8nhccWLtw10CDSfvfddyfuXEAHkGDQdOks9dnNTg2BBuV4+PDhpB/x7QexbGEpoMFAT70BSCX1 LcABYIBQc4LNMDf0YLaRBx2df3ByQGS89ta5AY3xHhNgGHav/Yo+MYUN0isGshEoJsAAhAxYdODo sjg3Bp7CZSFipzWxrF6xzVmKxinDyy+/fBQxWF6bO3fuTBy/fLZEU6KzFDudyxZmuXF9SwBE8fhw Ki8I91Eb+OgGNcUDG1wGsqXV4BxNJOjxNhgAJGZohUZax+DGuSQn0okeLe6o4R3pgPGEi2wPx7H8 mWu2zG/4bYiBS2sEYvVKsV/W6gADMW3dvn17Wa8ALAANRm1x3wowRCMYOtJRa4P8DX9rfQRQI3LJ zaoV5SG+aak0tWZI+UMMZAtw1ICGg1aHeVoyVSZGhJrKOoRgFDS25yiDQwePJ/vJBo7jMtOt2ZwN yxV1y9b4zBoBNmcjlxw6wJs3b06RCgMywpEclBGg0LEcAIals0zxBcqjqRLv8bEMVr6kQZ/ogoci +HBI7wkDWGWCjdY1qNyBIw4y9Eb3cNA4ID/MXs7o0EHjCY40OCcnNJdfAw33MzaGA+HwAEeJM1rd AMNrr722++Mf/zgBA4eI+Y7lWNPtY+DCyXX0QsNBf6o/0VIMNE6Ao0FW3vQ4duZjHDIrc3C3nbuL NUx7uPrpa12stAAN2RiOiMPXgobVq6c54sUFMET6W8ue1wo03Cz4Vb2xxi/cTnuwj3pKpie+VzvK dOniM/Aa0AixZdWChiUk1hklobWMXJ2tGch8u0uDet2pSiVoDCHUqgGNlTyUjiRPsLQEDRc4WoDG Vjrt49PWDGRJZc0BjoTKHIQcOSQnqedzhgae7j4dOFqARsmgl0rQ05r0x8ksb85Atqo3FTgSKzO4 U5WNQaNHHE/4VKUlaORS99XQY9byYmwJRkl6U4AjYw9+dsSRcxJ4ly6+iKMFaOQ6Yy6rVyv2vK2Y vbJBbg04ChJ3DrkN1UGjS8snKiWgkeM4paxerUGjNZVnVlljwFEAGkNqxJEDGivA0VGlT1WqQUP6 Gkbf1eQ8qcxercuaxPQXAo7CFOGDcfJDK9DoT1W6pD5VqQWNVEDKTZtvzcCV7OANGciszqRDp3Oc WyQ64h3NAI2hADS6dOBoAhpr/JxbsHrVkOk0ninkl1V/bA9mLr0pO+TY507uAMkx7PJsEWmwrZgr ACAdVZ5Qsc7dAjTYws3A5zJ7bcHqVcvAVUM8HCqrS/IT07lEHDSYWL1i5CG+i8YBNGwm4VNPPXUg 9R2ikhs3biz8BxG9JwRAZOfdvXt32jdPYhA6AlOVDh5PoGCz2JsyTEtBA8B47733JjuDfUs8Hi+9 9FI1qxeHSNuEtlTKzRBo6GxZykx5Sfwkt8aNFHLLig4SUsnRoT2VmR7SuQAHPyDrTgQfKTdVJeg8 m0ko8h/0sC+fTDsqSKfweU0vkQodSeRCmjJl4qLha9mbulx+EfcExo5dYS84OwOU5atYAw0GPLJW v/jii92bb745/T8Oid1iZ9gtKfLXrl3LZvViwKMskPpgu8pP4TLT+aw1DXyNulpCHT7jI+gtHfTR RfsphV50iDYn7ESnwhPSf4UssG/NFR1mHgwvq9fYyPsxKuD9QugTYPaaSH3Ggg1j5DDcvHnzlNJr GPb8zSeffDKMZRmeffbZYSz8MKLfdM0kQYPJwO1EPk9ghMFgIipADVICC/4PICFSWAONBw8eTDbP 3xLN8ls3hZ5LXLZkZVvOitCAB6sXIzdJbe6ApwHZOmMKaACQlAOwxKl9m964B/eKHTztDvoAhugD ND1zk9toTw32RzoFHDSkm+I+M3DtLAMX7FtjJQboBcfGFlDsxdrlMnnZCxkbdxgbdg+AcEnG+wMa E5MYgDE2wgQYgJi9vwEJH3h0uaJrGRg4mat2Du7u4eCzaO4Y6d1IAWH6+9FHH01TBzhCFWnHtq7z WzFgvfHGG95R+8MPP5wiF0Z/nM0S9NgI3vdI2UfhJ/IeyoZjr9Vd3wmkBHwhnl4xe6Xw5VA+ZQyr rAtwfP755+75KJYjY3JcaPvGSkwXdICGAtACyC4EHAKP8bf7sSEmfQAEEcYIRnuiDD5zzVHPAkYB wOgRxxUHDAybENpdsIzlUoj8mt/Ch8FIzBTkz3/+8/Td66+/PjmlHb1Ttq6LZQxQ0voHrF5cAIXC e0vQI+ddE/5OEY2YuSgfzp1T94Xab763QIQyKHIR4XBuSr50TuAh4GBeZgl5BBj6DFAwLQE0THSh SGMf4g51QUP/L07ScR4JeTFgsSfCGBt9ijBEVByJMjpwXGHAwMhzqQDdJwBiyEJYryBawJEYvX2P HFN2oSr6IFIRJablDbUjfi4Zsu5DnS1DeW6av1s3sYVRb9p0jaQnaW+IgIMGNv8x2MhjjhIm4GCd wk5JLIDEgMOAxvz2lyiCJy8whQEiEB0H1jFSwaPLFQANFv9yqQBDjw3FSk4UgF5G7xYcHjwtASAY wS2jl7uOUSKcrxKaipVsMRd3KmDkW8coyndx0W6N4CPhpkPOKVRcCvNo/NTQznkc2+UKSSvQ0DoB aw9a5GxF/MPIjcBmrgOZNNWolZagYRdDm4HG2s5R32p0S0ISy+Y1lG8P7ZHGFZJcVq81G9OUJbag WJLvgjClwIZ1wFEraQkavGo/Rks6xBPgWHsG3JoZyYkcSkCgbwC7YtIKNNZyRVqwhW1xTnFL0NiC DtF76HQlM9Ig0uHUDu2RQ5dSx1mzsVC03Ao0tq5/C9BoPeifZMc2IjmxoHFIJQ6pXKvogHPFpiqt QSMVjHIpBrcEjlagYX23FWhEI47QTraEmx7M05NU0OjSJdlxUkHDN1VpSfyzlbQEjVzO0xTQ8D5V iTVQKjnPObN69acqV0xagkYKAe9FAg3fGk8r4p9WoHHCALZGcrIVcUhtdNtd7WpOVVqARg6RzkUA jTXgqMmsbQUaJxFHLPU4tfHPGTS6PAFPVWpBI0VnKVvYeQLHebOFxdr1BDhizEilLEaxUaBLlzXH KQWNmO3WEv9cNOBcYwvLHfTX2vXMt8bhNhC77rjYUqsNJZGbDqnMSGwF7nI5hf5je/XWU5Ua0Ajp bcEWtiV4tGYLyx30U9r15KmKvaFYgeAqYM8/wEGqMjvltPElF/2VKjwfTN1qcbSHLucIGOQ9MJCQ /4E9sOjYUj8JZKSm28XMEtAQgxx6yNNgSzh6a0BD5D8kzZFl27pt8Te2r/O+li0MQZ8O0rZbz2tA Ax1LkpsceVZOmjuAMcysQDYjdhiBY+LM2P/ykHjJdtWLh6RnIf+BzwO82Z0mqvm+60luF0REoiNe CnuJf6LVKMy9yC9hgIJkJxc0yCqFHwPggFCH8vGKjQNKN2/ePGGiSwENeG/v3LkzOTVlI0cFXaTY 14Inzk0avfZbPP/88xPQiVs0FzQY9JU+L7CgvLTF5PgZT2MszyltS7LgCXDMPADDnEl4xMfhZryO KLaHM8NmyfpAA7DgIsN2BST2HTgunmDQk7FEFtgwdiV6NQkjR7sEpHAo+C8w+jXQsFSAjLBKPlO5 uJRqz3sS1FJAAwB6//33p8Q2sWLZNHpAiO/EKZojOKJoN93HxegVlWcqW5h4WB8+fDiBh9tHXGIl szOGtQVmcIF2ECXBAhwiQCWkg6VLvKHzDYcAMc+EFWMFJ+DgIjVegDFHLhYwtgCO3a7zcWwiUOGJ SCZ116H4OltkiWpAoww4AaQ8lsbOZcKHUIdyirZPhDqWzEagJFuHp5TR3Qca1B/AIIWe70QF6Euj V91F4LMmckSxj8Xal/tIbwg8qRPlpU4A7lqinC2r5Wn1gTFgARBZcFuA49NPP13oyWagUKSxC7F5 CTiYngg4EICEaAWujQyA6FOVCyI4KRGGuD1zTkR3DbWV4GA4BYZ++/btxbCZPrGOwcCnUNwS6sT4 MURug6NB8gMoKMwHhKAYFN+GAMPSAcao9hQl+O5JPVze1JQ2VdRkuU/VXzi2yIZTsmuX9PgZ6G2Z tRYCuBKd6ZiTozUnAcfbb799xFBuIo0ocIiVx5L1QA244ug94rjA0xKxZpWChjsqWvqE2umLRlXW FZiS2HUMRRkWMFKmDoyq6FQoz7EGgIkWUwUYLrvXWv1dbhkcWzweuaBhdQpEeEUnC7Uh6oAYaPjA Hr2KhihrMGKxT1Vy8/VDj2NbGUqX8xc9Im8FGi2BQ9MFnmYQaTCNYXFS6xg2EshZa+A3EBcTXcB8 bo8HcAEjxy9UZuoPp69LBZgLGhYIATuiQhw8Rt6cAhq2n2gDiMt5jeldgKMRaCzEKecoPdJo2ZiZ 6ddrR3xuIejlMTDOTQSikTI0PUgVAIJ1FMATPXa6k5tZav1DDx5qQcMlwbKnudWAhgseMT36fELk 04o4pMvlBY5WoLG1LeDQTFN0EFErUGJ6onYojQrsdxaQW4DGWsZvCWhYkE8Bo+BUpWK/fN+QdYml BDAeF+GNBbst2qAFaLgMXC1AQ1G9D+RLQcPNa1l9KuObqlRmwJ43aHSg2mCq0gI0XF7ZqzpVi4FG iOi7NR1gLWjEEgJ9es9SR5rUZDaYv87ZkTtoPEbgSCGRuWzSEjRyiXRK6ABbgIYF+SQwSgGODNAY Olv5kwMcKduWn6T6x9pgC9CIRUe5oJHKlnbCOdoANOwaR+mUo8slcZycXIeruM6TCho5wJEDGrGF 7BrQiE2rrN7oVKUANB7HlKOvcZwzcOQmSF31+qcA5xa0m2up8qUgr2lLTG8QOApB48Dm0e5+Vxc4 rjJolNQ/NdryOWMtGdYaOVFpf6WQHkVPcsuNNObctvM+WKlHG+fkOKVGeFWmKqWRRqxdaxn0WoOG 6q/XEIgET3IrAI1pfePnn3/uEcclFjZV6cjAFkZIAtZVAM5S0LDhf+kAHdPdOtKwbRCNPNRgogUs BQ02pJDx9+jRowP73Au2nUeHJvbmB1jDnqhFVdp1K2ek38SrYe2hxAgpI/bAK3pbtwG6W6c2YGNi Nouxj6WChpLyKKvNaq0FDcpJEp62xbcADVtWHf4eA7kj4gAxDrlhytpCKPRk4hD9/vvvIe2ZdMFz UHsgL8ZBI4l5ii3G5Cg8iVvbaQOSu6g7zv3cc881oe2j/8iyBJjpN/JAAA50azt3qhGiQwMHekVS gx1QXvTWCMYtViuSxrAHHL2FjeE0CPooq83dyF3TwBdERIQ/EMlht+hWm5bQblJnEttoW7F6cWkn aS5oUJbZb5e0fPqI+ov4yAtyAgqYk9ijP3MTLun02g1qqAEXKsCxQfbQAY7K999+++1+zttf0uxF Mzjqnbg6dplp9TCRAUS7mbpQ19gJk050754APg6MBGPxsUSZPisaYXFsGaHd9INOskPdEDtkhDJA dHJZkpqY3lRBF2X1Ed9YpqxcIRMW5/YtXIqHIxU4EZxbBEhuNqzS4dHJaw5/KjrJhmXgcDdnidVL AJoKGgK3me3vpF0Be+XtnJTTEvkYCrhhzjQc5goegQYkPQAGvBtjZw7jzRfOURc4RDuIk0MzOINO FDhGQ4a6cJipCwdXlwWQOay8knwcSp32Ean4aPtSHUcENtYIQzsFxW9hiV/cqFPRZqpe3ivzdA3w 0CknXMv3ECtXCohSXtpW07MYIRF6Fb6HHBHAILIQAxeSyuolvb5LpEqWOzS4DXzURX9ZnaGyEl1R VjtoxNrVTl+8T1WERBRSpB4yFr7T/3HjwCg42AOo9X8YFyAlXoPYCMgo4KuE+50MIMa4dFnXMXBA jCX1AGbbZ7F2wKjpN9+Cmu8e9Al6NcVQ2M19xFgvftBUvaKkkz2Eog+NsKmZpZomxWzMZeBa217u ltWyb9njQ+gv+UOKXv5OUzqXeEhrhvQ/beCL3Hw65Q9Wp49ekHIK3FLbFYCRzuk19AhKjoxChZ8y HBiiRPQRueFgEUqvWtCyHatGMtSFSUZtiYOoXC6By0UUHIWOTe3UUJ+5zqhQNzTCrgGTFqb5jA1o gVaMXHzO1avQ3j51kE5sTH2aS/ngszGEdqV9db/cnBQtTMsx5YgwcMWIb2IXOgTOGgDRhU7fAJqi Wzp5VVkVuTEwl7SrwI7fond1A5h1RBqdDo3ccHAjjdCjIrvyzDQphtQrhwUfFOVYnZdRYF4C2Vux RPn6rQQ0rKNbgecSsG+ll+8wbIColpHOtQfW8KzDlHCOuOs5Ygwr7S9Xr46gwA58A2huG+hpiYBI DxhKynuSmZuzAUwLKImgcUhhHFLEUQgaUb2XcRG0JUuUXYOodW5f+8YYunP1ytB9tlACGm4btAAN X/TcAjR87Hm1oJFiA7mgEU1yK2EcMmsadgFlSCUPaQkaW9HVnYdsARrqt1agUdNvMdCwc/GWoKGy tgYNd7NYK72p5Dw5/eXrqxrQOEmrX7v5Gq3c2vRkpVOHFqBxmdc4WrNExbZQ14BGLOOzFjRqHCb0 aLNkTWPt6Enbti1Bw23XVlSeuTrX9O59W21jm0hagoZTqUMhaAwhvZcROFqyRIXyJGpAw12TaAUa dnBqBRrWcVqCRig6asVj0hI0SqkL1/QGc1VSDLAGNHIYh3JPGL8KU5VWBpMTUuecDJ8ziqWARq4z 5oBGKDqqAY2WelOngKWn2KfMFnL1nvmmKrHDbFdAYyihlXMf32aCxkGbWS/7GkdrligXOFqCRuoo lgMascGpBDRKHTwl0kgta0kOSUvQ2IqB7GSqsrb9dSXSOGjKUcA4dCiMNIarQFmX2rmlhC+tQKNW b8pW6FagUUPdV+IPLUAjpaw5oLEVA9k+FHGs5f9HpidDLuOQb3E0d3pyFc502QI01kbGUtBYK28J aOSUNZe2sDVo1OptAZw5YNSagezMF3GsAcfKmsbBt2AZ6wC7Rb0WNK7CU5VWhC9rwFECGmsUczWR RsxxSkCjZBTPqf9WNIutQSPWV6W2dRJxrDVUwkLoUMI4VBFpHHzEKVcJOGq4G0IGXgsaOXpzHDyF RzMXNFJBuaRtW4NGDVNYKNKo1eu7/p8AAwAiWMA4j/doVAAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 0.0947 0.0704)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines10);
export default __webpack_public_path__ + "static/media/lines_10.57e61265eeaeae889653589f329141ca.svg";
export { ForwardRef as ReactComponent };